// English, the reference: every other language must have exactly these keys (checked by TypeScript).
// {name} placeholders are filled in by t(); keys ending in .one/.other are plural forms (tp()).

export const en = {
  'app.name': 'DoCuLat',
  'app.tagline': 'Files, sharing and customers of your company in one place.',
  'common.cancel': 'Cancel',
  'common.close': 'Close',
  'common.undo': 'Undo',
  'common.undone': 'Undone',
  'crm.detached': 'Unlinked: {name}',
  'crm.teams': 'Teams',
  'crm.addTeam': 'Add a team',
  'crm.removeTeam': 'Remove team {name}',
  'crm.teamRemoved': 'Team removed: {name}',
  'crm.teamOther': 'Another team',
  'crm.myTeams': 'My teams',
  'crm.bulkAddTeam': 'Add a team to the selected',
  'crm.bulkRemoveTeam': 'Remove a team from the selected',
  'crm.bulkTeamAdded': '“{name}” added to {count}.',
  'crm.bulkTeamRemoved': '“{name}” removed from {count}.',
  'crm.teamReadOnly': 'You only read in this team. A team admin or member puts it on records.',
  'crm.lastTeam': 'A record keeps at least one team. Add another before removing this one.',
  'crm.lastTeamHint': 'Its only team. Add another to remove it.',
  'crm.bulkTeamKept': 'Kept where it is the only team: {count}.',
  'files.teamsHere': 'Teams here',
  'files.teamFromFolder': 'from folder {name}',
  'files.teamsOf': 'Teams of {name}',
  'files.teamsInherited': 'From folders above',
  'files.teamsInheritedHint': 'Change these on the folder they come from.',
  'files.teamsOwnFolder': 'This folder and everything in it',
  'files.teamsOwnFile': 'This file only',
  'files.noOwnTeams': 'None of its own',
  'files.changeTeams': 'Change teams',
  'files.tagsHere': 'Tags here',
  'files.tagsInherited': 'Tags from folders above',
  'files.tagsInheritedHint': 'Take these off on the folder they come from.',
  'files.tagsOwn': 'Its own tags',
  'files.tagsOf': 'Tags of {name}',
  'files.tagsMenu': 'Tags…',
  'files.selectItem': 'Select {name}',
  'files.selectItems': 'Select',
  'files.selectDone': 'Done',
  'files.teamInheritedError': 'The team comes from a folder above. Change it on that folder.',
  'crm.tagRemoved': 'Tag removed: {name}',
  'notifications.markedRead.one': '{count} notification marked as read',
  'notifications.markedRead.other': '{count} notifications marked as read',
  'field.required': 'Fill this in.',
  'field.email': 'Enter an e-mail address, like name@example.com.',
  'field.url': 'Enter a web address, like https://example.com.',
  'field.format': 'This is not in the right format.',
  'field.tooLong': 'At most {max} characters.',
  'field.tooShort': 'At least {min} characters.',
  'field.min': 'At least {min}.',
  'field.max': 'At most {max}.',
  'field.number': 'Enter a number.',
  'field.requiredNote': 'Fields marked * are required.',
  'dates.openCalendar': 'Open the calendar',
  'dates.chooseDate': 'Choose a date',
  'dates.chooseDates': 'Choose the dates',
  'dates.chooseDay': 'Choose the day',
  'dates.noDate': 'No date chosen',
  'dates.ok': 'OK',
  'dates.d': 'dd',
  'dates.m': 'mm',
  'dates.y': 'yyyy',
  'dates.notADate': 'Not a date: write it as {pattern}.',
  'dates.notADay': 'Not a day of the year: write it as {pattern}.',
  'dates.notBefore': 'Not before {date}.',
  'dates.notAfter': 'Not after {date}.',
  'dates.endBeforeStart': 'The end comes before the start.',
  'dates.time': 'Time',
  'dates.hours': 'hours',
  'dates.minutes': 'minutes',
  'dates.hh': 'hh',
  'dates.mm': 'mm',
  'dates.notATime': 'Not a time.',
  'dates.am': 'AM',
  'dates.pm': 'PM',
  'panes.divider': 'Width of the list',
  'panes.showList': 'Show the list beside it',
  'panes.fullWidth': 'Full width',
  'panes.openPage': 'Open as a page',
  'appearance.title': 'Appearance',
  'appearance.hint': 'Your colours: everybody in the company sees buttons, links, selected items and lines in them, in light and dark, and always readable. Each person\'s choice of light or dark still applies.',
  'appearance.colour': 'Main colour',
  'appearance.notAColour': 'Write a colour as # and six digits, like #2f5bd3.',
  'appearance.combo.blue': 'Blue',
  'appearance.combo.teal': 'Teal',
  'appearance.combo.amber': 'Amber',
  'appearance.combo.orange': 'Orange',
  'appearance.combo.raspberry': 'Raspberry',
  'appearance.combo.slate': 'Slate',
  'appearance.darker': 'This colour is light: buttons and links show it darker, so their text stays readable.',
  'appearance.lighter': 'This colour is very dark: buttons and links show it lighter, so they stand out from the text.',
  'appearance.preview': 'Preview',
  'appearance.light': 'Light',
  'appearance.dark': 'Dark',
  'appearance.noPreview': 'Choose colours to see them here.',
  'appearance.save': 'Use these colours',
  'appearance.useDoCuLat': 'Use DoCuLat\'s colours',
  'appearance.saved': 'Saved: everybody in the company sees the new colours.',
  'appearance.reset': 'DoCuLat\'s colours are back.',
  'appearance.sampleTitle': 'Summer timber supply',
  'appearance.sampleText': 'Baltic Timber · €12,500',
  'appearance.sampleChip': 'Retail',
  'appearance.sampleChip2': 'Wholesale',
  'appearance.sampleError': 'Fill this in.',
  'appearance.sampleTonal': 'Add a task',
  'appearance.combinations': 'Ready-made combinations',
  'appearance.combinationsHint': 'Each is a main colour for buttons and links, a second colour for the focus ring and secondary actions, and an accent for badges, chosen to go together.',
  'appearance.group.professional': 'Professional',
  'appearance.group.neutral': 'Neutral',
  'appearance.group.tranquil': 'Tranquil',
  'appearance.group.vibrant': 'Vibrant',
  'appearance.group.playful': 'Playful',
  'appearance.group.warm': 'Warm',
  'appearance.combo.forest': 'Forest',
  'appearance.combo.plum': 'Plum',
  'appearance.combo.graphite': 'Graphite',
  'appearance.combo.stone': 'Stone',
  'appearance.combo.sand': 'Sand',
  'appearance.combo.ink': 'Ink',
  'appearance.combo.lagoon': 'Lagoon',
  'appearance.combo.sky': 'Sky',
  'appearance.combo.sage': 'Sage',
  'appearance.combo.electric': 'Electric',
  'appearance.combo.cobalt': 'Cobalt',
  'appearance.combo.emerald': 'Emerald',
  'appearance.combo.violet': 'Violet',
  'appearance.combo.candy': 'Candy',
  'appearance.combo.lime': 'Lime',
  'appearance.combo.coral': 'Coral',
  'appearance.combo.brick': 'Brick',
  'appearance.combo.wine': 'Wine',
  'appearance.own': 'Our own colours',
  'appearance.ownHint': 'Only the main colour is needed. Left empty, the second colour and the accent are made from it.',
  'appearance.second': 'Second colour',
  'appearance.accent': 'Accent',
  'appearance.fromMain': 'Made from the main colour',
  'appearance.pickFor': 'Pick: {name}',
  'appearance.clear': 'Clear: {name}',
  'appearance.darkerOther': '{name}: this colour is light, so it is shown darker to keep text on it readable.',
  'appearance.lighterOther': '{name}: this colour is very dark, so it is shown lighter to stand out.',
  'appearance.previewHint': 'Pages, cards and dialogs keep DoCuLat\'s background; only buttons, links, selected items and lines take your colours.',
  'appearance.sampleField': 'Customer',
  'appearance.sampleBadge': 'New',
  'common.save': 'Save',
  'common.saved': 'Saved.',
  'common.create': 'Create',
  'common.delete': 'Delete',
  'common.remove': 'Remove',
  'common.none': 'None',
  'common.rename': 'Rename',
  'common.retry': 'Try again',
  'common.loading': 'Loading…',
  'common.name': 'Name',
  'common.personName': 'Name',
  'common.email': 'Email',
  'common.role': 'Role',
  'common.actions': 'Actions',
  'common.actionsFor': 'Actions for {name}',
  'common.copy': 'Copy',
  'common.copied': 'Copied.',
  'common.somethingWrong': 'Something went wrong.',
  'common.notFound': 'Not found, or you have no access.',
  'common.back': 'Back',
  'common.never': 'never',
  'common.optional': 'optional',
  'common.dismiss': 'Dismiss',

  'auth.signIn': 'Sign in',
  'auth.signOut': 'Sign out',
  'auth.welcome': 'Welcome to DoCuLat',
  'auth.signInHint': 'Sign in with your company account to see your files and customers.',
  'auth.signingIn': 'Signing you in…',
  'auth.signedOut': 'You are signed out.',
  'auth.signInCancelled': 'Signing in was cancelled. Sign in again when you are ready.',
  'auth.signInExpired': 'The sign-in took too long, or was opened twice. Sign in again.',
  'auth.signInFailed': "Signing in did not work. Sign in again, and if it keeps happening, check that your computer's clock is right.",
  'signup.title': 'Create your DoCuLat account',
  'signup.hint': 'Your name and work e-mail. We\'ll send you a link to set your password.',
  'signup.firstName': 'First name',
  'signup.lastName': 'Last name',
  'signup.email': 'Work e-mail',
  'signup.terms': 'By signing up you agree to how we handle your data:',
  'signup.privacy': 'privacy policy',
  'signup.submit': 'Create account',
  'signup.haveAccount': 'Already have an account?',
  'signup.sentTitle': 'Check your e-mail',
  'signup.sent': 'We sent a link to {email}. Open it to set your password and sign in.',
  'signup.sentHint': 'No e-mail after a few minutes? Look in spam. If you already have an account, sign in or use "Forgot password" on the sign-in page.',
  'signup.closedTitle': 'Signing up is by invitation for now',
  'signup.closed': 'Ask us for a demo on our website, or ask a colleague to invite you to their company. If you already have an account, sign in.',
  'bots.notLoaded': 'The check that you\'re a person did not load. Reload the page and try again.',
  'bots.failed': 'The check that you\'re a person did not pass. Try again.',
  'mail.blockedFailed': 'E-mail to this address could not be delivered before. Check the address.',
  'mail.blockedComplained': 'The person at this address asked not to get e-mail from DoCuLat.',
  'mail.state.accepted': 'Sent',
  'mail.state.deferred': 'Delivery delayed',
  'mail.state.delivered': 'Delivered',
  'mail.state.complained': 'The recipient asked not to get these e-mails',
  'mail.notDelivered': 'Not delivered: {reason}',
  'mail.reason.no_mailbox': 'the mailbox does not exist',
  'mail.reason.mailbox_full': 'the mailbox is full',
  'mail.reason.spam': 'refused as unwanted mail',
  'mail.reason.other': 'refused by the receiving server',
  'bots.unavailable': 'We could not confirm the check that you are a person just now. Nothing you entered is lost: send it again in a minute.',
  'bots.unavailable.company': 'We could not confirm the check that you are a person just now. Nothing you entered is lost; press Create a company again in a minute.',
  'bots.unavailable.signup': 'We could not confirm the check that you are a person just now. Nothing you entered is lost; press Create account again in a minute.',
  'bots.ourFault': 'This is not possible right now because of a fault on our side. We have been told; please try later.',
  'bots.ourFault.company': 'Registering is not possible right now because of a fault on our side. We have been told; please try later.',
  'bots.ourFault.signup': 'Signing up is not possible right now because of a fault on our side. We have been told; please try later.',
  'bots.notSetUp': 'Signing up is not set up yet on this installation.',
  'bots.signupClosed': 'Signing up is by invitation for now.',
  'bots.tooManySignups': 'Too many sign-ups from this address. Try again in an hour.',
  'bots.disposable': 'Please use your work e-mail address.',
  'bots.domainBlocked': 'Sign-ups from this e-mail domain are not accepted.',
  'bots.tooManyChecks': 'Too many checks. Try again in an hour.',
  'bots.companiesPerDay.one': 'You can register {count} company a day. Register this one tomorrow.',
  'bots.companiesPerDay.other': 'You can register {count} companies a day. Register this one tomorrow.',
  'bots.companiesInAll.one': 'You\'ve registered {count} company, the most without our approval. Write to us to register more.',
  'bots.companiesInAll.other': 'You\'ve registered {count} companies, the most without our approval. Write to us to register more.',
  'bots.mailLimit.one': 'In its first week and during its trial, a company can send {count} invitation or share a day. Send the rest tomorrow.',
  'bots.mailLimit.other': 'In its first week and during its trial, a company can send {count} invitations and shares a day. Send the rest tomorrow.',

  'nav.dashboard': 'Dashboard',
  'nav.files': 'Files',
  'nav.shared': 'Shared with me',
  'nav.trash': 'Trash',
  'nav.members': 'Members',
  'nav.account': 'My account',
  'nav.console': 'More tools (dev console)',
  'nav.reportProblem': 'Report a problem',
  'feedback.unavailable': 'The form to report a problem could not be opened. Try again in a moment.',
  'nav.main': 'Main',
  'nav.skip': 'Skip to content',
  'nav.menu': 'Menu',
  'nav.home': 'Home',
  'nav.tasks': 'Tasks',
  'nav.more': 'More',
  // The mobile app (TF-270): empty screens until sign-in comes (TF-271).
  'mobile.empty.title': 'Nothing here yet',
  'mobile.files.empty': "Your company's folders and files will be here, to open, share and add photos to.",
  'mobile.tasks.empty': 'The tasks given to you will be here, the ones due first at the top.',
  'mobile.more.version': 'Version {version}',
  'mobile.loadFailed': 'This did not load. Check the connection and try again.',
  'mobile.offline.title': 'No connection',
  'mobile.offline.text': 'The app cannot reach DoCuLat. You are still signed in. Try again when the phone is online.',
  'mobile.update.title': 'Update DoCuLat',
  'mobile.update.text': 'This version of the app no longer works with DoCuLat. Update it to continue. Your files and records are safe.',
  'mobile.update.store': 'Open the store',
  'mobile.update.noStore': 'Update the app where you installed it.',
  'mobile.kept.offline': 'Offline. You see what is kept on this phone.',
  'mobile.kept.offlineWaiting': 'Offline. Changes waiting to be sent: {count}.',
  'mobile.kept.toCheck': 'Changes made offline to check: {count}.',
  'mobile.kept.savedOnPhone': 'Saved on the phone. It is sent once the phone is online.',
  'mobile.kept.needsConnection': 'Connect to the internet to keep this file on the phone.',
  'mobile.kept.noRoom': 'Not enough room within the storage limit. Remove kept files or raise the limit in More, Storage.',
  'mobile.kept.keepFailed': 'The file could not be kept. Try again.',
  'mobile.kept.available': 'Available offline',
  'mobile.kept.fileKept': 'Kept on this phone ({size}). It opens without a connection.',
  'mobile.kept.fileHint': 'Keep this file on the phone to open it without a connection.',
  'mobile.kept.onPhone': 'Kept on this phone',
  'mobile.storage.title': 'Storage and offline',
  'mobile.storage.intro': 'The phone keeps the records you opened in the last 7 days and the files you chose. Everything is encrypted and deleted when you sign out.',
  'mobile.storage.changes': 'Changes made offline',
  'mobile.storage.tickDone': 'Done: {subject}',
  'mobile.storage.tickOpen': 'Open again: {subject}',
  'mobile.storage.note': 'Note on {record}: {subject}',
  'mobile.storage.waiting': 'Waiting to be sent',
  'mobile.storage.conflict': 'Changed on the web meanwhile',
  'mobile.storage.gone': 'Deleted, or no longer open to you',
  'mobile.storage.refused': 'Refused by DoCuLat',
  'mobile.storage.sendMine': 'Send mine',
  'mobile.storage.keepWeb': "Keep the web's",
  'mobile.storage.delete': 'Delete',
  'mobile.storage.sendNow': 'Send now',
  'mobile.storage.room': 'Room on the phone',
  'mobile.storage.used': '{used} of {cap}',
  'mobile.storage.limit': 'Limit',
  'mobile.storage.limitHint': 'Kept files count toward the limit. Records take little room.',
  'mobile.storage.files': 'Files kept',
  'mobile.storage.remove': 'Remove',
  'mobile.storage.noFiles': 'No files kept. Turn on "Available offline" on a file.',
  'mobile.storage.clear': 'Delete everything kept',
  'mobile.signIn.server': 'Server: {server}',
  'mobile.signInFailed': "Signing in did not work. Try again, and if it keeps happening, check that the phone's date and time are right.",
  'mobile.more.appearance': 'Appearance',
  'mobile.more.language': 'Language',
  'mobile.more.sameAsPhone': 'Same as the phone',
  'mobile.more.textSize': 'Text size',
  'mobile.textSize.normal': 'Normal',
  'mobile.textSize.larger': 'Larger',
  'mobile.textSize.largest': 'Largest',
  'mobile.more.help': 'Help',
  'mobile.help.title': 'How the app works',
  'mobile.help.home': "Your day at a glance: the tasks due, today's meetings and what is new. Tap a line to open it.",
  'mobile.help.files': "Your company's files, in folders. Tap a folder to open it, and a file to see what you can do with it: preview, keep offline, send a copy.",
  'mobile.help.crm': 'Your organisations, contacts and deals. Open one to call, write or navigate, and to add a note or a task.',
  'mobile.help.tasks': "Everything due, yours or everybody's, and a calendar of meetings. Tick a task when it is done.",
  'mobile.help.signing': 'A file is sent for signature from its page. Signers sign with Smart-ID, Mobile-ID or an ID card, and you see who has signed.',
  'mobile.help.askCompany': 'Ask your company',
  'mobile.help.call': 'Call {name}',
  'mobile.help.write': 'Write to {name}',
  'mobile.help.noContact': 'Your company has not set a contact yet. Ask the person who invited you.',
  'mobile.help.askDoculat': 'Ask DoCuLat',
  'mobile.help.writeTo': 'Write to {email}',
  'mobile.signIn.browser': 'Signing in opens your browser for a moment. You come back here by yourself.',
  'mobile.signIn.noAccount': "No account yet? Your company's admin invites you by e-mail. Open that e-mail first.",
  'mobile.signIn.showDetails': 'Show details',
  'mobile.pushAsk.title': 'Stay informed',
  'mobile.pushAsk.text': 'May DoCuLat tell you when a task is due, a file is signed or somebody writes to you? The phone asks next.',
  'mobile.pushAsk.yes': 'Yes',
  'mobile.pushAsk.notNow': 'Not now',
  'mobile.hint.home': 'Your day: tasks, meetings and news. Tap a line to open it.',
  'mobile.hint.files': "Your company's files. Tap a folder to open it, and Back to come up.",
  'mobile.hint.crm': 'Your organisations, contacts and deals. Tap one, then Call or Email.',
  'mobile.hint.gotIt': 'Got it',
  'mobile.up': 'Up',
  'mobile.down': 'Down',
  'mobile.stop': 'Stop',
  'mobile.files.copyLink': 'Copy the link',
  'mobile.files.needsConnection': 'Needs a connection.',
  'mobile.files.emptyAdd': 'This folder is empty. Add a file or scan a document with the buttons above.',
  'mobile.kept.asOf': 'As of {when}.',
  'mobile.home.quickActions': 'Quick actions',
  'mobile.chips.more': 'More…',
  'mobile.undo.done': 'Done: {subject}.',
  'mobile.undo.removed': 'Removed: {name}.',
  'mobile.signOut.ask': 'Sign out?',
  'mobile.signOut.allSent': 'Everything is sent. Kept files and records are deleted from this phone.',
  'mobile.signOut.unsent': 'Not sent yet: scans {scans}, changes {changes}. Signing out deletes them.',
  'mobile.storage.clearAsk': 'Delete everything kept on this phone?',
  'mobile.storage.clearAskText': 'The files and records kept for offline use are deleted from this phone. They stay in DoCuLat.',
  'mobile.storage.deleteChangeAsk': 'Delete this change?',
  'mobile.storage.deleteChangeAskText': 'It was made offline and not sent. Deleted here, it is gone.',
  'mobile.tasks.chooseDate': 'Choose a date',
  'mobile.tasks.chooseTime': 'Choose a time',
  'mobile.pick.done': 'Done',
  'mobile.didNotWork': 'This did not work. Check the connection and try again.',
  'mobile.saved.sent': 'Sent.',
  'mobile.bar.backTo': 'Back to {name}',
  'mobile.bar.switchCompany': 'Company: {name}. Tap to switch.',
  'mobile.files.place': 'In',
  'mobile.files.above': 'Folders above',
  'mobile.tasks.due.any': 'Any date',
  'mobile.tasks.due.week': 'Next 7 days',
  'mobile.tasks.none': 'No open tasks here.',
  'mobile.tasks.more': 'Show more',
  'mobile.tasks.agenda': 'Agenda',
  'mobile.tasks.day': 'Day',
  'mobile.tasks.week': 'Week {number}',
  'mobile.tasks.dayEmpty': 'Nothing on this day.',
  'mobile.tasks.newMeeting': 'New meeting',
  'mobile.tasks.addMeeting': 'Add meeting',
  'mobile.tasks.markDone': 'Mark as done',
  'mobile.tasks.reopen': 'Open again',
  'mobile.tasks.snoozeTomorrow': 'Snooze to tomorrow',
  'mobile.tasks.snoozeNextWeek': 'Snooze to next week',
  'mobile.tasks.moved': 'Moved to {date}.',
  'mobile.tasks.saveFailed': 'This was not saved. Try again.',
  'mobile.tasks.noDate': 'No date',
  'mobile.tasks.atTime': 'At a time',
  'mobile.tasks.hourEarlier': 'An hour earlier',
  'mobile.tasks.hourLater': 'An hour later',
  'mobile.tasks.minutesEarlier': '15 minutes earlier',
  'mobile.tasks.minutesLater': '15 minutes later',
  'mobile.tasks.noRecord': 'No deal, account or contact',
  'mobile.tasks.searchRecords': 'Search deals, accounts and contacts',
  'mobile.tasks.weekNumbersHint': 'In the calendar. Week 1 is the one with the year’s first Thursday.',
  // Customers on the phone (TF-277).
  'mobile.crm.openRecord': 'Open {name}',
  'mobile.crm.calledAt': 'Called at {time}.',
  'mobile.crm.notNow': 'Not now',
  'mobile.crm.map': 'Map',
  'mobile.crm.osm': 'OpenStreetMap',
  'mobile.crm.hiddenFiles': 'Files you have no access to: {count}.',
  'mobile.crm.mine': 'My contacts',
  'mobile.crm.pointsInvalid': 'One of the e-mail addresses is not an address. Check it and try again.',
  'mobile.crm.editPoints': 'Change phone numbers and e-mail addresses',
  'mobile.lock.title': 'DoCuLat is locked',
  'mobile.lock.text': "Unlock it with Face ID, your fingerprint or the phone's code.",
  'mobile.lock.unlock': 'Unlock',
  'mobile.lock.prompt': 'Unlock DoCuLat',
  'mobile.company.choose': 'Choose a company',
  'mobile.company.none': "{email} is not in a company yet. Ask your company's admin to invite you.",
  'mobile.home.overdue': 'Overdue: {day}',
  'mobile.home.tick': 'Mark as done: {subject}',
  'mobile.home.tickFailed': 'The task was not marked as done. Try again.',
  'mobile.home.unread': 'Unread: {count}',
  'mobile.home.nothingDue': 'Nothing due today.',
  'mobile.home.meetings': 'Meetings today',
  'mobile.home.noMeetings': 'No meetings today.',
  'mobile.home.allNotifications': 'All notifications',
  'mobile.home.recentRecords': 'Customers you opened last',
  'mobile.home.noRecentRecords': 'Accounts, contacts and deals you open show here.',
  'mobile.home.tabUnread': 'Home, unread notifications: {count}',
  'mobile.notifications.markRead': 'Mark as read: {title}',
  'mobile.notifications.allRead': 'All marked as read.',
  'mobile.files.addPhoto': 'Add a photo or video',
  'mobile.files.addFile': 'Add a file',
  'mobile.files.stopUpload': 'Stop uploading {name}',
  'mobile.files.uploadStopped': 'The connection was lost. Try again.',
  // Scanning paper on the phone (TF-275).
  'mobile.scan.button': 'Scan a document',
  'mobile.scan.title': 'Save the scan',
  'mobile.scan.word': 'Scan',
  'mobile.scan.pages': 'Pages: {count}',
  'mobile.scan.name': 'Name',
  'mobile.scan.into': 'Into: {path}',
  'mobile.scan.hint': 'The scan is kept on this phone until it is uploaded. Without a connection it waits, and goes when the connection is back.',
  'mobile.scan.save': 'Save and upload',
  'mobile.scan.noName': 'Give the scan a name.',
  'mobile.scan.failed': 'The scan could not be saved. Try again.',
  'mobile.scan.chooseFolder': 'Choose a folder',
  'mobile.scan.intoHere': 'Into this folder',
  'mobile.scan.folderUp': 'Up one folder',
  'mobile.scan.noFolders': 'No folders here.',
  'mobile.scan.queue': 'Scans on this phone',
  'mobile.scan.waiting': 'Waiting to upload',
  'mobile.scan.sending': 'Uploading',
  'mobile.scan.retry': 'Try {name} again',
  'mobile.scan.discard': 'Delete {name} from this phone',
  'mobile.scan.discardConfirm': 'It is not uploaded yet. Deleted here, it is gone.',
  'mobile.share.title': 'Add to DoCuLat',
  'mobile.share.company': 'Company',
  'mobile.share.where': 'Where',
  'mobile.share.folder': 'A folder',
  'mobile.share.record': 'An account or deal',
  'mobile.share.chooseRecord': 'Choose an account or deal',
  'mobile.share.noRecord': 'No account or deal chosen',
  'mobile.share.files': 'Files: {count}',
  'mobile.share.word': 'Shared file',
  'mobile.share.upload': 'Upload',
  'mobile.share.onlyFiles': 'Only files can be added. Text and links were left out.',
  'mobile.share.nothing': 'Nothing to add. Share a file from another app, such as Mail or Photos.',
  'mobile.share.reading': 'Reading the shared files…',
  'mobile.share.readFailed': 'The shared files could not be read. Share them again.',
  'mobile.share.pickRecord': 'Choose an account or a deal first.',
  'mobile.share.sent': 'Uploading. Uploads go on if you leave this page.',
  'mobile.share.done': 'Done',
  'mobile.files.pickFailed': 'The phone did not hand over the files. Try again.',
  'mobile.files.checkingHint': 'The file opens once the virus check has passed it.',
  'mobile.files.blockedHint': 'A virus was found in this file. It cannot be opened or sent.',
  'mobile.files.previewRendition': 'Shown as a PDF, read only',
  'mobile.files.browserHint': 'Opens in the browser, signed in. When you are done, tap Done (iPhone) or Back (Android) to return here.',
  'mobile.files.handoffSignedOut': 'You are signed out. Sign in again in the app, then try again.',
  'mobile.files.handoffTooMany': 'Too many tries in a minute. Wait a moment and try again.',
  'mobile.files.handoffFailed': 'The browser could not be opened signed in. Try again.',
  'mobile.files.sendOrSave': 'Send or save a copy',
  'mobile.files.sendOrSaveDetail': 'Save it on the phone, or send it by email or a messenger.',
  'mobile.files.sendLink': 'Send the link',
  'mobile.files.sendLinkDetail': 'For people in your company. It opens the file in DoCuLat.',
  'mobile.files.noViewer': 'No app on this phone opens this kind of file. Use “Send or save a copy”.',
  'mobile.files.openFailed': 'This did not work. Check the connection and try again.',
  'mobile.files.expiresNever': 'No end date',
  'mobile.files.expiresWeek': 'In 7 days',
  'mobile.files.expiresMonth': 'In 30 days',
  'mobile.files.passwordHint': 'At least {count} characters. Send it separately from the link.',
  'mobile.files.limitHint': 'A whole number from 1 to 100000.',
  'mobile.files.linkOnce': 'Once you leave this page, the link cannot be shown again. You can withdraw it in the web app.',
  'mobile.more.account': 'Account',
  'mobile.more.security': 'Security',
  'mobile.more.biometric': 'Unlock with Face ID or fingerprint',
  'mobile.more.biometricDetail': 'Asked when you open the app, and after 5 minutes away from it.',
  'mobile.more.biometricUnavailable': 'Set up Face ID, a fingerprint or a screen lock on the phone first.',
  'mobile.more.push': 'Notifications',
  'mobile.account.soleOwner': 'You are the only owner of a company. Make somebody else an owner in the web app, Settings, or delete the company there first.',
  'mobile.account.offline': 'DoCuLat cannot be reached. Try again when the phone is online.',
  'mobile.account.web': 'On the web: app.doculat.eu, My account.',
  'mobile.push.title': 'Push notifications',
  'mobile.push.channel': 'Notifications',
  'mobile.push.phone': 'This phone',
  'mobile.push.kinds': 'What comes as a push',
  'mobile.push.intro': 'The same choices as On the phone in the web app, Settings, Notifications. A push says what happened and opens it. It never shows a note, an amount or a file.',
  'mobile.push.allow': 'Allow notifications',
  'mobile.push.openSettings': 'Open the phone settings',
  'mobile.push.state.granted': 'On. Pushes come to this phone.',
  'mobile.push.state.undetermined': 'Not allowed yet.',
  'mobile.push.state.denied': 'Turned off in the phone settings.',
  'mobile.push.state.unavailable': 'Not available in this version of the app.',
  'nav.company': 'Company',
  'nav.overdue': '{count} overdue',
  'nav.language': 'Language',
  'nav.languageBackend': 'E-mails and the sign-in page are in {language} for now',
  'nav.appearance': 'Appearance',
  'theme.light': 'Light',
  'theme.dark': 'Dark',
  'theme.system': 'Same as the system',
  'contrast.label': 'Contrast',
  'density.dense': 'Dense tables',
  'contrast.system': 'Same as the system',
  'contrast.standard': 'Standard contrast',
  'contrast.medium': 'Medium contrast',
  'contrast.high': 'High contrast',

  'company.switch': 'Switch company',
  'company.current': 'Company: {name}',
  'company.new': 'New company',
  'company.create': 'Create a company',
  'company.nameLabel': 'Company name',
  'company.nameHint': 'As it shows in DoCuLat: short and familiar.',
  'company.country': 'Country',
  'company.chooseCountry': 'Choose…',
  'company.numbers': 'Registration and VAT number',
  'company.numbersHint': "The number of your company in its country's register; a self-employed person gives their taxpayer code. The VAT number is optional.",
  'company.registrationNo': 'Registration number',
  'company.registrationOrTaxpayerNo': 'Registration or taxpayer number',
  'company.registrationRequired': "Give the company's registration number, or a self-employed person's taxpayer code.",
  'company.vatNo': 'VAT number',
  'company.vatValid': 'Valid in VIES.',
  'company.fillFromVies': 'Fill the legal name and address from VIES',
  'company.vatInvalid': 'VIES does not know this VAT number. You can go on; check it later.',
  'company.vatUnavailable': 'VIES is not answering just now. You can go on.',
  'company.checkLimited': 'Too many checks; the number will be checked when you create the company.',
  'company.numberTaken': 'A company with this number is already registered in DoCuLat. Ask a colleague who uses it to invite you.',
  'company.numberReserved': 'This number is reserved for DoCuLat\'s demo company. Enter your company\'s own number.',
  'company.askToJoin': 'Ask to join it',
  'company.joinAsked': 'Its owners have been told that you ask to join. They invite you if they know you.',
  'company.legal': 'Legal name and address',
  'company.legalName': 'Legal name',
  'company.street': 'Street and number',
  'company.postalCode': 'Postal code',
  'company.city': 'City',
  'company.address': 'Legal address',
  'company.contact': 'For invoices (optional)',
  'company.invoiceEmail': 'E-mail for invoices',
  'company.phone': 'Phone',
  'company.website': 'Website',
  'company.detailsTitle': "Company's details",
  'company.detailsSaved': "The company's details are saved.",
  'company.notGiven': 'Not given',
  'company.numberChecked': 'Checked',
  'company.completeTitle': "Complete your company's details",
  'company.completeText': "Complete your company's details: its registration or VAT number, legal name and address. Invoices use them.",
  'company.complete': 'Complete',
  'company.notNow': 'Not now',
  'company.created': '{name} was created.',
  'company.pendingDeletion': 'This company is scheduled for deletion. Only owners can open it until then.',
  'company.closed': 'Closed',
  'company.countryNotServed': 'DoCuLat cannot be provided to companies established in this country.',
  'company.held': 'Being checked',
  'company.heldNote': 'Your registration is being checked. We will write to you within one working day.',
  'readOnly.title': 'Read-only',
  'readOnly.banner': 'This company is read-only. Its owner needs to add a registration or VAT number by {date}.',
  'readOnly.ownerHint': 'Everything can still be opened, downloaded and exported. Adding the number ends it at once; otherwise the company is closed on that date.',
  'readOnly.askOwner': 'Everything can still be opened, downloaded and exported, but nothing can be changed.',
  'readOnly.addNumber': 'Add the number',
  'readOnly.refused': 'This company is read-only: its owner needs to add a registration or VAT number by {date}.',
  'readOnly.refusedNoDate': 'This company is read-only: its owner needs to add a registration or VAT number.',
  'memberLimit.readOnly': 'Read-only',
  'memberLimit.rule.one': 'The plan allows {count} active person; guests do not count. The others can open everything but not change it.',
  'memberLimit.rule.other': 'The plan allows {count} active people; guests do not count. The others can open everything but not change it.',
  'memberLimit.chooseTitle.one': '{plan} allows {count} person. Choose who stays active',
  'memberLimit.chooseTitle.other': '{plan} allows {count} people. Choose who stays active',
  'memberLimit.chooseHint': 'Owners always stay active. The others can still sign in, open, search and export, but not change anything. You can change this later.',
  'memberLimit.ownerStays': 'Owner: always active',
  'memberLimit.chosenCount': '{chosen} of {count} chosen',
  'memberLimit.swapsLeft': '{count} changes left this month',
  'memberLimit.save': 'Save who stays active',
  'memberLimit.saved': 'Saved who stays active',
  'memberLimit.banner.one': 'You’re read-only in {company} because its plan allows {count} active person. Ask an owner.',
  'memberLimit.banner.other': 'You’re read-only in {company} because its plan allows {count} active people. Ask an owner.',
  'memberLimit.refused.one': 'You’re read-only in this company because its plan allows {count} active person. Ask an owner.',
  'memberLimit.refused.other': 'You’re read-only in this company because its plan allows {count} active people. Ask an owner.',
  'memberLimit.moveTitle': 'Move to {plan}',
  'memberLimit.moveAndSave': 'Save and move to {plan}',
  'memberLimit.trialChoose': 'Choose who stays active',
  'company.none': 'You are not in a company yet',
  'company.noneHint': 'Create one for your team, or accept an invitation from a colleague.',
  'company.guest': 'Guest',

  'role.owner': 'Owner',
  'role.admin': 'Admin',
  'role.member': 'Member',
  'role.external': 'External',

  'invitations.title': 'Invitations for you',
  'invitations.from': 'Invited by {name} as {role}',
  'invitations.accept': 'Accept',
  'invitations.accepted': 'You joined {name}.',
  'invitations.decline': 'Decline',
  'invitations.declined': 'You declined the invitation to {name}.',
  'invitations.later': 'Later',
  'invitations.banner': '{name} invited you to join as {role}.',
  'invitations.waiting.one': '{count} invitation waiting',
  'invitations.waiting.other': '{count} invitations waiting',
  'invitations.unverifiedTitle': 'Verify your e-mail to see invitations',
  'invitations.unverified': 'Invitations are matched to a verified e-mail address, and {email} is not verified yet, so invitations sent to it cannot be shown. Verify it, or ask to be invited at an address you have verified.',
  'invitations.sendVerification': 'Send me a verification e-mail',
  'invitations.verificationSent': 'Sent to {email}. Open the link in it, then come back here.',
  'invitations.verifiedNow': 'Your e-mail is verified. Reload the page to see your invitations.',

  'files.title': 'Files',
  'files.root': 'All files',
  'files.upload': 'Upload',
  'files.uploadFiles': 'Upload files',
  'files.newFolder': 'New folder',
  'files.folderName': 'Folder name',
  'files.folderCreated': 'Folder {name} created.',
  'files.empty': 'This folder is empty',
  'files.emptyHint': 'Drop files here or use Upload.',
  'files.emptyReadOnly': 'Nothing here yet.',
  'files.dropHere': 'Drop files to upload them here',
  'files.column.name': 'Name',
  'files.column.modified': 'Modified',
  'files.column.size': 'Size',
  'files.column.addedBy': 'Added by',
  'files.column.linkedTo': 'Linked to',
  'files.searchFiles': 'Search files',
  'files.changed': 'Changed',
  'files.changed.2d': 'In the last 2 days',
  'files.changed.7d': 'In the last 7 days',
  'files.changed.30d': 'In the last 30 days',
  'files.size.small': 'Under 1 MB',
  'files.size.medium': '1 to 10 MB',
  'files.size.large': '10 to 100 MB',
  'files.size.huge': 'Over 100 MB',
  'files.count.one': '{count} file',
  'files.count.other': '{count} files',
  'files.countMore': 'More than {count} files',
  'files.allFolders': 'In all folders',
  'files.inFolder': 'In {name}',
  'files.moveTo': 'Move to…',
  'files.move.titleOne': 'Move {name}',
  'files.move.titleMany.one': 'Move {count} item',
  'files.move.titleMany.other': 'Move {count} items',
  'files.move.search': 'Find a folder',
  'files.move.choose': 'Choose a folder',
  'files.move.noneFound': 'No folder of that name.',
  'files.move.noAdd': 'You may not add here',
  'files.move.moving': 'Being moved',
  'files.move.already': 'Already here',
  'files.move.to': 'Move to {name}',
  'files.move.newFolderIn': 'New folder in {name}',
  'files.move.open': 'Open {name}',
  'files.move.close': 'Close {name}',
  'files.move.refused.not_found': '{name} is no longer there.',
  'files.move.refused.no_edit': 'You may not move {name}.',
  'files.move.refused.already_there': '{name} is already there.',
  'files.move.refused.into_itself': '{name} cannot go into itself.',
  'files.move.mayNotAdd': 'You may not add to {folder}.',
  'files.move.noneCanGo.one': 'This item cannot go there.',
  'files.move.noneCanGo.other': 'None of these {count} items can go there.',
  'files.move.movedOne': 'Moved {name} to {folder}',
  'files.move.moved.one': 'Moved {count} item to {folder}',
  'files.move.moved.other': 'Moved {count} items to {folder}',
  'files.move.merged.one': '{count} added as a new version.',
  'files.move.merged.other': '{count} added as new versions.',
  'files.move.failed': '{name} could not be moved.',
  'files.move.skipped.one': '{count} item skipped. Nothing moved.',
  'files.move.skipped.other': '{count} items skipped. Nothing moved.',
  'files.move.access.title': 'Access changes in {folder}',
  'files.move.access.intro': 'What you move takes the access of the folder it goes to:',
  'files.move.access.teamsGained': 'These teams can see it: {teams}.',
  'files.move.access.teamsLost': 'These teams can no longer see it: {teams}.',
  'files.move.access.restricted': 'The folder is restricted: only the people it is shared with can open it.',
  'files.move.access.open': 'It leaves a restricted folder: more people can open it.',
  'files.move.access.sensitiveGained': 'It gets these sensitive tags: {tags}.',
  'files.move.access.sensitiveLost': 'It loses these sensitive tags: {tags}.',
  'files.move.access.go': 'Move',
  'files.move.clash.title': '{name} is already there',
  'files.move.clash.fileThere': 'The folder has a file of this name.',
  'files.move.clash.folderThere': 'The folder has a folder of this name.',
  'files.move.clash.copy': 'Keep both',
  'files.move.clash.version': 'Add as a new version',
  'files.move.clash.versionHint': 'It becomes the newest version of the file there; its earlier versions come with it.',
  'files.move.clash.skip': 'Skip',
  'files.move.clash.skipHint': 'It stays where it is.',
  'files.move.clash.cancel': 'Cancel the move',
  'files.move.clash.applyToAll': 'Do the same for the other names taken ({count})',
  'files.nothingFound': 'No file matches these filters.',
  'files.sortBy': 'Sort by {name}',
  'files.view': 'View',
  'files.view.detailed': 'Detailed',
  'files.view.tiles': 'Tiles',
  'files.view.grouped': 'Grouped by account and deal',
  'files.showDetails': 'Show details',
  'files.hideDetails': 'Hide details',
  'files.alsoUnder.one': 'also under {count} other',
  'files.alsoUnder.other': 'also under {count} others',
  'files.group.notLinked': 'Not linked',
  'dashboard.myDay': 'My day',
  'dashboard.today': 'Today',
  'dashboard.tomorrow': 'Tomorrow',
  'dashboard.anyTime': 'Any time',
  'dashboard.closes': 'Closes',
  'dashboard.nothingToday': 'Nothing planned today.',
  'dashboard.overdueInTasks.one': '{count} overdue in My tasks',
  'dashboard.overdueInTasks.other': '{count} overdue in My tasks',
  'pins.title': 'Pinned',
  'pins.pin': 'Pin',
  'pins.unpin': 'Unpin',
  'pins.pinForCompany': 'Pin for everyone',
  'pins.unpinForCompany': 'Unpin for everyone',
  'pins.pinned': 'Pinned: {name}',
  'pins.unpinned': 'Unpinned: {name}',
  'pins.pinnedForCompany': 'Pinned for everyone: {name}',
  'pins.unpinnedForCompany': 'Unpinned for everyone: {name}',
  'pins.mark': 'Pinned',
  'pins.markCompany': 'Pinned for everyone',
  'pins.empty': "Nothing pinned yet. In Files, open a file or folder's menu and choose Pin: it shows here and at the top of the drive.",
  'files.folder': 'Folder',
  'files.restricted': 'Restricted',
  'files.restrictedHint': 'Only people it is shared with can open it',
  'files.sealedMark': 'Sensitive: you can see only that it exists',
  'files.documentSensitive': 'You can see that this exists, not what is in it.',
  'files.makeRestricted': 'Restrict access',
  'files.makeOpen': 'Open to the whole company',
  'files.download': 'Download',
  'files.preview': 'Preview',
  'files.openInTab': 'Open in a new tab',
  'files.share': 'Share',
  'files.shareWithOthers': 'Share with others…',
  'files.linkCopied': 'Link copied. It opens for people who already have access to the file.',
  'files.linkNotCopied': 'The link could not be copied.',
  'files.copyLink': 'Copy link',
  'files.details': 'Details and versions',
  'files.linkTo': 'Link to…',
  'files.linkToTitle': 'Link “{name}” to…',
  'files.linkSearch': 'Find a task, deal, account or contact',
  'files.linkResults': 'Where to link it',
  'files.linkNothing': 'Nothing found.',
  'files.linkedToName': 'Linked to {name}.',
  'files.alreadyLinked': 'This file is already linked here.',
  'files.linkedTo': 'Linked to',
  'files.notLinked': 'Not linked to any task or customer record yet.',
  'files.linksHidden.one': 'And {count} more you cannot see.',
  'files.linksHidden.other': 'And {count} more you cannot see.',
  'files.moveToTrash': 'Move to trash',
  'files.movedToTrash': '{name} moved to trash.',
  'files.renamed': 'Renamed to {name}.',
  'files.newName': 'New name',
  'files.loadMore': 'Load more',
  'files.readOnly': 'You can view this folder, not change it.',
  'files.usage': '{used} of {quota} used',
  'files.state.uploading': 'Uploading',
  'files.state.pending_scan': 'Checking for viruses',
  'files.state.clean': 'Ready',
  'files.state.infected': 'Blocked: virus found',
  'files.state.failed': 'Upload failed',
  'files.notReady': 'The file is not ready yet.',
  'files.noPreview': 'No preview for this kind of file. Download it to open it.',
  // Text recognition read only the first pages, or is reading (TF-229).
  'files.ocr.reading': 'Text recognition: {read} of {total} pages read',
  'files.ocr.cut.plan': 'The first {read} of {total} pages were read for search: your plan reads up to {read} pages of one document. The rest is read by itself on a plan that reads more.',
  'files.ocr.cut.month': 'The first {read} of {total} pages were read for search: this month’s recognised pages are used up. The rest is read by itself when the next month begins, or on a plan that reads more.',
  'files.ocr.cut.ceiling': 'The first {read} of {total} pages were read for search: up to {read} pages of one document are read here.',
  'files.ocr.plans': 'See the plans',
  'files.versions': 'Versions',
  'files.version': 'Version {number}',
  'files.newVersion': 'Upload a new version',
  'files.uploadedBy': 'Uploaded {date}',
  'files.location': 'Location',
  'files.tree': 'Folders',
  'files.treeHide': 'Hide folders',
  'files.treeShow': 'Show folders',
  'files.treeDivider': 'Width of the folders',
  'files.treeMode': 'Show in the tree',
  'files.treeFolders': 'Folders',
  'files.treeAccounts': 'Accounts',
  'files.accountsHide': 'Hide accounts',
  'files.accountsNone': 'No account has files you can open yet.',
  'files.openFolder': 'Open folder',
  'files.type': 'Type',

  'upload.title': 'Uploads',
  'upload.queued': 'Waiting',
  'upload.uploading': 'Uploading {percent}%',
  'upload.scanning': 'Checking for viruses',
  'upload.done': 'Ready',
  'upload.blocked': 'Blocked: virus found',
  'upload.cancelled': 'Stopped',
  'upload.failed': 'Failed: {reason}',
  'upload.clear': 'Clear finished',
  'upload.quota': 'Not enough storage left in your plan.',
  'upload.typeNotAllowed': '{names}: this type of file cannot be stored here. Your plan allows: {types}.',
  'upload.tooLarge': '{names}: larger than the {max} your plan allows for a single file.',
  'upload.typeNotAllowedServer': 'This type of file cannot be stored here.',
  'upload.tooLargeServer': 'This file is larger than your plan allows for a single file.',
  'upload.exists': 'A file with this name already exists here.',
  'upload.conflict.title': 'A file with this name is already here',
  'upload.conflict.there': 'Already here',
  'upload.conflict.yours': 'Yours',
  'upload.conflict.added': 'added {date}',
  'upload.conflict.addedBy': 'added {date} by {name}',
  'upload.conflict.inFolder': 'Folder: {folder}',
  'upload.conflict.useExisting': 'Use the existing file',
  'upload.conflict.useExistingHint': 'Nothing is uploaded: the file already there is linked here.',
  'upload.conflict.copy': 'Add as a copy',
  'upload.conflict.version': 'Add as a new version',
  'upload.conflict.versionHint': 'It becomes the current version; the earlier ones are kept, and so are the file\'s links.',
  'upload.conflict.applyToAll': 'Do the same for the other files of this upload ({count})',
  'upload.conflict.cancel': 'Don\'t upload this one',
  'upload.conflict.waiting': 'Waiting for your choice',
  'upload.conflict.usedExisting': 'the file already there is used',
  'upload.conflict.addedAsCopy': 'added as a copy',
  'upload.conflict.addedAsVersion': 'added as a new version',
  'storage.nearlyFull': 'Storage is {percent}% full: {used} of {quota}. When it is full, nobody in the company can upload files.',
  'storage.full': 'Storage is full ({used} of {quota}): nobody in the company can upload files.',
  'storage.unavailable': 'Uploading files is not possible right now, because the storage is not taking files. Everything already stored can still be opened and downloaded.',
  'storage.freeUp': 'Delete files that are no longer needed and empty the trash, or move to a plan with more storage:',
  'storage.planLink': 'Plan and billing',
  'storage.askAdmin': 'Ask an owner or administrator of the company to free space or change the plan.',
  'storage.uploadFull': 'Uploading is paused: the storage is full',
  'storage.uploadUnavailable': 'Uploading is not possible right now: the storage is not taking files. Try again later.',

  'trash.title': 'Trash',
  'trash.hint': 'Items are deleted for good after 30 days. Admins can delete them earlier.',
  'trash.empty': 'The trash is empty',
  'trash.restore': 'Restore',
  'trash.restored': '{name} restored.',
  'trash.deleteForever': 'Delete forever',
  'trash.deleteForeverConfirm': 'Delete {name} for good? This cannot be undone.',
  'trash.deleteForeverTitle': 'Delete {name} for good?',
  'trash.emptyTrash': 'Empty trash',
  'trash.emptyConfirm': 'Delete everything in the trash for good? This cannot be undone.',
  'trash.deleted': 'Deleted {name}.',
  'trash.deletedAt': 'Deleted {date}',

  'share.title': 'Share “{name}”',
  'share.people': 'People and companies',
  'share.link': 'Link',
  'share.withPerson': 'Share with a person',
  'share.withCompany': 'Share with a company',
  'share.emailPlaceholder': 'name@company.com',
  'share.slugLabel': 'Company handle',
  'share.slugHint': 'The short name in their address, e.g. acme-ltd',
  'share.canView': 'Can view',
  'share.canEdit': 'Can edit',
  'share.add': 'Share',
  'share.shared': 'Shared with {name}.',
  'share.sensitiveNote': 'Sensitive tags: {tags}. Only people these tags allow can open it, whatever is shared. Sharing outside the company and public links need Share external on them.',
  'share.sharedKeptOut': 'Shared with {name}. The tag {tags} keeps them out until it allows them.',
  'share.suspendedBy': 'Suspended by the tag {tags}',
  'share.pending': 'Waiting for them to sign in',
  'share.revoke': 'Stop sharing',
  'share.revoked': 'No longer shared with {name}.',
  'share.nobody': 'Not shared with anybody yet.',
  'share.createLink': 'Create a link',
  'share.linkHint': 'Anybody with the link can view and download — no account needed.',
  'share.linkPassword': 'Password',
  'share.linkExpires': 'Expires on',
  'share.linkMaxDownloads': 'Download limit',
  'share.linkCreated': 'Copy the link now: it is shown only once.',
  'share.links': 'Active links',
  'share.linkSummary': 'Created {date} · {downloads} downloads',
  'share.withPassword': 'with password',
  'share.expires': 'expires {date}',
  'share.withdraw': 'Withdraw',
  'share.withdrawn': 'Link withdrawn.',
  'share.externalSensitive': 'A sensitive tag on this lets you share it only with colleagues, not outside the company or by a public link.',
  'share.noLinks': 'No links yet.',

  'shared.title': 'Shared with me',
  'shared.hint': 'What people in other companies shared with you.',
  'shared.empty': 'Nothing has been shared with you yet',
  'shared.from': 'From {company}',

  'public.title': 'Shared with you',
  'public.passwordNeeded': 'This link is protected by a password.',
  'public.password': 'Password',
  'public.open': 'Open',
  'public.wrongPassword': 'That password is not right.',
  'public.gone': 'This link has expired or was withdrawn.',
  'public.reported': 'This link was disabled after a report',
  'public.reportedText': 'DoCuLat disabled it because it was reported as illegal content. The company that shared it was told why.',
  'public.downloadsLeft': '{count} downloads left',
  'public.poweredBy': 'Shared with DoCuLat',
  'legal.privacy': 'Privacy policy',
  'legal.copyright': 'Copyright',
  'legal.rights': '© {years} {holder}. All rights reserved.',
  'legal.draft': 'Draft: this text has not yet been reviewed by a lawyer.',
  'legal.updated': 'Last updated {date}',
  'legal.changed': 'We updated our privacy terms on {date}: who is responsible for which data, a data processing agreement and the list of sub-processors.',
  'legal.dpa': 'Data processing agreement',
  'legal.terms': 'Terms of service',
  'openSource.title': 'Open-source software',
  'openSource.intro': 'DoCuLat is built with open-source software. We thank its authors. Each part keeps its own licence, linked below; we use them unmodified.',
  'openSource.servers': 'On our servers',
  'openSource.serversIntro': 'Programs that run beside DoCuLat\'s own code, each on its own.',
  'openSource.packages': 'In the app',
  'openSource.packagesIntro': 'The {count} packages DoCuLat\'s code uses, with their versions and licences.',
  'openSource.unavailable': 'The list of packages is made when the app is built, and this copy has none. It is on every server copy.',
  'report.thisContent': 'Report this content',
  'report.title': 'Report illegal content',
  'report.intro': 'Tell us about a DoCuLat public link that shares illegal content or breaks our terms of service. A person at DoCuLat reviews every report and decides without undue delay.',
  'report.emergency': 'If somebody is in immediate danger, call 112 first.',
  'report.link': 'Address of the public link',
  'report.linkHint': 'The whole address, as you received it.',
  'report.reason': 'What is wrong with it',
  'report.choose': 'Choose one',
  'report.reason.copyright': 'Copyright infringement',
  'report.reason.illegal': 'Other illegal content, such as hate speech or fraud',
  'report.reason.child_abuse': 'Child sexual abuse material',
  'report.reason.malware': 'Malware or phishing',
  'report.reason.privacy': 'Personal data shared without the person\'s consent',
  'report.reason.other': 'Something else that breaks the law or our terms',
  'report.explanation': 'Why it is illegal',
  'report.explanationHint': 'Be as exact as you can: which file, and which law or right it breaks. For copyright, say which work is yours.',
  'report.name': 'Your name',
  'report.email': 'Your e-mail address',
  'report.emailHint': 'For our receipt and our decision.',
  'report.anonymousHint': 'You may leave out your name and address for this kind of report.',
  'report.goodFaith': 'I believe in good faith that the information in this report is accurate and complete.',
  'report.submit': 'Send the report',
  'report.sentTitle': 'Thank you: your report is {reference}',
  'report.sent': 'A person at DoCuLat reviews it. If you gave your e-mail address, we will send you our decision and the reasons for it.',
  'report.notALink': 'That is not the address of a DoCuLat public link. It contains /s/ followed by a long code.',
  'report.linkUnknown': 'No DoCuLat public link has this address. Check that it was copied whole.',
  'report.tooMany': 'Too many reports from this address. Please try again in an hour.',
  'report.emailRequired': 'Please give an e-mail address for our answer.',
  'terms.consentForCompany': 'I accept, for the company, the {terms}Terms of service{/terms}, the {dpa}Data processing agreement{/dpa} and the {privacy}Privacy policy{/privacy}.',
  'terms.consentForMe': 'I accept the {terms}Terms of service{/terms} and the {privacy}Privacy policy{/privacy}.',
  'terms.acceptTitle': 'Accept the terms of service',
  'terms.acceptText': '{company} has not accepted DoCuLat\'s terms of service yet. As its owner, please read them, with the data processing agreement and the privacy policy, and accept them.',
  'terms.changedTitle': 'The terms of service have changed',
  'terms.changedText': 'DoCuLat\'s terms have changed since {company} accepted them. As its owner, please read the new ones and accept them.',
  'terms.accept': 'Accept',
  'terms.later': 'Later',

  'search.placeholder': 'Search files and customers',
  'search.label': 'Search',
  'search.title': 'Search',
  'search.resultsFor': 'Results for “{query}”',
  'search.none': 'Nothing found for “{query}”.',
  'search.tooShort': 'Type at least two characters.',
  'search.kind.all': 'Everything',
  'search.kind.files': 'Files and folders',
  'search.kind.crm': 'Customers',
  'search.kind.file': 'File',
  'search.kind.folder': 'Folder',
  'search.kind.account': 'Account',
  'search.kind.contact': 'Contact',
  'search.kind.deal': 'Deal',
  'search.kind.activity': 'Activity',

  'notifications.title': 'Notifications',
  'notifications.open': 'Notifications',
  'notifications.unread.one': '{count} unread notification',
  'notifications.unread.other': '{count} unread notifications',
  'notifications.none': 'You are all caught up.',
  'notifications.markAll': 'Mark all as read',
  'notificationType.invitation': 'Invitations to join a company',
  'notificationType.share.received': 'Something was shared with me',
  'notificationType.share.company': 'Something was shared with my company',
  'notificationType.task.assigned': 'A task was assigned to me',
  'notificationType.task.due': 'A task of mine is due',
  'notificationType.upload.blocked': 'An upload of mine was blocked by the virus scanner',
  'notificationType.member.joined': 'Somebody joined my company',
  'notificationType.member.join_request': 'Somebody asks to join my company',
  'notificationType.signing.completed': 'A document I sent for signature was signed',
  'notificationType.signing.declined': 'A signer declined a document I sent',
  'notificationType.automation.message': 'An automation rule sends me a message',
  'notificationType.automation.disabled': 'An automation rule of mine was switched off',
  'notificationType.member.removed': 'I was removed from a company',
  'notificationType.member.role_changed': 'My role in a company changed',
  'notificationType.privacy.export_ready': 'A data export I asked for is ready',
  'notificationType.privacy.deletion': 'A company I run is scheduled for deletion, or was deleted',
  'notificationType.billing.invoice': 'An invoice was issued for a company I run',
  'notificationType.mail.undelivered': 'An invitation or share I sent could not be delivered',

  'members.title': 'Members of {name}',
  'members.you': 'you',
  'members.invite': 'Invite someone',
  'members.inviteHint': 'They get an email and join by signing in with that address.',
  'members.invited': 'Invitation sent to {email}.',
  'members.pending': 'Open invitations',
  'members.expires': 'until {date}',
  'members.cancelInvitation': 'Cancel invitation',
  'members.invitationCancelled': 'Invitation for {email} cancelled.',
  'members.roleChanged': '{name} is now {role}.',
  'members.removeConfirm': 'Remove {name} from {company}? They lose access at once, including anything shared with them personally.',
  'members.removeTitle': 'Remove {name}?',
  'members.removed': '{name} was removed.',
  'members.leave': 'Leave this company',
  'members.leaveConfirm': 'Leave {company}? You lose access to its files and records.',
  'members.left': 'You left {company}.',
  'members.rules': 'Owners can change anybody’s role; admins manage members and admins. A company always keeps one owner.',
  'members.canEdit': 'Can edit documents',
  'members.canEditFor': 'Can edit documents: {name}',
  'members.canEditYes': 'Yes',
  'members.canEditNo': 'No',
  'members.editingRule': 'Your plan sells editing in the browser per person: switch it on for the people who need it. Without it they open documents read-only.',
  'members.editingCost.one': '{count} person × {price} = {total} this month.',
  'members.editingCost.other': '{count} people × {price} = {total} this month.',
  'members.editingOn': 'Editing switched on for {name}.',
  'members.editingOff': 'Editing switched off for {name}.',
  'members.roleFor': 'Role of {name}',

  'account.title': 'My account',
  'account.profile': 'Profile',
  'account.profileHint': 'Your name and email address come from your sign-in account.',
  'account.language': 'Language',
  'account.appearance': 'Appearance',
  'account.calls': 'Calls',
  'marketplace.setUp': 'Set up',
  'notificationType.sending.domain': 'My company\'s own sending domain was verified or stopped working',
  'notificationType.sending.paused': 'My company\'s e-mail on behalf of its people was paused',
  'sending.title': 'Send from our own domain',
  'sending.intro': 'Shares and invitations your people send go out from an address on your company\'s own domain, so customers see your name and nothing says "via DoCuLat". Until the domain is verified, and whenever it is not, they go out from DoCuLat\'s address as before: nothing is lost.',
  'sending.paused': 'E-mail on behalf of your people is paused: too many shares and invitations went to addresses that do not exist or were reported as unwanted. DoCuLat will look into it and lift the pause. People still see what is shared with them in the app.',
  'sending.notAllowedTitle': 'Not available for your company',
  'sending.notAllowed.plan': 'Your plan does not include a sending domain of your own. Business and Business Plus do.',
  'sending.notAllowed.unverified': 'Only for companies whose VAT number is confirmed.',
  'sending.notAllowed.blocked': 'Switched off for your company by DoCuLat. Write to us if you think this is a mistake.',
  'sending.toCompany': 'Company details',
  'sending.setUpTitle': 'Your domain',
  'sending.domain': 'Domain',
  'sending.domainHint': 'A subdomain such as {example} is recommended: nothing about your company\'s existing e-mail has to change.',
  'sending.taken': 'This domain is used by another company.',
  'sending.mainDomainWarning': 'This is your main domain. Its MX records must stay as they are, and its SPF record has to be changed rather than a second one added. A subdomain is simpler.',
  'sending.address': 'Address',
  'sending.addressHint': 'Shares and invitations come from this address, with the name of the person who sent them. Replies go to that person.',
  'sending.setUp': 'Set up the domain',
  'sending.state.pending': 'Waiting for DNS',
  'sending.state.verified': 'Verified',
  'sending.state.broken': 'Not working',
  'sending.stateHint.pending': 'Add the records below, then check. Until then, e-mail goes out from DoCuLat\'s address.',
  'sending.stateHint.verified': 'Shares and invitations go out from your domain, signed for it.',
  'sending.stateHint.broken': 'A record is missing. Until it is back, e-mail goes out from DoCuLat\'s address.',
  'sending.checked.pending': 'Not all records are there yet.',
  'sending.checked.verified': 'The domain is verified.',
  'sending.checked.broken': 'A record is missing.',
  'sending.from': 'From:',
  'sending.changeAddress': 'Change the address',
  'sending.lastChecked': 'Last checked {date}',
  'sending.check': 'Check now',
  'sending.remove': 'Remove the domain',
  'sending.removeTitle': 'Remove {domain}?',
  'sending.removeHint': 'Shares and invitations go out from DoCuLat\'s address again. The records in your DNS can be deleted afterwards.',
  'sending.removed': 'The domain was removed.',
  'sending.recordsTitle': 'Add these records in your DNS',
  'sending.recordsIntro': 'Add the records below where your domain is managed (your registrar or DNS host). Changes usually work within an hour, sometimes only after 48 hours. Then press Check now; DoCuLat also checks every day.',
  'sending.hostHint': 'Some DNS hosts want only the part of the name before your domain.',
  'sending.cloudflare': 'On Cloudflare, set these records to DNS only (grey cloud), not proxied.',
  'sending.spf.title': 'SPF: who may send for the domain',
  'sending.spf.add': 'Add this TXT record.',
  'sending.spf.change': 'You already have an SPF record. Do not add a second one: change it to this.',
  'sending.spf.current': 'Now: {value}',
  'sending.spf.done': 'Your SPF record already allows Mailgun: nothing to do.',
  'sending.dkim.title': 'DKIM: the signature on your e-mail',
  'sending.dkim.add': 'Add this TXT record. It holds the key receiving servers check the signature with.',
  'sending.mx.title': 'MX: where bounces come back',
  'sending.mx.add': 'Add these two MX records, so bounced e-mail comes back to be counted.',
  'sending.mx.mainDomain': 'Do not change the MX records of your main domain: they belong to your mailbox provider.',
  'sending.dmarc.title': 'DMARC: what receivers do with e-mail that fails',
  'sending.dmarc.done': 'Your domain has a DMARC record: nothing to do.',
  'sending.dmarc.add': 'Recommended: add this TXT record. Large mailbox providers expect one; it changes nothing about delivery and sends reports to your address.',
  'sending.type': 'Type',
  'sending.name': 'Name',
  'sending.value': 'Value',
  'sending.priority': 'priority {priority}',
  'sending.copyOf': 'Copy the {what}',
  'sending.copied': 'Copied.',
  'sending.found': 'Found',
  'sending.missing': 'Not found yet',
  'dashboard.sizes': 'Deals by size',
  'dashboard.sizes.whichOf': 'Which deals: {name}',
  'dashboard.sizes.open': 'Open deals',
  'dashboard.sizes.won': 'Won in a period',
  'dashboard.sizes.range': '{from} to {to}',
  'dashboard.sizes.average': 'Average {amount}',
  'dashboard.sizes.median': 'Half of the deals are above {amount}',
  'dashboard.sizes.largest': 'Largest:',
  'dashboard.sizes.chartByCount': 'Deals by amount in {currency}: how many in each range',
  'dashboard.sizes.chartByValue': 'Deals by amount in {currency}: their value in each range',
  'dashboard.sizes.none': 'No deals with an amount here yet.',
  'dashboard.sizes.few': 'Too few deals with an amount for a chart; here they are, largest first.',
  'crm.filterAmountRange': 'between',
  'crm.filterAmountFrom': 'From',
  'crm.filterAmountBelow': 'Below',
  'crm.currencyIs': 'Currency: {currency}',
  'crm.noAmountFilter': 'No amount',
  'dashboard.sizes.noAmount.one': '{count} deal without an amount',
  'dashboard.sizes.noAmount.other': '{count} deals without an amount',
  'account.calendar': 'Calendar',
  'account.weekNumbers': 'Show week numbers',
  'account.weekNumbersHint': 'In the list, month and week views and their printouts. Week 1 is the one with the year’s first Thursday.',
  'account.openIn': 'Open records in',
  'account.openInHint': 'Where a task, a deal or a contact opens when you click it. Ctrl+click always opens the full page in a new tab. Kept in this browser.',
  'account.openInTasks': 'Tasks',
  'account.openInDeals': 'Deals',
  'account.openInContacts': 'Contacts',
  'account.openInSheet': 'Side sheet',
  'account.openInPage': 'Full page',
  'account.timeZone': 'Time zone',
  'account.timeZoneHint': 'Every time is shown in this zone. It is kept with your account, so e-mails and reminders use it too.',
  'settings.timeZone': 'Time zone',
  'settings.timeZoneHint': 'Used where nobody is looking: birthday tasks, automation rules, and a new member\'s times until their device says where they are.',
  'settings.timeZoneFromCountry': 'From the company\'s country',
  'time.enteredAs': 'Entered as {time} in {city} ({offset})',
  'time.bothTimes': '{yours} your time · {theirs} {city}',
  'time.yourTime': '{time} your time ({city})',
  'time.anyTime': 'No time: at any time that day, the same date everywhere',
  'time.search': 'Search for a city or time zone',
  'time.suggested': 'Suggested',
  'time.matching': 'Matching',
  'time.allZones': 'All time zones',
  'time.noMatch': 'No time zone matches.',
  'time.zoneOf': 'Time zone: {zone}',
  'time.chooseZone': 'Choose the time zone',
  'time.nowShownIn': 'Times are now shown in {city} time.',
  'time.change': 'Change',
  'time.automatic': 'Automatic (this device: {zone})',
  'time.automaticShort': 'Automatic',
  'time.calendarIn': 'Times in {zone}',
  'account.callPrompt': 'After calling from the app, offer to log the call',
  'account.notifications': 'Notifications',
  'account.notificationsHint': 'Choose how you want to hear about each kind of event.',
  'account.channel.email': 'Email',
  'account.channel.inApp': 'In the app',
  'account.channel.push': 'On the phone',
  'account.pushHint': 'On the phone means a push to the DoCuLat app, on each phone where you signed in and allowed notifications. Until you choose, it follows In the app.',
  'account.data': 'Your data',
  'account.dataHint': 'Download what DoCuLat keeps about you: profile, memberships, notifications, settings and what was shared with you.',
  'account.download': 'Download my data',
  'account.downloaded': 'Your data was saved as my-data.json.',
  'account.delete': 'Delete my account',
  'account.deleteHint': 'You leave every company, what was shared with you is removed, and your name and address are blanked in audit logs. Not possible while you are the only owner of a company.',
  'account.deleteConfirm': 'Type your email address to confirm',
  'account.deleteButton': 'Delete my account for good',
  'account.deleted': 'Your account is being deleted. Goodbye.',

  'dashboard.membersOnly': 'This page is for the people of this company.',
  'dashboard.overdue': '{count} overdue',
  'dashboard.noTasks': 'Nothing assigned to you. Enjoy it.',
  'dashboard.allTasks': 'All my tasks',
  'dashboard.newestFiles': 'Newest files',
  'dashboard.noFiles': 'Nothing here yet. Upload something, or bring it in from a connected drive.',
  'dashboard.allFiles': 'All files',
  'dashboard.deals': 'Deals',
  'dashboard.noDeals': 'No open deals.',
  'dashboard.inOpenDeals': 'in {count} open deal(s)',
  'dashboard.dealCount': '{count} deal(s)',
  'dashboard.owners.all': 'Whose open deals',
  'dashboard.owners.stage': 'Whose deals in {stage}',
  'dashboard.owners.others.one': 'and {count} other',
  'dashboard.owners.others.other': 'and {count} others',
  'dashboard.won': '{count} won, {amount}',
  'dashboard.edit': 'Edit dashboard',
  'dashboard.addWidget': 'Add widget',
  'dashboard.template': 'Start from',
  'dashboard.template.company': 'The company’s default',
  'dashboard.template.standard': 'Standard',
  'dashboard.template.sales': 'Salesperson',
  'dashboard.template.office': 'Office manager',
  'dashboard.reset': 'Reset to default',
  'dashboard.saveCompany': 'Save as the company’s default',
  'dashboard.saved': 'Dashboard saved',
  'dashboard.companySaved': 'Saved as the company’s default. Everybody who has not arranged their own sees it.',
  'dashboard.resetDone': 'Back to the default dashboard',
  'dashboard.empty': 'No widgets. Edit the dashboard to add some.',
  'dashboard.dragHint': 'Drag to move',
  'dashboard.moveUp': 'Move {name} up',
  'dashboard.moveDown': 'Move {name} down',
  'dashboard.sizeOf': 'Size of {name}',
  'dashboard.size.small': 'Small',
  'dashboard.size.medium': 'Medium',
  'dashboard.size.large': 'Large',
  'dashboard.pipelineOf': 'Pipeline of {name}',
  'dashboard.measureOf': 'What {name} measures',
  'dashboard.periodOf': 'Period of {name}',
  'dashboard.currencyOf': 'Currency of {name}',
  'dashboard.measure.count': 'Number of deals',
  'dashboard.measure.value': 'Value',
  'dashboard.period.month': 'This month',
  'dashboard.period.quarter': 'This quarter',
  'dashboard.period.year': 'This year',
  'dashboard.period.90d': 'The last 90 days',
  'dashboard.funnel': 'Sales funnel',
  'dashboard.funnelByCount': 'Open deals by stage, by number of deals',
  'dashboard.funnelByValue': 'Open deals by stage, by value in {currency}',
  'dashboard.noOpenDeals': 'No open deals in this pipeline.',
  'dashboard.funnel.won': 'Won: {figures}',
  'dashboard.funnel.lost': 'Lost: {figures}',
  'dashboard.winRate': 'Win rate {rate}%',
  'dashboard.team': 'Deals by team member',
  'dashboard.teamByCount': 'Open, won and lost deals by person, by number of deals',
  'dashboard.teamByValue': 'Open, won and lost deals by person, by value in {currency}',
  'dashboard.team.open': '{count} open',
  'dashboard.team.won': '{count} won',
  'dashboard.team.openNow': 'Open now',
  'dashboard.team.wonIn': 'Won: {period}',
  'dashboard.team.lost': '{count} lost',
  'dashboard.team.lostIn': 'Lost: {period}',
  'dashboard.team.teamOf': 'Team: {name}',
  'dashboard.team.allTheirDeals': 'All their deals',
  'dashboard.team.teamDealsOnly': "Only the team's deals",
  'dashboard.team.showFigures': 'Show figures',
  'dashboard.left': '{name} (left)',
  'dashboard.team.others.one': '{count} other person',
  'dashboard.team.others.other': '{count} other people',
  'dashboard.allPipelines': 'All pipelines',
  'dashboard.noDealsYet': 'No deals yet.',
  'dashboard.toBoard': 'Open the board',
  'dashboard.firstPipeline': 'The first pipeline',
  'dashboard.remove': 'Remove {name}',
  'nav.crm': 'Customers',
  'crm.deals': 'Deals',
  'crm.accounts': 'Accounts',
  'crm.contacts': 'Contacts',
  'crm.myTasks': 'My tasks',
  'crm.calendar': 'Calendar',
  'crm.calendarDeals': 'Show deals',
  'crm.calendarBusy': 'Busy',
  'crm.print': 'Print',
  'crm.print.openTasks': 'Open tasks',
  'crm.print.tasksIn': 'Tasks: {statuses}',
  'crm.print.everyone': 'Everybody',
  'crm.print.withDeals': 'with deals',
  'crm.print.withoutDeals': 'without deals',
  'crm.print.printed': 'Printed {date}',
  'crm.print.capped': 'the first {limit} items',
  'crm.list.period': 'Period',
  'crm.list.period.week': 'Week',
  'crm.list.period.2w': '2 weeks',
  'crm.list.period.month': 'Month',
  'crm.list.period.3m': '3 months',
  'crm.list.period.custom': 'Custom',
  'crm.list.from': 'From',
  'crm.list.to': 'To',
  'crm.list.customOrder': 'The end is before the start.',
  'crm.list.customLong': 'At most a year: choose dates closer together.',
  'crm.list.showing': 'Showing {shown} of {total} items',
  'crm.list.items.one': '{count} item',
  'crm.list.items.other': '{count} items',
  'crm.list.showAll': 'Show all',
  'crm.list.tooMany': 'More than {limit} items in this period: choose a shorter period or narrow the filters.',
  'crm.list.empty': 'Nothing in this period.',
  'crm.list.week': 'Week {number} · {from} – {to}',
  'crm.list.overdue': 'Overdue',
  'crm.list.allDay': 'All day',
  'crm.list.deal': 'Deal',
  'crm.calendarPrev.day': 'Previous day',
  'crm.calendarPrev.week': 'Previous week',
  'crm.calendarPrev.month': 'Previous month',
  'crm.calendarPrev.other': 'Back',
  'crm.calendarNext.day': 'Next day',
  'crm.calendarNext.week': 'Next week',
  'crm.calendarNext.month': 'Next month',
  'crm.calendarNext.other': 'Forward',
  'crm.taskMoved': '“{name}” moved to {date}',
  'crm.dealMoved': '“{name}” now expected to close on {date}',
  'crm.moveUndone': 'Moved back.',
  'crm.noAccess': 'Customer records are for the company’s own people.',
  'crm.formerMember': 'a former member',
  'crm.pipeline': 'Pipeline',
  'crm.view': 'View',
  'crm.viewBoard': 'Board',
  'crm.viewList': 'List',
  'crm.boardScroll': 'Scrolling',
  'crm.boardScroll.board': 'One scroll for the board',
  'crm.boardScroll.columns': 'Each column scrolls',
  'crm.newDeal': 'New deal',
  'crm.pipelineIs': 'Pipeline: {name}',
  'crm.closedBetween': 'Closed {from} – {to}',
  'crm.closedSince': 'Closed since {from}',
  'crm.newAccount': 'New account',
  'crm.newContact': 'New contact',
  'crm.newAccountNamed': 'New account “{name}”',
  'crm.newContactNamed': 'New contact “{name}”',
  'crm.editDeal': 'Edit deal',
  'crm.editAccount': 'Edit account',
  'crm.editContact': 'Edit contact',
  'crm.edit': 'Edit',
  'inline.change': 'Change {name}',
  'inline.saving': 'Saving…',
  'crm.amountChanged': 'Amount changed to {amount}',
  'crm.accountChanged': 'Account changed to {name}',
  'crm.stageProbability': '(stage: {percent}%)',
  'crm.probabilityHint': 'Empty: the stage\'s probability',
  'crm.probabilityInvalid': 'Give a whole percent from 0 to 100',
  'crm.dealCreated': 'Deal “{name}” created.',
  'crm.accountCreated': 'Account {name} created.',
  'crm.contactCreated': 'Contact {name} created.',
  'crm.dealCount.one': '{count} deal',
  'crm.dealCount.other': '{count} deals',
  'crm.moveDeal': 'Move {name}',
  'crm.moveTo': 'Move to {stage}',
  'crm.movedTo': '{name} moved to {stage}.',
  'crm.showAll': 'Show all {count}',
  'crm.filters': 'Filters',
  'crm.filterAmount': 'Amount',
  'crm.filterAmountOp': 'Amount comparison',
  'crm.filterInStage': 'In stage over (days)',
  'crm.filterOwner': 'Responsible',
  'crm.filterAnyone': 'Anyone',
  'crm.noOwner': 'No owner',
  'crm.filterMe': 'Me',
  'crm.filterAny': 'Any',
  'crm.filterClear': 'Clear filters',
  'crm.filterClearAll': 'Clear all',
  'crm.daysHere.one': '{count} day here',
  'crm.daysHere.other': '{count} days here',
  'crm.inStageSince': 'In this stage since {date}',
  'crm.searchDeals': 'Search deals',
  'crm.searchAccounts': 'Search accounts',
  'crm.searchContacts': 'Search contacts',
  'crm.status': 'Status',
  'crm.statusAll': 'All',
  'crm.status.open': 'Open',
  'crm.status.won': 'Won',
  'crm.status.lost': 'Lost',
  'crm.stage': 'Stage',
  'crm.stageAll': 'All stages',
  'crm.noDeals': 'No deals here',
  'crm.noDealsInStage': 'No deals in this stage',
  'crm.stages': 'Stages',
  'crm.showStage': 'Show',
  'crm.noAccounts': 'No accounts yet',
  'crm.noAccountsHint': 'Accounts are the companies you work with: customers, prospects, suppliers and partners.',
  'crm.noContacts': 'No contacts yet',
  'crm.nothingFound': 'Nothing found.',
  'crm.dealTitle': 'Title',
  'crm.accountName': 'Name',
  'crm.account': 'Account',
  'crm.contact': 'Contact',
  'crm.callNumber': 'Call {number}',
  'crm.outcome': 'Result',
  'crm.outcome.reached': 'Reached',
  'crm.outcome.no_answer': 'No answer',
  'crm.outcome.left_message': 'Left a message',
  'crm.outcome.wrong_number': 'Wrong number',
  'crm.outcome.missed': 'Missed',
  'crm.outcome.returned': 'Returned their call',
  'crm.callDirection': 'Direction',
  'crm.callDirection.outgoing': 'Outgoing',
  'crm.callDirection.incoming': 'Incoming',
  'crm.callWhen': 'When',
  'crm.callPurpose': 'Purpose',
  'crm.followUp': 'Follow-up',
  'crm.followUp.none': 'None',
  'crm.followUp.again': 'Call again tomorrow',
  'crm.followUp.task': 'Create a follow-up task',
  'crm.callInFuture': 'A call cannot be in the future. Plan it as a task.',
  'crm.callBar': 'Log the call',
  'crm.logCallQuestion': 'Log the call with {name}?',
  'crm.logCallTitle': 'Log the call with {name}',
  'crm.callWith': 'Call with {name}',
  'crm.callAgainSubject': 'Call {name} again',
  'crm.callLogged': 'Call logged.',
  'crm.callLoggedAgain': 'Call logged. Calling again tomorrow is on your tasks.',
  'crm.contactAccounts': 'Accounts',
  'crm.linkAccount': 'Link to an account',
  'crm.noContactAccounts': 'Not linked to any account.',
  'crm.primaryAccount': 'Primary',
  'crm.roleAt': 'Role at {name}',
  'crm.makePrimary': 'Make {name} the primary account',
  'crm.unlinkAccount': 'Unlink from {name}',
  'crm.people': 'People',
  'crm.sortByRole': 'Sort by role',
  'crm.sortByName': 'Sort by name',
  'crm.linkPerson': 'Link a person',
  'crm.unlinkPerson': 'Unlink {name}',
  'crm.link': 'Link',
  'crm.linkPickFirst': 'Choose the {what} first.',
  'crm.role': 'Role',
  'crm.newPrimaryHint': 'This is their primary account, the one their timeline entries are filed under. Choose which account takes its place.',
  'crm.newPrimary': 'New primary account',
  'crm.noPrimary': 'None',
  'crm.unlink': 'Unlink',
  'crm.filedUnder': 'Filed under',
  'crm.role.employee': 'Employee',
  'crm.role.director': 'Director',
  'crm.role.board_member': 'Board member',
  'crm.role.owner': 'Owner',
  'crm.role.consultant': 'Consultant',
  'crm.role.former_employee': 'Former employee',
  'crm.amount': 'Amount',
  'crm.amountInvalid': 'The amount must be a number, like 1250 or 1250.50.',
  'crm.currency': 'Currency',
  'crm.expectedClose': 'Expected close',
  'crm.probability': 'Probability',
  'crm.owner': 'Owner',
  'crm.closedAt': 'Closed',
  'crm.created': 'Created',
  'crm.details': 'Details',
  'crm.kind': 'Type',
  'crm.kindAll': 'All types',
  'crm.kind.prospect': 'Prospect',
  'crm.kind.customer': 'Customer',
  'crm.kind.supplier': 'Supplier',
  'crm.kind.partner': 'Partner',
  'crm.kind.other': 'Other',
  'crm.relation.parent.a': 'Parent company',
  'crm.relation.parent.b': 'Subsidiary',
  'crm.relation.owner.a': 'Owner (shareholder)',
  'crm.relation.owner.b': 'Owned company',
  'crm.relation.head_office.a': 'Head office',
  'crm.relation.head_office.b': 'Branch',
  'crm.relation.partner.a': 'Partner',
  'crm.relation.partner.b': 'Partner',
  'crm.relation.reseller.a': 'Reseller',
  'crm.relation.reseller.b': 'Vendor',
  'crm.relation.competitor.a': 'Competitor',
  'crm.relation.competitor.b': 'Competitor',
  'crm.relatedAccounts': 'Related accounts',
  'crm.group.show': 'Show group',
  'crm.group.crumb': 'Group',
  'crm.group.title': 'Group of {name}',
  'crm.group.totals': 'Group totals',
  'crm.group.accounts': 'Companies',
  'crm.group.won12': 'Won in the last 12 months',
  'crm.group.tooLarge': 'The group is too large: showing the first {count} companies.',
  'crm.group.tree': 'Companies in the group',
  'crm.group.fold': 'Hide the companies under {name}',
  'crm.group.unfold': 'Show the companies under {name}',
  'crm.group.cameFrom': 'You came from here',
  'crm.group.noDeals': 'No open or recently won deals',
  'crm.group.open.one': '{count} open deal',
  'crm.group.open.other': '{count} open deals',
  'crm.group.won': 'won {amount} in 12 months',
  'crm.group.hidden.one': 'And {count} more company you may not see.',
  'crm.group.hidden.other': 'And {count} more companies you may not see.',
  'crm.addRelated': 'Add related account',
  'crm.addRelatedSubmit': 'Add link',
  'crm.noRelated': 'No related accounts yet: add its parent company, subsidiaries, owners or partners.',
  'crm.relationRemoved': 'Link to {name} removed.',
  'crm.relationAdded': 'Linked to {name}.',
  'crm.editRelationNote': 'Note on the link to {name}',
  'crm.removeRelation': 'Remove the link to {name} ({role})',
  'crm.relationIncomplete': 'Choose the kind of link and the other account.',
  'crm.relationThisIs': '{name} is the…',
  'crm.relationOf': '{role} of…',
  'crm.relationOther': 'Other account',
  'crm.relationPreview': 'Here {other} will be listed as {role}; on its page, {name} as {own}.',
  'crm.relationNote': 'Note',
  'crm.relationNoteHint': 'For example 51 % or since 2024',
  'crm.phone': 'Phone',
  'crm.emails': 'Email addresses',
  'crm.phones': 'Phone numbers',
  'crm.addEmail': 'Add an email address',
  'crm.addPhone': 'Add a phone number',
  'crm.kindOf': 'Kind of {name}',
  'crm.primary': 'Primary',
  'crm.primaryOf': 'Primary: {name}',
  'crm.removeOf': 'Remove {name}',
  'crm.emailKind.work': 'Work',
  'crm.emailKind.personal': 'Personal',
  'crm.emailKind.other': 'Other',
  'crm.phoneKind.work': 'Work',
  'crm.phoneKind.mobile': 'Mobile',
  'crm.phoneKind.home': 'Home',
  'crm.phoneKind.fax': 'Fax',
  'crm.phoneKind.other': 'Other',
  'crm.website': 'Website',
  'crm.registrationNo': 'Registration number',
  'crm.vatNo': 'VAT number',
  'crm.vat.firstHint': 'For a company in the EU: type its VAT number and we fill in the name and address.',
  'crm.vat.useRegisteredName': 'Use the registered name “{name}”?',
  'crm.vat.useRegisteredNameText': 'The register calls this company “{name}”. The name you typed is replaced; the address is filled in either way.',
  'crm.vat.useRegisteredNameYes': 'Use it',
  'crm.vat.checkAndFill': 'Check and fill from VIES',
  'crm.vat.unavailable': 'The VAT service of {country} is not answering, try later.',
  'crm.vat.tooMany': 'Too many checks: try again in a minute.',
  'crm.vat.validFilled': 'Valid. Name and address filled from {source} on {date}: check them before saving.',
  'crm.vat.validNothing': 'Valid in {source} ({date}). This country gives no name or address.',
  'crm.vat.invalid': 'Not valid in {source} ({date}).',
  'crm.vat.checkedIn': 'Checked in {source}',
  'crm.vat.validOn': 'Valid · checked {date}',
  'crm.vat.invalidOn': 'Not valid · checked {date}',
  'crm.vat.recheck': 'Check the VAT number again',
  'crm.vat.check': 'Check the VAT number in VIES',
  'crm.city': 'City',
  'crm.country': 'Country',
  'crm.address.legal': 'Legal address',
  'crm.address.office': 'Office address',
  'crm.address.sameAsLegal': 'Same as legal address',
  'crm.address.line1': 'Street and number',
  'crm.address.line2': 'Building, suite',
  'crm.address.city': 'City',
  'crm.address.chooseCountry': 'Choose a country',
  'crm.address.postal.postal': 'Postal code',
  'crm.address.postal.zip': 'ZIP code',
  'crm.address.postal.postcode': 'Postcode',
  'crm.address.postal.pin': 'PIN code',
  'crm.address.postal.eircode': 'Eircode',
  'crm.address.region.state': 'State',
  'crm.address.region.province': 'Province',
  'crm.address.region.county': 'County',
  'crm.address.region.prefecture': 'Prefecture',
  'crm.address.region.region': 'Region',
  'crm.address.copy': 'Copy address',
  'crm.address.work': 'Work address',
  'crm.address.other': 'Other address',
  'crm.address.sameAsAccount': 'Same as the account\'s office address',
  'crm.address.fromAccount': 'The account\'s office address',
  'crm.address.label': 'Label',
  'crm.address.labelSuggestions': 'Home|Summer house|Delivery address|Postal address',
  'crm.address.show': 'Show address',
  'crm.address.showOnMap': 'Show on map',
  'crm.address.navigate': 'Navigate there',
  'crm.address.app.apple': 'Apple Maps',
  'crm.address.app.google': 'Google Maps',
  'crm.address.app.waze': 'Waze',
  'crm.address.copied': 'Address copied.',
  'crm.address.postalInvalid': '{which}: the postal code does not look right for this country. For example: {example}',
  'crm.firstName': 'First name',
  'crm.lastName': 'Last name',
  'crm.jobTitle': 'Job title',
  'crm.salutation': 'Salutation',
  'crm.salutationNone': 'None',
  'crm.salutation.mr': 'Mr',
  'crm.salutation.mrs': 'Mrs',
  'crm.salutation.ms': 'Ms',
  'crm.salutation.mx': 'Mx',
  'crm.salutation.dr': 'Dr',
  'crm.salutation.prof': 'Prof',
  'crm.matched.salutation': 'Salutation',
  'crm.matched.jobTitle': 'Job title',
  'crm.matched.department': 'Department',
  'crm.matched.email': 'Email',
  'crm.matched.phone': 'Phone',
  'crm.matched.account': 'Account',
  'crm.matched.role': 'Role',
  'crm.matched.language': 'Language',
  'crm.matched.address': 'Work address',
  'crm.matched.tag': 'Tag',
  'crm.matched.name': 'Name',
  'crm.matched.field': 'Field',
  'crm.matched.registrationNo': 'Registration number',
  'crm.matched.vatNo': 'VAT number',
  'crm.matched.website': 'Website',
  'crm.matched.legalAddress': 'Legal address',
  'crm.matched.officeAddress': 'Office address',
  'crm.matched.kind': 'Kind',
  'crm.matched.related': 'Related account',
  'crm.matched.contact': 'Contact',
  'crm.addressAs': 'Address as {name}',
  'crm.pronouns': 'Pronouns',
  'crm.pronounsHint': 'For example she/her, he/him or they/them.',
  'crm.department': 'Department',
  'crm.birthday': 'Birthday',
  'crm.birthdayDayMonth': 'Day and month',
  'crm.birthdayYear': 'Year',
  'crm.turnsThisYear': 'turns {age} this year',
  'crm.birthdayIncomplete': 'A birthday needs both the day and the month.',
  'crm.birthdayYearInvalid': 'The year of birth must be between 1900 and this year.',
  'crm.birthdayNoSuchDay': 'That year had no 29 February.',
  'crm.languages': 'Languages',
  'crm.addLanguage': 'Add a language',
  'crm.languagesEu': 'EU languages',
  'crm.languagesOther': 'Other languages',
  'crm.preferredLanguage': 'Preferred',
  'crm.preferredLanguageGroup': 'Preferred language',
  'crm.preferredLanguageOf': 'Preferred language: {name}',
  'crm.preferredLanguageHint': 'The marked one is the language they prefer.',
  'crm.removeLanguage': 'Remove {name}',
  'crm.nameRequired': 'Give a first or a last name.',
  'crm.titleRequired': 'Give the deal a title.',
  'crm.fieldRequired': '{name} is required.',
  'crm.fieldInvalid': '{name} must be a number.',
  'crm.customFields': 'More fields',
  'crm.yes': 'Yes',
  'crm.no': 'No',
  'crm.typeToSearch': 'Type to search…',
  'crm.clearChoice': 'Remove {name}',
  'crm.openDeals': 'Open deals',
  'crm.openAmount': 'Open amount',
  'crm.addContact': 'Add contact',
  'crm.addPhoto': 'Add photo',
  'crm.addPhotoFor': 'Add a photo of {name}',
  'crm.photoMenu': 'Photo of {name}',
  'crm.changePhoto': 'Change photo',
  'crm.removePhoto': 'Remove photo',
  'crm.photoSaved': 'Photo saved.',
  'crm.photoNotSaved': 'The photo was not saved.',
  'crm.photoRemoved': 'Photo removed.',
  'crm.photoTooLarge': 'A photo can be at most 10 MB.',
  'crm.photoUnreadable': 'This image cannot be opened. Choose a JPEG, PNG or WebP image.',
  'crm.cropPhoto': 'Crop the photo',
  'crm.cropPhotoHint': 'Drag the photo and zoom until the face is in the circle.',
  'crm.cropArea': 'Photo to crop. Arrow keys move it.',
  'crm.photoZoom': 'Zoom',
  'crm.usePhoto': 'Use photo',
  'crm.addDeal': 'Add deal',
  'crm.noContactsHere': 'No contacts yet.',
  'crm.noDealsHere': 'No deals yet.',
  'crm.openTotal': 'Open: {amount}',
  'crm.closedDeals': 'Closed',
  'crm.moreDeals': 'The first {count} are shown.',
  'crm.emailTo': 'E-mail {name}',
  'crm.deleteDealConfirm': 'Delete the deal “{name}”?',
  'crm.deleteDealTitle': 'Delete the deal “{name}”?',
  'crm.deleteAccountConfirm': 'Delete the account {name}? Its contacts and deals stay, without an account.',
  'crm.deleteAccountTitle': 'Delete the account {name}?',
  'crm.deleteContactConfirm': 'Delete the contact {name}?',
  'crm.deleteContactTitle': 'Delete the contact {name}?',
  'crm.erase': 'Erase personal data',
  'crm.eraseHint': 'When the person asks to be forgotten (GDPR)',
  'crm.eraseConfirm': 'Erase {name} for good? The contact and every timeline entry about this person are deleted; deals stay, without the person. This cannot be undone.',
  'crm.eraseButton': 'Erase for good',
  'crm.erased': 'The contact was erased.',
  'crm.timeline': 'Timeline',
  'crm.timelineEmpty': 'Nothing here yet. Add a note, a call or a task above.',
  'comm.title': 'Communication preferences',
  'comm.preset.business': 'Business correspondence',
  'comm.preset.newsletter': 'Newsletter and marketing emails',
  'comm.preset.events': 'Event invitations',
  'comm.preset.calls': 'Phone calls',
  'comm.preset.sms': 'Text messages',
  'comm.state.allowed': 'Allowed',
  'comm.state.denied': 'Not allowed',
  'comm.state.not_asked': 'Not asked',
  'comm.state.not_set': 'Not set',
  'comm.titleCompany': 'Communication preferences (whole company)',
  'comm.companyHint': 'What the company as a whole agrees to. Its people follow it unless they have said otherwise themselves.',
  'comm.followsCompany': 'Where this person has said nothing, the company-wide preferences of {name} apply.',
  'comm.fromCompany': '{state} (company)',
  'comm.onCompany': 'On (company)',
  'comm.overridesCompany': 'The company does not allow this; the person agreed on {date}.',
  'comm.noticeBlockedCompany': 'Do not contact anyone at {name} (company-wide).',
  'comm.doNotContactCompanyHint': 'applies to all its people who have not allowed contact themselves',
  'comm.howCompany': 'How did the company tell you?',
  'comm.method.in_person': 'Told in person',
  'comm.method.phone': 'By phone',
  'comm.method.email': 'By email',
  'comm.method.signed_form': 'Signed form',
  'comm.method.web_form': 'Web form',
  'comm.method.other': 'Other',
  'comm.doNotContact': 'Do not contact',
  'comm.doNotContactHint': 'overrides every category',
  'comm.on': 'On',
  'comm.off': 'Off',
  'comm.edit': 'Record a change',
  'comm.history': 'History',
  'comm.historyTitle': 'History of communication preferences',
  'comm.historyEmpty': 'No changes recorded yet.',
  'comm.how': 'How did they tell you?',
  'comm.note': 'Note',
  'comm.saved': 'Communication preferences saved.',
  'comm.since': '{date} · {name}',
  'comm.noticeBlocked': 'Do not contact this person.',
  'comm.noticeLimited': 'Not allowed: {categories}',
  'comm.listBlocked': 'Do not contact',
  'comm.listLimited': 'Some kinds of contact are not allowed',
  'crm.timelineTabs': 'Show on the timeline',
  'crm.tab.all': 'All',
  'crm.tab.notes': 'Notes',
  'crm.tab.tasks': 'Tasks',
  'crm.tab.contacts': 'Contacts',
  'crm.tab.changes': 'Changes',
  'crm.tab.people': 'People',
  'crm.tab.deals': 'Deals',
  'crm.tab.files': 'Files',
  'crm.touch.sent': 'Emails sent',
  'crm.touch.received': 'Emails received',
  'crm.touch.call': 'Calls',
  'crm.touch.meeting': 'Meetings',
  'crm.timelineNarrow': 'Person or deal',
  'crm.timelineEveryone': 'Everyone and every deal',
  'crm.timelineTabEmpty': 'Nothing of this kind yet.',
  'crm.emailDirection': 'Which way',
  'crm.direction.sent': 'Sent',
  'crm.direction.received': 'Received',
  'crm.emailSent': 'Email sent',
  'crm.emailReceived': 'Email received',
  'crm.mailFrom': 'From {address}',
  'crm.mailTo': 'To {addresses}',
  'crm.mailCc': 'Cc {addresses}',
  'crm.activityType': 'Kind of entry',
  'crm.activity.note': 'Note',
  'crm.activity.task': 'Task',
  'crm.activity.call': 'Call',
  'crm.activity.meeting': 'Meeting',
  'crm.activity.email': 'Email',
  'crm.category': 'Kind of task',
  'crm.category.todo': 'To-do',
  'crm.category.call': 'Call',
  'crm.category.meeting': 'Meeting',
  'crm.category.email': 'E-mail',
  'crm.category.birthday': 'Birthday',
  'crm.taskStatus.todo': 'To do',
  'crm.taskStatus.in_progress': 'In progress',
  'crm.taskStatus.waiting': 'Waiting',
  'crm.taskStatus.done': 'Done',
  'crm.filterEveryone': 'Everyone',
  'crm.noMatchingTasks': 'No task matches these filters.',
  'crm.add.note': 'Add note',
  'crm.add.task': 'Add task',
  'crm.add.call': 'Log call',
  'crm.add.meeting': 'Log meeting',
  'crm.add.email': 'Log email',
  'crm.subject': 'Subject',
  'crm.dueAt': 'Due',
  'crm.assignedTo': 'Assigned to',
  'crm.newTask': 'New task',
  'crm.taskAdded': 'Task added: {name}',
  'crm.dueInPast': 'This date is in the past.',
  'crm.addTaskOn': 'Add a task on {date}',
  'crm.editTask': 'Edit task',
  'crm.editTaskNamed': 'Edit “{name}”',
  'crm.belongsTo': 'Belongs to',
  'crm.belongsToHint': 'A deal, account or contact, or leave empty',
  'crm.ownTaskHint': 'A task that belongs to no deal, account or contact is seen only by you, the person it is assigned to, and the company’s owners and admins. It does not appear in search.',
  'crm.recordKind.deal': 'Deal',
  'crm.recordKind.account': 'Account',
  'crm.recordKind.contact': 'Contact',
  'crm.recordKind.task': 'Task',
  'crm.taskSaved': 'Task saved',
  'crm.notAssigned': 'Not assigned',
  'crm.assignedToName': 'for {name}',
  'crm.activityAdded': 'Added to the timeline.',
  'crm.timelineAdd': 'Add to the timeline',
  'crm.timelineShow': 'Show',
  'crm.addedElsewhere.note': 'Note added',
  'crm.addedElsewhere.task': 'Task added',
  'crm.addedElsewhere.call': 'Call logged',
  'crm.addedElsewhere.meeting': 'Meeting added',
  'crm.addedElsewhere.email': 'Email added',
  'crm.deleteEntry': 'Delete “{name}”',
  'crm.deleteEntryConfirm': 'Delete “{name}” from the timeline?',
  'crm.deleteEntryTitle': 'Delete “{name}”?',
  'crm.overdue': 'Overdue since {date}',
  'crm.files': 'Files',
  'crm.attachFile': 'Attach a file',
  'crm.chooseFile': 'Choose files from the company drive',
  'crm.attach': 'Attach',
  'crm.attachNamed': 'Attach {name}',
  'crm.fileAttached': '{name} attached.',
  'crm.filesAttached.one': '{count} file attached.',
  'crm.filesAttached.other': '{count} files attached.',
  'crm.attachFailed': 'Not attached: {name} ({reason})',
  'crm.picker.search': 'Search all folders by name',
  'crm.picker.recent': 'Recent',
  'crm.picker.browse': 'Browse',
  'crm.picker.linked': 'Linked here',
  'crm.picker.sort': 'Sort by',
  'crm.picker.sort.used': 'Last used',
  'crm.picker.sort.name': 'Name',
  'crm.picker.sort.changed': 'Date changed',
  'crm.picker.attached': 'Attached',
  'crm.picker.preview': 'Preview {name}',
  'crm.picker.previewHint': 'Preview',
  'crm.picker.attachCount.one': 'Attach {count} file',
  'crm.picker.attachCount.other': 'Attach {count} files',
  'crm.picker.noneFound': 'No file has “{text}” in its name.',
  'crm.picker.noRecent': 'Files you open, upload or attach show here.',
  'crm.picker.noLinked': 'Nothing is linked here yet.',
  'crm.picker.searchingAll': 'Searching all folders…',
  'crm.picker.found.one': '{count} file found in all folders',
  'crm.picker.found.other': '{count} files found in all folders',
  'crm.picker.foundMore': 'More than {count} files found: type more of the name.',
  'crm.taskFiles.one': '{count} file attached',
  'crm.taskFiles.other': '{count} files attached',
  'crm.filesOfTasks': 'On its tasks',
  'crm.assigneeCannotOpen': '{name} cannot open this file.',
  'crm.shareWith': 'Share with {name}',
  'crm.sharedWith': 'Shared with {name}.',
  'crm.sharedPending': 'Shared with {name}: they can open it the next time they open DoCuLat.',
  'crm.tags': 'Tags',
  'crm.moreFilters': 'More filters',
  // Contacts: not contacted lately, missing details, count and chips (TF-56).
  'crm.lastContacted': 'Last contacted',
  'crm.lastContacted.any': 'Any time',
  'crm.lastContacted.3m': 'Not in 3 months',
  'crm.lastContacted.6m': 'Not in 6 months',
  'crm.lastContacted.12m': 'Not in 12 months',
  'crm.lastContacted.never': 'Never',
  'crm.sortOldestFirst': 'Sort by last contacted, oldest first',
  'crm.missing': 'Missing details',
  'crm.missing.firstName': 'No first name',
  'crm.missing.lastName': 'No last name',
  'crm.missing.email': 'No e-mail',
  'crm.missing.phone': 'No phone',
  'crm.missing.account': 'No account',
  'crm.missing.jobTitle': 'No job title',
  'crm.missing.registrationNo': 'No registration number',
  'crm.missing.vatNo': 'No VAT number',
  'crm.missing.legalAddress': 'No legal address',
  'crm.missing.industry': 'No industry',
  'crm.missing.owner': 'No owner',
  'crm.missingMode.any': 'Missing any of them',
  'crm.missingMode.all': 'Missing all of them',
  'crm.filterChosen.one': '{count} chosen',
  'crm.filterChosen.other': '{count} chosen',
  'crm.filterChip': '{filter}: {value}',
  'crm.searchChip': 'Search',
  'crm.activeFilters': 'Active filters',
  'crm.removeFilter': 'Remove filter {name}',
  'crm.contactCount.one': '{count} contact',
  'crm.contactCount.other': '{count} contacts',
  'crm.contactCountMore': 'More than {count} contacts',
  'crm.accountCount.one': '{count} account',
  'crm.accountCount.other': '{count} accounts',
  'crm.accountCountMore': 'More than {count} accounts',
  'crm.prefBy': 'Preferences by',
  'crm.prefBy.own': 'Person\'s own',
  'crm.prefBy.company': 'Company\'s',
  'crm.classification': 'Classification',
  'crm.personal': 'Personal',
  'crm.personalHint': 'Seen only by the contact\'s owner and the company\'s owners and admins.',
  'crm.shares.title': 'Shared with',
  'crm.shares.dialogTitle.contact': 'Share this contact',
  'crm.shares.dialogTitle.account': 'Share this account',
  'crm.shares.dialogTitle.deal': 'Share this deal',
  'crm.shares.hint.contact': 'The colleagues you choose see this contact\'s personal details, as its owner does, and the contact itself while it is private.',
  'crm.shares.hint.account': 'While the account is private, the colleagues you choose see it too.',
  'crm.shares.hint.deal': 'While the deal is private, the colleagues you choose see it too, with its notes and tasks.',
  'crm.private.mark': 'Private',
  'crm.private.label': 'Private',
  'crm.private.hint.contact': 'Only its owner, the colleagues it is shared with and the company\'s owners and admins see this contact.',
  'crm.private.hint.account': 'Only its owner, the colleagues it is shared with and the company\'s owners and admins see this account. Its contacts and deals have a switch of their own.',
  'crm.private.hint.deal': 'Only its owner, the colleagues it is shared with and the company\'s owners and admins see this deal, with its notes and tasks.',
  'crm.private.notYours': 'Only its owner and the company\'s owners and admins change this.',
  'crm.shares.nobody': 'Nobody else',
  'crm.shares.change': 'Change',
  'crm.shares.noColleagues': 'There is nobody else in the company to share it with.',
  'crm.shares.colleagues': 'Colleagues',
  'crm.shares.saved': 'Sharing saved.',
  'crm.shares.tagKeepsOut': 'A sensitive tag on this record keeps this colleague out. Sharing alone does not let them open it.',
  'crm.shares.mine': 'My contacts',
  'crm.copiedFrom': 'Copied from {name}',
  'crm.columns': 'Columns',
  'crm.clearCustomFilters': 'Clear these filters',
  'crm.addTag': 'Add a tag',
  'crm.createTag': 'Create tag “{name}”',
  'crm.removeTag': 'Remove tag {name}',
  'crm.filterByTag': 'Filter by tag',
  'crm.removeTagFilter': 'Stop filtering by {name}',
  'crm.tagMode': 'Which tags must match',
  'crm.tagMode.any': 'Any of these',
  'crm.tagMode.all': 'All of these',
  'crm.tagMode.anyShort': 'Any',
  'crm.tagMode.allShort': 'All',
  'crm.tagsChosen': 'Tags chosen',
  'crm.selectRow': 'Select {name}',
  'crm.selectTasks': 'Select',
  'crm.selectAll': 'Select all shown',
  'crm.selectedCount': '{count} selected',
  'crm.bulkAddTag': 'Add a tag to the selected',
  'crm.bulkRemoveTag': 'Remove a tag from the selected',
  'crm.bulkTagged': '“{name}” added to {count}.',
  'crm.bulkUntagged': '“{name}” removed from {count}.',
  'crm.clearSelection': 'Clear selection',
  'crm.uploadTo': 'New files go to {path}.',
  'crm.uploadToChange': 'Change',
  'crm.uploadHere': 'Upload here',
  'crm.uploadRestricted': 'This folder is restricted: colleagues who cannot open it will not see these files here.',
  'crm.uploadNoRights': 'You cannot add files to this folder. Choose another one.',
  'crm.dropToUpload': 'Drop the files to upload them to {path}',
  'crm.uploadNotAttached': 'The file is in the drive, but it could not be attached here: {reason}',
  'crm.detach': 'Detach {name}',
  'crm.detachHint': 'Removes the link; the file stays in the drive',
  'crm.noFiles': 'No files attached.',
  'crm.uploadsStay.one': '{count} uploaded file stays in {path}.',
  'crm.uploadsStay.other': '{count} uploaded files stay in {path}.',
  'crm.hiddenFiles.one': '{count} more file you have no access to.',
  'crm.hiddenFiles.other': '{count} more files you have no access to.',
  'crm.noTasks': 'No tasks for you',
  'crm.noTasksHint': 'Tasks assigned to you on accounts, contacts and deals show up here.',
  'crm.taskDone': 'Done: {name}',
  'crm.taskNotFound': 'This task does not exist, or you may not see it.',
  'crm.noDetails': 'No details.',
  'crm.addedByOn': 'Added by {name}, {date}',
  'crm.doneOn': 'Done {date}',
  'crm.ownTaskShort': 'Nothing: a task of its own',
  'crm.tasks.overdue': 'Overdue',
  'crm.tasks.today': 'Today',
  'crm.tasks.upcoming': 'Coming up',
  'crm.tasks.someday': 'No due date',
  'crm.tasks.done': 'Done',

  'nav.settings': 'Settings',
  'nav.moreSettings': 'More settings',
  'nav.moreSections': 'More sections',
  'nav.signing': 'Signatures',
  'settings.adminsOnly': 'Only the company’s owners and admins can see this.',
  'settings.fields': 'Custom fields',
  'settings.tags': 'Tags',
  'settings.tagsIntro': 'Anybody in the company adds tags while tagging a contact, an account or a deal. Here owners and admins add one ahead of use, rename them, merge two that mean the same, and delete them.',
  'settings.newTag': 'New tag',
  'settings.tagAdded': 'Added “{name}”.',
  'settings.tagExists': '“{name}” is there already.',
  'settings.relationTypes': 'Relation types',
  'settings.accountLinks': 'Links between accounts',
  'settings.contactRoles': 'Contact roles',
  'settings.contactRolesIntro': 'What a person can be at an account: employee, director, board member and so on. A contact can be linked to several accounts, with a role at each.',
  'settings.addContactRole': 'Add a role',
  'settings.communication': 'Communication preferences',
  'settings.communicationIntro': 'The kinds of contact you ask your contacts about. On each contact you record whether they allowed it, when and how. Standard categories are shown in each person\'s language until you rename them.',
  'settings.addCategory': 'Add a category',
  'settings.categoryName': 'Name',
  'settings.categoryUses': 'Recorded',
  'settings.categoryUsesCount': 'Recorded: {count}',
  'settings.editCategory': 'Rename {name}',
  'settings.deleteCategory': 'Delete {name}',
  'settings.switchOffCategory': 'Switch off {name}',
  'settings.switchOnCategory': 'Switch on {name}',
  'settings.categoryKeep': 'Standard categories and categories with something recorded are switched off, not deleted: the history is proof of consent.',
  'settings.deleteCategoryConfirm': 'Nothing has been recorded under this category. It will be gone from the list.',
  'settings.categoryDeleted': '{name} deleted.',
  'settings.categoryAdded': '{name} added.',
  'settings.addRelationType': 'Add a type',
  'settings.relationTypesIntro': 'How accounts can be linked to each other. Each type has a name for each side, because a link reads differently from each end: a parent company and its subsidiary. Standard types are shown in each person\'s language until you rename them.',
  'settings.relationType': 'Type',
  'settings.relationUses': 'Links',
  'settings.relationChain': 'Chain',
  'settings.relationOff': 'Off',
  'settings.relationUsesCount': 'Links: {count}',
  'settings.editRelationType': 'Edit {name}',
  'settings.switchOffRelation': 'Switch off {name}',
  'settings.switchOnRelation': 'Switch on {name}',
  'settings.relationSwitchedOff': '{name} switched off: existing links stay, no new ones can be added.',
  'settings.relationSwitchedOn': '{name} switched on.',
  'settings.deleteRelationType': 'Delete {name}',
  'settings.relationKeep': 'Standard types and types in use are switched off, not deleted.',
  'settings.deleteRelationTypeConfirm': 'No link uses this type. It will be gone from the list.',
  'settings.relationTypeDeleted': '{name} deleted.',
  'settings.relationNamesMissing': 'Give both sides a name.',
  'settings.relationTypeAdded': '{name} added.',
  'settings.relationNamesHint': 'Name each side as what that account is to the other, for example Parent company and Subsidiary. For a link that reads the same both ways, such as Partner, use the same name twice.',
  'settings.relationNameA': 'One side',
  'settings.relationNameB': 'The other side',
  'settings.relationStandardHint': 'Leave a name empty to use the standard one, in each person\'s language.',
  'settings.relationChainLabel': 'A chain with a top (no loops)',
  'settings.relationChainHint': 'For parent companies, head offices and owners: an account cannot end up above itself.',
  'settings.relationChainLocked': 'This type is in use, so it cannot become a chain now. Add a new type instead.',
  'settings.tagsEmpty': 'No tags yet. They appear here as soon as somebody tags a contact or an account.',
  'settings.tagName': 'Tag',
  'settings.tagUse': 'Used on',
  'settings.tagType': 'Type',
  'settings.tagSensitive': 'Sensitive',
  'settings.tagNotUsed': 'Not used',
  'settings.tagTaskCount.one': '{count} task',
  'settings.tagTaskCount.other': '{count} tasks',
  'settings.mergeTag': 'Merge {name} into another tag',
  'settings.mergeInto': 'Merge into',
  'settings.mergeHint': 'Every account and contact tagged “{name}” gets the chosen tag instead, and “{name}” is removed.',
  'settings.merge': 'Merge',
  'settings.deleteTag': 'Delete {name}',
  'settings.deleteTagConfirm': 'Delete the tag “{name}”? It is taken off {count} records. The records themselves stay.',
  'settings.tagMerged': '“{name}” merged into “{into}”.',
  'settings.tagDeleted': 'Tag “{name}” deleted.',
  'tags.sensitive': 'sensitive',
  'tags.level.none': 'None',
  'tags.level.visible': 'Visible',
  'tags.level.read': 'Read',
  'tags.level.change': 'Change',
  'tags.level.share_internal': 'Share internal',
  'tags.level.share_external': 'Share external',
  'tags.warnTitle': 'Put on “{name}”?',
  'tags.warn': '“{name}” is a sensitive tag. Your level on it: {level}. Once it is on, you may no longer open or change what you tag.',
  'tags.putOnAnyway': 'Put it on',
  'tags.removeHint': 'Only people with Change on a sensitive tag, and the company’s owners, can take it off.',
  'tags.recordsAndDocuments': '{records} and {documents}',
  'tags.sensitiveIntro': 'A sensitive tag adds one more layer of access. A record or document with it is open only to the teams and people its table names, and only as far as their usual access allows.',
  'tags.planNeeded': 'Sensitive tags are on the Business plan.',
  'tags.seePlans': 'See the plans',
  'tags.makeSensitive': 'Make sensitive',
  'tags.makeSensitiveTitle': 'Make {name} sensitive?',
  'tags.onConfirm': 'Now on: {counted}. Once “{name}” is sensitive, what has it is open only to the owners and to the teams and people you name in its table. The table starts empty.',
  'tags.aTeam': 'Team',
  'tags.layerNote': 'The tag never gives access by itself: a person also needs their usual access to the record or document.',
  'tags.levelsHint': 'Visible: sees it is there. Read: opens it. Change: edits it and may take the tag off. Share internal: shares it inside the company. Share external: shares it outside. Each level includes the ones before it.',
  'tags.table': 'Who gets which level',
  'tags.tableEmpty': 'Nobody yet: only the owners reach what has this tag.',
  'tags.levelOf': 'Level for {name}',
  'tags.removeRow': 'Take {name} out of the table',
  'tags.addRow': 'Add a team or a person',
  'tags.whoGetsWhat': 'Each person’s level',
  'tags.nobodyYet': 'Nobody has a level yet.',
  'tags.via': 'through {teams}',
  'tags.savedOnly': 'This list shows the table as saved.',
  'settings.editTag': 'Edit {name}',
  'tags.nameSection': 'Name',
  'tags.accessSection': 'Access',
  'tags.nameNotSaved': 'The name was not saved: {reason}',
  'tags.accessNotSaved': 'The access was not saved: {reason}',
  'tags.tagSaved': '“{name}” saved.',
  'tags.makeNormal': 'Make it a normal tag',
  'tags.makeNormalTitle': 'Make {name} a normal tag?',
  'tags.offConfirm': 'Now on: {counted}. Its table is deleted, and all of these become reachable again by everybody’s usual access.',
  'tags.ownersOnly': 'Only an owner can do this to a sensitive tag.',
  'tags.reachableAgain': 'It is a sensitive tag: what it protects becomes reachable again by everybody’s usual access.',
  'tags.mergeSensitiveHint': 'A sensitive tag merges only into another sensitive tag, which keeps its own table.',
  'tags.records.one': '{count} record',
  'tags.records.other': '{count} records',
  'tags.documents.one': '{count} document',
  'tags.documents.other': '{count} documents',
  'settings.fieldsHint': 'Fields of your own on accounts, contacts and deals: they appear in the forms and on each record.',
  'settings.fieldsFor': 'Fields for',
  'settings.entity.account': 'Accounts',
  'settings.entity.contact': 'Contacts',
  'settings.entity.deal': 'Deals',
  'settings.noFields': 'No custom fields yet.',
  'settings.fieldLabel': 'Label',
  'settings.fieldKey': 'Stored as {key}',
  'settings.fieldType': 'Type',
  'settings.fieldType.text': 'Text',
  'settings.fieldType.number': 'Number',
  'settings.fieldType.date': 'Date',
  'settings.fieldType.boolean': 'Yes / no',
  'settings.fieldType.select': 'One choice',
  'settings.fieldType.multiselect': 'Several choices',
  'settings.fieldClassification': 'Classification: its own section on the account, and a list column',
  'settings.fieldPersonal': 'Personal (owner and admins only)',
  'settings.fieldPublicForm': 'May be on a website form',
  'settings.fieldPublicFormNote': "This field's name and its choices can be seen by anyone who opens your form.",
  'settings.offFormsTitle': 'Take the fields off the forms?',
  'settings.offFormsConfirm': 'These forms still ask a field that can no longer be on a website form: {forms}. Saving takes it off them. Answers already received are kept.',
  'settings.offFormsSave': 'Take off and save',
  'settings.personalArticle9': 'Details that reveal religion, health or similar (for example halal, kosher, gluten-free) are special-category data under GDPR Article 9: record them only with the contact\'s explicit consent.',
  'settings.suggestedPersonal': 'Suggested personal fields:',
  'settings.suggest.interests': 'Interests',
  'settings.suggest.interestsOptions': 'Sports|Music|Travel|Reading|Art and culture|Technology|Nature|Wine and food',
  'settings.suggest.hobbies': 'Hobbies',
  'settings.suggest.hobbiesOptions': 'Golf|Tennis|Running|Cycling|Fishing|Hunting|Sailing|Skiing',
  'settings.suggest.food': 'Food preferences',
  'settings.suggest.foodOptions': 'Vegetarian|Vegan|Pescatarian|Other',
  'settings.fieldActive': 'Switched on',
  'settings.fieldStandardKeep': 'A standard classification is switched off, not removed.',
  'settings.fieldOptionAt': '{name}: a choice cannot start with "@".',
  'settings.topicsHint': 'Add the product lines or services you sell, for example e-invoicing or fleet leasing: then each person can be marked with what they want to hear about.',
  'fields.preset.industry': 'Industry',
  'fields.preset.company_size': 'Company size',
  'fields.preset.segment': 'Customer segment',
  'fields.preset.region': 'Region',
  'fields.preset.area': 'Area of responsibility',
  'fields.preset.topics': 'Topics of interest',
  'fields.option.nace.A': 'Agriculture, forestry and fishing',
  'fields.option.nace.B': 'Mining and quarrying',
  'fields.option.nace.C': 'Manufacturing',
  'fields.option.nace.D': 'Electricity, gas, steam and air conditioning',
  'fields.option.nace.E': 'Water supply, sewerage and waste management',
  'fields.option.nace.F': 'Construction',
  'fields.option.nace.G': 'Wholesale and retail trade, vehicle repair',
  'fields.option.nace.H': 'Transportation and storage',
  'fields.option.nace.I': 'Accommodation and food service',
  'fields.option.nace.J': 'Information and communication',
  'fields.option.nace.K': 'Financial and insurance activities',
  'fields.option.nace.L': 'Real estate activities',
  'fields.option.nace.M': 'Professional, scientific and technical activities',
  'fields.option.nace.N': 'Administrative and support services',
  'fields.option.nace.O': 'Public administration and defence',
  'fields.option.nace.P': 'Education',
  'fields.option.nace.Q': 'Human health and social work',
  'fields.option.nace.R': 'Arts, entertainment and recreation',
  'fields.option.nace.S': 'Other service activities',
  'fields.option.nace.T': 'Households as employers',
  'fields.option.nace.U': 'Extraterritorial organisations',
  'fields.option.size.micro': 'Micro (under 10 people)',
  'fields.option.size.small': 'Small (10–49)',
  'fields.option.size.medium': 'Medium (50–249)',
  'fields.option.size.large': 'Large (250 or more)',
  'fields.option.region.riga': 'Rīga',
  'fields.option.region.pieriga': 'Pierīga',
  'fields.option.region.vidzeme': 'Vidzeme',
  'fields.option.region.kurzeme': 'Kurzeme',
  'fields.option.region.zemgale': 'Zemgale',
  'fields.option.region.latgale': 'Latgale',
  'fields.option.region.abroad': 'Abroad',
  'fields.option.area.management': 'Management',
  'fields.option.area.finance': 'Finance and accounting',
  'fields.option.area.sales': 'Sales',
  'fields.option.area.marketing': 'Marketing',
  'fields.option.area.purchasing': 'Purchasing',
  'fields.option.area.logistics': 'Logistics',
  'fields.option.area.production': 'Production',
  'fields.option.area.it': 'IT',
  'fields.option.area.hr': 'HR',
  'fields.option.area.legal': 'Legal',
  'settings.fieldRequired': 'Required',
  'settings.fieldOptions': 'Choices, one per line',
  'settings.fieldChoices': 'Choices',
  'settings.choiceNamed': 'Choice {name}',
  'settings.removeChoice': 'Remove the choice {name}',
  'settings.removeChoicesTitle': 'Remove choices?',
  'settings.removeChoicesConfirm': 'These choices will be removed, and taken off every record that has them: {choices}.',
  'settings.removeChoicesSave': 'Remove and save',
  'settings.fieldOptionPipe': 'A choice of {name} contains “|”, which cannot be used.',
  'settings.addField': 'Add field',
  'settings.moveUp': 'Move {name} up',
  'settings.moveDown': 'Move {name} down',
  'settings.removeField': 'Remove {name}',
  'settings.unsaved': 'Unsaved changes',
  'settings.fieldsSaved': 'Custom fields saved.',
  'settings.fieldLabelMissing': 'Every field needs a label.',
  'settings.fieldOptionsMissing': 'Give {name} at least one choice.',
  'settings.fieldsRemovedHint': 'A removed field disappears from forms and records; the values already entered are kept and come back if you add a field with the same key.',
  'settings.integrations': 'Integrations',
  'settings.marketplace': 'Marketplace',
  'marketplace.title': 'Marketplace',
  'marketplace.hint': 'Everything DoCuLat can connect or switch on for the company. What you switch off disappears for everybody in it; members only ever see what is on.',
  'marketplace.search': 'Search the Marketplace',
  'marketplace.category': 'Category',
  'marketplace.categoryAll': 'All categories',
  'marketplace.category.files': 'Files and drives',
  'marketplace.category.signing': 'Signing',
  'marketplace.category.email': 'E-mail and calendar',
  'marketplace.category.money': 'Money',
  'marketplace.category.automation': 'Automation and API',
  'marketplace.category.data': 'Data',
  'marketplace.category.assistants': 'Assistants',
  'marketplace.show': 'Show',
  'marketplace.stateAll': 'All',
  'marketplace.stateEnabled': 'On',
  'marketplace.stateAvailable': 'Available',
  'marketplace.stateComing': 'Coming soon',
  'marketplace.kind.integration': 'Integration',
  'marketplace.kind.tool': 'Tool',
  'marketplace.on': 'On',
  'marketplace.off': 'Off',
  'marketplace.switchFor': 'Switched on: {name}',
  'marketplace.switchedOn': '{name} is switched on.',
  'marketplace.switchedOff': '{name} is switched off.',
  'marketplace.interested': 'I\'m interested',
  'marketplace.interestHint': 'We count every company that asks, to know what to build first.',
  'marketplace.interestSaved': 'Thank you: {name} is counted as wanted.',
  'marketplace.interestRemoved': 'No longer counted: {name}.',
  'marketplace.priceCompany': '{price} a month',
  'marketplace.pricePerson': '{price} per person a month',
  'marketplace.notOnPlan': 'Not on your plan',
  'marketplace.onPlans': 'On these plans: {plans}',
  'marketplace.changePlan': 'Plan and billing',
  'marketplace.confirmTitle': 'Switch on {name}?',
  'marketplace.confirmText': '{name} costs {price} a month, charged from this month. Switching it off later refunds nothing for a month it was on.',
  'marketplace.confirmOk': 'Switch on',
  'marketplace.notSetUp': 'Not set up on this installation yet.',
  'marketplace.editingIncluded': 'Included for everyone on your plan.',
  'marketplace.editingAddon': 'Per person: switch it on for the people who need it in Members.',
  'marketplace.editingNone': 'Not on your plan: documents open read-only.',
  'marketplace.openMembers': 'Members',
  'marketplace.openAutomation': 'Open the rules',
  'marketplace.openForms': 'Open the forms',
  'marketplace.otherConnections': 'Other connections',
  'marketplace.noMatch': 'Nothing matches: try another category or word.',
  'marketplace.automationOff': 'Automation is switched off for the company. An owner or admin can switch it on in the Marketplace.',
  'settings.integrationsHint': 'Accounts DoCuLat may use on the company’s behalf. Credentials are stored encrypted and never shown again.',
  'settings.provider.microsoft': 'OneDrive and SharePoint files.',
  'settings.provider.google': 'Google Drive files.',
  'settings.provider.google-contacts': 'Your own Google Contacts, to import them into the CRM (read only).',
  'settings.provider.microsoft-contacts': 'Your own Outlook or Microsoft 365 contacts, to import them into the CRM (read only).',
  'settings.provider.microsoft-mail': 'Your own Outlook or Microsoft 365 mailbox, so e-mails with the company\'s contacts are logged by themselves (read only).',
  'settings.provider.microsoft-calendar': 'Your own Outlook or Microsoft 365 calendar, kept in step with your DoCuLat meetings both ways.',
  'settings.provider.google-calendar': 'Your own Google Calendar, kept in step with your DoCuLat meetings both ways.',
  'settings.provider.google-mail': 'Your own Gmail or Google Workspace mailbox, so e-mails with the company\'s contacts are logged by themselves (read only).',
  'settings.adminConsentLink': 'Microsoft administrator? Approve it for your whole organisation.',
  'settings.provider.dokobit': 'Electronic signatures (Smart-ID, Mobile-ID, ID cards) for documents sent for signature.',
  'settings.provider.demo': 'A test provider for trying the connection flow.',
  'settings.connected': 'Connected',
  'settings.notConnected': 'Not connected',
  'settings.connectedSince': 'connected {date}',
  'settings.connect': 'Connect {provider}',
  'settings.connectShort': 'Connect',
  'settings.disconnect': 'Disconnect',
  'settings.disconnectConfirm': 'Disconnect {provider}? DoCuLat stops using this account and forgets its credentials.',
  'settings.disconnectTitle': 'Disconnect {provider}?',
  'settings.apiToken': 'API token',
  'settings.environment': 'Environment',
  'settings.env.sandbox': 'Sandbox (testing)',
  'settings.env.production': 'Production',
  'settings.oauth.connected': '{provider} is connected.',
  'settings.oauth.denied': 'Connecting {provider} was cancelled on its sign-in page.',
  'settings.oauth.expired': 'Connecting {provider} took too long. Please try again.',
  'settings.oauth.failed': 'Connecting {provider} did not work. Please try again.',
  'settings.oauth.adminConsent': 'Only an administrator of your organisation can approve {provider}.',
  'settings.oauth.adminConsented': 'Your administrator approved {provider}.',
  'settings.automation': 'Automation',
  'automation.hint': 'Rules do routine work when something happens: “when a deal is won, create a folder and a task”. A rule acts with the permissions of the admin who wrote it.',
  'automation.newRule': 'New rule',
  'automation.editRule': 'Edit rule',
  'automation.noRules': 'No rules yet',
  'automation.noRulesHint': 'For example: when a deal is won, create a folder for its contract and a task to send the invoice.',
  'automation.on': 'On',
  'automation.off': 'Off',
  'automation.switchedOn': '{name} is on.',
  'automation.switchedOff': '{name} is off.',
  'automation.when': 'When',
  'automation.then': 'Then',
  'automation.recentRuns': 'Recent runs',
  'automation.noRuns': 'No rule has run yet.',
  'automation.run.running': 'Running',
  'automation.run.ok': 'Done',
  'automation.run.failed': 'Failed',
  'automation.run.skipped': 'Skipped',
  'automation.run.throttled': 'Stopped: too many runs',
  'automation.step.ok': 'done',
  'automation.step.skipped': 'skipped',
  'automation.step.failed': 'failed',
  'automation.trigger.deal.won': 'a deal is won',
  'automation.trigger.deal.stage_changed': 'a deal moves to a stage',
  'automation.trigger.file.uploaded': 'a file is uploaded',
  'automation.trigger.signing.completed': 'a document is signed by everyone',
  'automation.trigger.contact.created': 'a contact is added',
  'automation.trigger.account.created': 'an account is added',
  'automation.action.create_folder': 'Create a folder',
  'automation.action.move_file': 'Move the file',
  'automation.action.create_task': 'Create a task',
  'automation.action.add_note': 'Add a note',
  'automation.action.notify': 'Send a notification',
  'automation.field.name': 'Folder name',
  'automation.field.parentFolderId': 'Inside folder',
  'automation.field.folderId': 'Into folder',
  'automation.field.subject': 'Task',
  'automation.field.assigneeId': 'Assign to',
  'automation.field.dueInDays': 'Due in days',
  'automation.field.text': 'Note',
  'automation.field.to': 'Notify',
  'automation.field.message': 'Message',
  'automation.ruleName': 'Name of the rule',
  'automation.triggerLabel': 'What happens',
  'automation.toStage': 'Stage',
  'automation.anyStage': 'Any stage',
  'automation.inFolder': 'In folder',
  'automation.anyFolder': 'Any folder',
  'automation.noFolder': 'No folder chosen',
  'automation.driveRoot': 'At the top of the drive',
  'automation.intoCreatedFolder': 'Into the folder created in an earlier step',
  'automation.assignDefault': 'The rule’s author',
  'automation.ruleAuthor': 'The rule’s author',
  'automation.allAdmins': 'All admins',
  'automation.team': 'Team: {name}',
  'automation.teamAdmins': 'Admins of {name}',
  'automation.stepType': 'Step {step}',
  'automation.notForTrigger': 'not for this trigger',
  'automation.moveStepUp': 'Move step {step} up',
  'automation.moveStepDown': 'Move step {step} down',
  'automation.removeStep': 'Remove step {step}',
  'automation.addStep': 'Add a step',
  'automation.insertField': 'Insert:',
  'automation.limit': 'At most, runs per hour',
  'automation.limitHint': 'A rule that runs more often is switched off, and you are told.',
  'automation.limitInvalid': 'Runs per hour must be a whole number from 1 to 1000.',
  'automation.nameMissing': 'Give the rule a name.',
  'automation.actionDoesNotFit': 'Step {step} needs something this trigger does not bring (a file, or a deal, contact or account).',
  'automation.fieldMissing': 'Step {step}: fill in “{field}”.',
  'automation.saveRule': 'Save rule',
  'automation.saved': 'Rule {name} saved.',
  'automation.deleteConfirm': 'Delete the rule {name}? Its run history goes with it.',
  'automation.deleteTitle': 'Delete the rule {name}?',
  'automation.trigger.file.attached': 'a file is attached to a deal or account',
  'automation.action.move_to_path': 'File it into a folder path',
  'automation.field.path': 'Folder path',
  'automation.attachedTo': 'Attached to',
  'automation.dealOrAccount': 'A deal or an account',
  'automation.toDeal': 'A deal',
  'automation.toAccount': 'An account',
  'automation.withTag': 'Only files with the tag',
  'automation.anyTag': 'Any file',
  'automation.withTagHint': 'Its own tag or its folder’s. A file attached earlier is filed when it gets the tag.',
  'automation.topFolderOnly': 'Only files in the top folder of the drive',
  'automation.topFolderOnlyHint': 'A file someone filed by hand stays where it is.',
  'automation.pathHint': 'Folder names separated by /. Missing folders are made. The date is the signing date of a document signed here, otherwise the day the rule runs.',
  'automation.pathPreview': 'A file attached today goes to: {path}',
  'automation.exampleTag': 'Agreement',
  'automation.exampleAccount': 'Example Ltd',
  'automation.exampleDeal': 'Example deal',
  'settings.audit': 'Audit log',
  'audit.hint': 'Everything that happened in the company, newest first. The log cannot be changed, not even by admins.',
  'audit.area': 'Area',
  'audit.allAreas': 'All areas',
  'audit.area.tenant': 'Company and members',
  'audit.area.files': 'Files',
  'audit.area.scan': 'Virus scan',
  'audit.area.preview': 'Previews',
  'audit.area.text': 'Text for search',
  'audit.area.ocr': 'Text recognition (OCR)',
  'audit.area.sharing': 'Sharing',
  'audit.area.download': 'Downloads',
  'audit.area.crm': 'Customers',
  'audit.area.signing': 'Signatures',
  'audit.area.automation': 'Automation',
  'audit.area.integrations': 'Integrations',
  'audit.area.privacy': 'Privacy',
  'audit.area.platform': 'Platform owner',
  'audit.area.wopi': 'Office editor',
  'audit.person': 'Person',
  'audit.everybody': 'Everybody',
  'audit.from': 'From',
  'audit.to': 'To',
  'audit.when': 'When',
  'audit.data': 'Details',
  'audit.who': 'Who',
  'audit.what': 'What',
  'audit.system': 'DoCuLat',
  'audit.plain.companyViewed': 'DoCuLat support opened the company',
  'audit.plain.teamAccessChanged': 'Access by team switched on or off',
  'audit.plain.teamHiddenChanged': 'A team hidden from admins, or shown again',
  'audit.plain.teamOutsideChanged': 'People from outside the company allowed in a team, or their limits changed',
  'audit.plain.teamOutsideInvited': 'Somebody from outside the company invited into a team',
  'audit.plain.phoneHandoff': 'Signed in in a browser from the phone app',
  'handoff.opening': 'Signing in…',
  'audit.support': 'DoCuLat support ({name})',
  'audit.guest': '{name} (guest)',
  'audit.none': 'Nothing in the log for this filter',
  'settings.privacy': 'Data and privacy',
  'settings.privateRecords': 'Private records',
  'settings.newRecordsPrivate': 'New records are private',
  'settings.newRecordsPrivateHint': 'New contacts, accounts and deals start private: only their owner, the colleagues they are shared with and the company\'s owners and admins see them. The form shows it, and it can be turned off there. Existing records do not change.',
  'settings.teamAccess': 'Access by team',
  'settings.teamAccessOn': 'Access follows teams',
  'settings.teamAccessHint': 'A record is seen by the people in its teams, its owner, whom it is shared with, and the owners and admins. “All company” is everybody. Off: teams are labels, and everybody sees every record that is not private.',
  'settings.teamAccessOwnersOnly': 'Only the company’s owners change this.',
  'settings.teamAccessOnTitle': 'Turn on access by team?',
  'settings.teamAccessOnMessage': 'Accounts, contacts, deals and files will be seen only by the people in their teams. Records in “All company” stay seen by everybody.',
  'settings.teamAccessPreview': 'People who would no longer see some accounts, contacts and deals:',
  'settings.teamAccessNobody': 'Nobody loses sight of an account, contact or deal.',
  'settings.teamAccessLoses': '{name}: {count}',
  'settings.teamAccessTurnOn': 'Turn on',
  'settings.teamAccessOffTitle': 'Turn off access by team?',
  'settings.teamAccessOffMessage': 'Everybody in the company will see every record that is not private again. Teams stay as labels.',
  'settings.teamAccessTurnOff': 'Turn off',
  'crm.recordReadOnly': 'You only read this record. A team admin or member changes it.',
  'crm.recordSensitive': 'You can see that this exists, not what is in it.',
  'crm.sealedMark': 'Sensitive: you can see only that it exists',
  'crm.recordHidden': 'A record you cannot open',
  'crm.planMeeting': 'Plan meeting',
  'crm.meeting.add': 'Add meeting',
  'crm.meeting.edit': 'Edit meeting',
  'crm.meeting.starts': 'Starts',
  'crm.meeting.ends': 'Ends',
  'crm.meeting.beforeStart': 'The meeting ends before it starts.',
  'crm.meeting.tooLong': 'A meeting lasts at most 14 days.',
  'crm.meeting.place': 'Place',
  'crm.meeting.placeHint': 'An address, a room or a video call link',
  'crm.meeting.placeSuggestions': 'Addresses found',
  'crm.meeting.placesBy.google': 'Google Maps',
  'crm.meeting.placesBy.osm': '© OpenStreetMap contributors',
  'crm.meeting.usePlace': 'Use {place}',
  'crm.meeting.attendees': 'Attendees',
  'crm.meeting.organiser': 'Organiser: {name}',
  'crm.meeting.addAttendee': 'Add a colleague, a contact or an e-mail address',
  'crm.meeting.inviteAddress': 'Add {email}',
  'crm.meeting.kind.user': 'Colleague',
  'crm.meeting.kind.contact': 'Contact',
  'crm.meeting.kind.email': 'E-mail address',
  'crm.meeting.required': 'Required',
  'crm.meeting.optional': 'Optional',
  'crm.meeting.makeOptional': 'Make {name} optional',
  'crm.meeting.makeRequired': 'Make {name} required',
  'crm.meeting.remove': 'Remove {name}',
  'crm.meeting.listLocked': 'The list has a contact you cannot open, so it stays as it is. Somebody who can open the contact changes it.',
  'crm.meeting.optionalName': '{name} (optional)',
  'crm.meeting.readOnly': 'You are asked to this meeting. Its organiser changes it.',
  'crm.meeting.resized': '“{name}” now ends at {time}',
  'crm.meeting.sendInvitations': 'E-mail the invitation to the people outside the company',
  'crm.meeting.sendUpdates': 'E-mail this change to the people invited',
  'crm.meeting.sendHint': 'With a calendar file and links to answer. Colleagues see the meeting in DoCuLat.',
  'crm.meeting.invitationsSent': 'Invitations e-mailed {date}',
  'crm.meeting.withAnswer': '{name}: {answer}',
  'crm.meeting.answer.accepted': 'yes',
  'crm.meeting.answer.tentative': 'maybe',
  'crm.meeting.answer.declined': 'no',
  'crm.losesSight': 'You are in none of its other teams, so you may no longer see it.',
  'settings.company': 'Company',
  'settings.showcase': 'Showcase',
  'settings.showcaseHint': 'A showcase company for demos: everything in it is made up, and it is rebuilt from time to time.',
  'settings.supportContact': 'Support contact for the phone app',
  'settings.supportContactHint': "Whom the people in your company call or write to from the phone app's Help. A name, and a phone or an e-mail or both. Leave the name empty for nobody.",
  'settings.supportContactReach': 'Give a phone number or an e-mail address, or both.',
  'settings.supportPhone': 'Phone',
  'settings.mapProvider': 'Map on computers',
  'settings.mapProviderHint': 'Where an address opens when someone presses its map button on a computer. Phones always offer their navigation apps.',
  'settings.map.google': 'Google Maps',
  'settings.map.googleHint': 'Familiar to most people, with street view and public transport.',
  'settings.map.osm': 'OpenStreetMap',
  'settings.map.osmHint': 'Open and run by a non-profit: your customers\' addresses are not sent to Google.',
  'privacy.export': 'Export the company’s data',
  'privacy.exportHint': 'A ZIP with every file, the customer records, members, shares and the audit log, ready in a few minutes. The download link lasts 7 days.',
  'privacy.exportButton': 'Export data',
  'privacy.exportStarted': 'The export is being prepared. You will be notified when it is ready.',
  'privacy.noExports': 'No exports yet.',
  'privacy.exportOf': 'Export of {date}',
  'privacy.status.queued': 'Waiting',
  'privacy.status.running': 'Preparing',
  'privacy.status.ready': 'Ready',
  'privacy.status.failed': 'Failed',
  'privacy.status.expired': 'Expired',
  'privacy.fileCount': '{count} files',
  'privacy.availableUntil': 'available until {date}',
  'privacy.deletion': 'Delete the company',
  'privacy.deletionHint': 'The company closes at once: only owners can still open it, to export data or change their mind. After 30 days everything is erased for good in every part of DoCuLat, and the owners get a report.',
  'privacy.typeName': 'Type the company’s name to confirm: {name}',
  'privacy.deleteCompany': 'Delete the company',
  'privacy.deletionScheduled': 'The company will be erased on {date}.',
  'privacy.deletionPending': 'This company is scheduled to be erased on {date}. Until then only owners can open it.',
  'privacy.cancelDeletion': 'Keep the company',
  'privacy.cancelDeletionConfirm': 'Cancel the deletion and open the company to all its members again?',
  'privacy.deletionCancelled': 'The deletion was cancelled.',
  'privacy.ownersOnly': 'Only owners can delete the company.',
  'signing.title': 'Signatures',
  'signing.hint': 'Documents sent for electronic signature. To send one, open the file and choose “Send for signature”.',
  'signing.none': 'Nothing sent for signature yet',
  'signing.noAccess': 'Signatures are for the company’s own people.',
  'signing.sendForSignature': 'Send for signature',
  'signing.sendTitle': 'Send “{name}” for signature',
  'signing.documentTitle': 'Title',
  'signing.signers': 'Who signs',
  'signing.addSigner': 'Add a signer',
  'signing.removeSigner': 'Remove signer {number}',
  'signing.deadline': 'Sign by',
  'signing.deal': 'Deal',
  'signing.message': 'Message to the signers',
  'signing.send': 'Send',
  'signing.sent': '“{name}” was sent for signature.',
  'signing.connectDokobit': 'Connect Dokobit',
  'signing.askAdmin': 'Ask an admin of the company to connect it.',
  'signing.sentOn': 'sent {date}',
  'signing.until': 'sign by {date}',
  'signing.status.sent': 'Waiting for signatures',
  'signing.status.completed': 'Signed',
  'signing.status.declined': 'Declined',
  'signing.status.cancelled': 'Cancelled',
  'signing.status.failed': 'Failed',
  'signing.signer.pending': 'not signed yet',
  'signing.signer.signed': 'signed',
  'signing.signer.declined': 'declined',
  'signing.signedDocument': 'Signed document',
  'signing.cancel': 'Cancel signing',
  'signing.cancelConfirm': 'Cancel “{name}”? Signers can no longer sign it.',
  'signing.cancelTitle': 'Cancel “{name}”?',
  'files.chooseFolder': 'Choose a folder',
  'files.chooseThisFolder': 'Choose {name}',
  'files.openAFolder': 'Open a folder to choose it',
  'files.noSubfolders': 'No folders inside.',

  'editor.edit': 'Edit in browser',
  'editor.open': 'Open in browser',
  'editor.editing': 'Editing',
  'editor.readOnly': 'Read only',
  // Office editing is part of the paid plans (TF-168).
  'editor.notOnPlan': 'Editing in the browser is part of the Team plan and above. Download the file to edit it on your computer.',
  'editor.askAdmin': 'Ask an admin to switch on editing for you. Download the file to edit it on your computer.',
  'editor.notSwitchedOn': 'Editing in the browser is not switched on for you.',
  'editor.switchOn': 'Switch it on in Members',
  'editor.changePlan': 'Change the plan',
  'editor.ownerCanEnable': 'The owner of this document can enable editing in the browser. Download the file to edit it on your computer.',
  'editor.close': 'Close editor',
  'editor.loading': 'Opening the document…',
  'editor.unavailable': 'Editing is not available right now. You can download the file and upload a new version.',
  'editor.notAvailable': 'Not available',
  'editor.backToFile': 'Back to the file',
  'editor.savedAsVersions': 'Every save becomes a new version of the file.',
  'editor.frameTitle': 'Document editor: {name}',

  'editor.unsaved': 'Unsaved changes',
  'editor.saved': 'Saved',

  // Files from a connected drive (phase 3b).
  'drive.import': 'Import from a drive',
  'drive.importHint': 'Files are copied into this folder and scanned like any upload. Nothing is changed in the other drive.',
  'drive.importCount': 'Import {count} file(s)',
  'drive.importing': 'Copying…',
  'drive.imported': '{count} file(s) copied into this folder.',
  'drive.someFailed': '{count} file(s) could not be copied.',
  'drive.account': 'From',
  'drive.root': 'Drive',
  'drive.whereYouAre': 'Where you are in the drive',
  'drive.emptyFolder': 'Nothing in this folder.',
  'drive.sendTo': 'Send to {drive}',
  'drive.sent': '“{name}” was sent to the drive.',
  'drive.cannotBrowse': 'This drive cannot be read just now.',
  'drive.keepIn': 'Keep in a drive',
  'drive.keepInNamed': 'Keep in {drive}',
  'drive.keepInHint': 'Everything in “{folder}” is copied to the drive and kept up to date as it changes.',
  'drive.keepInWarning': 'One way only: this folder is the original. A change made to a copy in the drive is replaced the next time the original changes, and a restricted folder inside is never copied.',
  'drive.keepHere': 'Keep it in {where}',
  'drive.noFoldersHere': 'No folders here. Choose where the copies should go, or stay at the top of the drive.',
  'drive.keptIn': '“{folder}” will be kept in the drive from now on.',
  'drive.keptInDrives': 'Folders kept in a drive',
  'drive.keptInDrivesHint': 'Set up from the folder itself, in Files. Each one is checked when something changes in it, and from time to time anyway.',
  'drive.keptInTo': 'in {drive}, under {where}',
  'drive.lastSwept': 'Last checked {when} · {count} copied',
  'drive.notSweptYet': 'Not checked yet.',
  'drive.lastFailed': 'The last attempt did not finish: {detail}',
  'drive.failing': 'Not working',
  'drive.skipped': '{count} restricted folder(s) left out',
  'drive.sweepNow': 'Check now',
  'drive.sweepAsked': 'It will be checked in a moment.',
  'drive.stopKeeping': 'Stop keeping it',
  'drive.stopKeepingConfirm': 'Stop keeping “{folder}” in the drive? What has already been copied stays where it is.',

  'error.title': 'Something went wrong',
  'error.hint': 'Try again. If it keeps happening, tell your administrator.',
  'error.notFound': 'This page does not exist.',
  'error.home': 'Go to start',
  'auth.signingOut': 'Signing you out…',
  'notFound.lead': 'There is nothing at this address. Here is where things are.',
  'notFound.places': 'Where things are',
  'notFound.searchButton': 'Search',
  'notFound.dashboard': 'Your company at a glance',
  'notFound.deals': 'Deals on their way to a sale',
  'notFound.accounts': 'The companies you work with',
  'notFound.contacts': 'The people at them',
  'notFound.tasksLabel': 'Tasks and calendar',
  'notFound.tasks': 'What is due, and when',
  'notFound.files': 'Your company\'s files and folders',
  'notFound.search': 'Find anything by its words',
  'notFound.shared': 'What others shared with you',
  'notFound.settings': 'People, the company and its tools',
  'status.unreachable': 'DoCuLat can\'t be reached right now. It may be your internet connection or our service:',
  'status.page': 'see the status page',
  'status.question': 'Is DoCuLat down for everyone?',
  'status.link': 'Service status',
  'status.version': 'Version {version}',
  'status.unreachableShort': 'DoCuLat can\'t be reached right now. Check your connection, or see status.doculat.eu.',

  // Plans, usage and invoices (phase 8a/8b).
  'settings.billing': 'Plan and billing',
  'billing.currentPlan': 'Current plan',
  'billing.monthly': '{amount} a month',
  'billing.freeOfCharge': 'Free of charge',
  'billing.period': 'This month: {from} to {to}',
  'trial.title': 'Trial',
  'trial.banner.one': 'Trial: {count} day left. After that you continue on {free}, or choose a plan.',
  'trial.banner.other': 'Trial: {count} days left. After that you continue on {free}, or choose a plan.',
  'trial.freeSummary': 'Free ({storage}, {members} people, documents read-only in the browser)',
  'trial.freePlan': 'the Free plan',
  'trial.choosePlan': 'Choose a plan',
  'trial.later': 'Not now',
  'overLimit.title': 'Over the {plan} plan’s limits.',
  'overLimit.text': 'Nothing was deleted, but what is over a limit can’t grow: {limits}. A plan with more lifts it.',
  'overLimit.storage': 'storage {used} of {limit} (no uploads)',
  'overLimit.members': 'people {used} of {limit}',
  'overLimit.signatures': 'signatures this month {used} of {limit} (no new requests)',
  'overLimit.ocrPages': 'scanned pages read this month {used} of {limit} (no more read)',
  'overLimit.seePlans': 'See the plans',
  'billing.trialUntil': 'Trial until {date} ({left}).',
  'billing.trialLeft.one': '{count} day left',
  'billing.trialLeft.other': '{count} days left',
  'billing.trialThen': 'After that the company continues on {free}, whatever it uses. Choosing a plan now ends the trial and starts that plan at once.',
  'billing.endsOn': 'This plan ends on {date}; the company moves to Free.',
  'billing.cancel': 'Cancel this plan',
  'billing.cancelTitle': 'Cancel the plan?',
  'billing.cancelBody': 'The company keeps this plan until {date} and moves to Free afterwards.',
  'billing.cancelConfirm': 'Cancel the plan',
  'billing.cancelled': 'The plan ends when this month does.',
  'billing.plans': 'Plans',
  'billing.plansHint': 'An owner can change the plan; it takes effect at once.',
  'billing.yourPlan': 'Your plan',
  'billing.agreedPlan': 'Agreed for your company.',
  'billing.withdrawnPlan': 'No longer offered. You can stay on it.',
  'billing.leaveAgreed': 'You are on a plan agreed for your company. After the change you cannot choose it again yourself; contact us to get it back.',
  'billing.leaveWithdrawn': 'Your plan is no longer offered. After the change you cannot choose it again.',
  'billing.thisPlan': 'Current',
  'billing.choose': 'Move to {plan}',
  'billing.confirmTitle': 'Move to {plan}?',
  'billing.confirmPaid': 'The company will be billed {amount} a month, plus anything used above the plan.',
  'billing.confirmFree': 'The company moves to the free plan and stops at its limits.',
  'billing.confirm': 'Change the plan',
  'billing.planChanged': 'The company is now on {plan}.',
  'billing.includesStorage': '{amount} of storage',
  'billing.includesMembers': '{count} people',
  'billing.includesSignatures': '{count} signatures a month',
  'billing.includesPages': '{count} recognised pages a month',
  'billing.includesPagesPerDocument': 'Up to {count} pages read in one document',
  'billing.includesEditing': 'Office documents edited in the browser',
  'billing.editingAddon': 'Editing in the browser: {price} per person per month',
  'billing.noEditing': 'Documents open read-only in the browser (download to edit)',
  'billing.includesFileSize': 'Files up to {size} each',
  'billing.includesFileTypes': 'File types: {types}',
  'billing.usageTitle': 'Used this month',
  'billing.limitsInfo': 'About the limits',
  'billing.limitsTitle': 'How the limits work',
  'billing.limitsHard': 'This plan stops at its limits and nothing is charged above them. When the storage is full no more files can be uploaded; once the month’s signatures or scanned pages are used, no more are sent or read until the next month. Choose a bigger plan to go on.',
  'billing.limitsOverage': 'Above what the plan includes, the extra is charged on the next invoice at the prices shown with each plan. Storage is the exception: when it is full, uploads stop.',
  'billing.nearLimit': 'The company is close to what the {plan} plan allows. A bigger plan keeps everything working.',
  'billing.usageStorage': 'Storage',
  'billing.usageMembers': 'People',
  'billing.usageSignatures': 'Signatures',
  'billing.usagePages': 'Recognised pages',
  'billing.overLimit': 'at the limit of this plan',
  'billing.overCharged': 'above the plan, charged on the invoice',
  'billing.cardOnFile': 'Paid by {brand} ending {last4}',
  'billing.noCard': 'No card yet.',
  'billing.addCard': 'Add a card',
  'billing.changeCard': 'Change the card',
  'billing.cardFirst': 'You will be taken to the payment provider to enter a card; the plan changes as soon as it is there.',
  'billing.toTheCardPage': 'Enter a card',
  'billing.pastDue': 'A payment did not go through. The invoice is still open: add another card and it will be tried again.',
  'billing.details': 'Invoice details',
  'billing.detailsHint': 'What your invoices say about your company. An owner can change them.',
  'billing.detailsHintVat': 'What your invoices say about your company, and what decides the VAT on them. An owner can change them.',
  'billing.legalName': 'Legal name',
  'billing.country': 'Country',
  'billing.address': 'Address',
  'billing.vatNumber': 'VAT number',
  'billing.vatNumberHint': 'A business elsewhere in the EU that gives one is not charged VAT: it accounts for the tax itself.',
  'billing.detailsSaved': 'Invoice details saved.',
  'billing.netTotal': 'Total before VAT',
  'billing.vat': 'VAT {rate} %',
  'billing.invoices': 'Invoices',
  'billing.noInvoices': 'No invoices yet: the first one is written when this month ends.',
  'billing.number': 'Number',
  'billing.month': 'Month',
  'billing.plan': 'Plan',
  'billing.total': 'Total',
  'billing.state': 'State',
  'billing.openInvoice': 'Open',
  'billing.downloadPdf': 'Download PDF',
  'billing.invoiceOf': 'Invoice for {month}',
  'billing.statusOpen': 'Open',
  'billing.statusPaid': 'Paid',
  'billing.statusVoid': 'Void',

  // Import of accounts and contacts from a file (TF-164).
  'crm.import.titleAccounts': 'Import accounts',
  'crm.import.titleContacts': 'Import contacts',
  'crm.import.all': 'Imports',
  'crm.import.fromFile': 'Import from a file',
  'crm.import.menuAccounts': 'More for accounts',
  'crm.import.menuContacts': 'More for contacts',
  'crm.import.adminsOnly': 'Only the company\'s owners and admins can import.',
  'crm.import.steps': 'Steps of the import',
  'crm.import.step.upload': 'Upload',
  'crm.import.step.map': 'Map',
  'crm.import.step.check': 'Check',
  'crm.import.step.import': 'Import',
  'crm.import.uploadIntroAccounts': 'Choose a CSV or Excel file with one account per row and the headings in the first row. Up to 10 MB and {rows} rows.',
  'crm.import.uploadIntroContacts': 'Choose a CSV or Excel file with one person per row and the headings in the first row. Up to 10 MB and {rows} rows.',
  'crm.import.chooseFile': 'Choose a file or drop it here',
  'crm.import.fileHint': '.csv, .xlsx, or a DoCuLat data export (.zip or .jsonl). The file is read in your browser.',
  'crm.import.template': 'Download a template',
  'crm.import.templateName.account': 'accounts-template.csv',
  'crm.import.templateName.contact': 'contacts-template.csv',
  'crm.import.file.too_big': 'The file is larger than 10 MB. Split it into smaller files.',
  'crm.import.file.not_spreadsheet': 'This is not a CSV or .xlsx file. In Excel, use Save as and choose one of those.',
  'crm.import.file.empty': 'The file has no rows below its headings.',
  'crm.import.file.too_many_rows': 'The file has more than {rows} rows. Split it into smaller files.',
  'crm.import.file.too_many_columns': 'The file has more than 500 columns.',
  'crm.import.separator': 'Separator',
  'crm.import.separator.semicolon': 'Semicolon ( ; )',
  'crm.import.separator.comma': 'Comma ( , )',
  'crm.import.separator.tab': 'Tab',
  'crm.import.charset': 'Character set',
  'crm.import.charset.utf8': 'UTF-8',
  'crm.import.charset.baltic': 'Windows-1257 (Baltic)',
  'crm.import.charset.western': 'Windows-1252 (Western European)',
  'crm.import.sheet': 'Sheet',
  'crm.import.reading': 'Reading the file…',
  'crm.import.preview': 'First rows',
  'crm.import.previewHint': 'If letters or columns look wrong, change the separator or the character set.',
  'crm.import.next': 'Next',
  'crm.import.rowsInFile': 'Rows in the file: {count}',
  'crm.import.column': 'Column {letter}',
  'crm.import.mapIntro': 'Choose the field each column goes into. Columns set to "Do not import" are left out.',
  'crm.import.needAccountName': 'Choose the column with the account\'s name.',
  'crm.import.needContactName': 'Choose the column with the first name, the last name or the full name.',
  'crm.import.noValues': 'No values',
  'crm.import.mapTo': 'Field for {column}',
  'crm.import.skip': 'Do not import',
  'crm.import.doubled': 'Another column goes into this field',
  'crm.import.columnsUsed': 'Columns to import: {used} of {total}',
  'crm.import.group.account': 'Account',
  'crm.import.group.contact': 'Person',
  'crm.import.group.points': 'Email and phone',
  'crm.import.group.address': 'Address',
  'crm.import.group.company': 'Company',
  'crm.import.group.custom': 'Custom fields',
  'crm.import.target.name': 'Name',
  'crm.import.target.fullName': 'Full name',
  'crm.import.target.preferredLanguage': 'Preferred language',
  'crm.import.target.accountName': 'Company name',
  'crm.import.target.accountRegistrationNo': 'Company registration number',
  'crm.import.target.accountVatNo': 'Company VAT number',
  'crm.import.target.email': 'Email ({label})',
  'crm.import.target.phone': 'Phone ({label})',
  'crm.import.target.address': '{address}: {part}',
  'crm.import.sending': 'Sending rows: {sent} of {total}',
  'crm.import.check': 'Check',
  'crm.import.checking': 'Checking…',
  'crm.import.sendFailed': 'The rows could not be sent. Try again: the rows already sent are kept.',
  'crm.import.checkFailed': 'The file could not be checked. Try again.',
  'crm.import.startFailed': 'The import could not start.',
  'crm.import.options': 'For every row',
  'crm.import.owner': 'Owner',
  'crm.import.ownerHint': 'Where an owner column names a member, that member is the owner.',
  'crm.import.ownerDefault': 'Me',
  'crm.import.ownerUnknown': 'Rows whose owner is not a member of the company: {count}. They get the owner chosen above.',
  'crm.import.kind': 'Type',
  'crm.import.kindHint': 'For rows where no column gives the type.',
  'crm.import.dateOrder': 'Dates such as 03/10/2026',
  'crm.import.dateOrder.dmy': 'Day first (3 October)',
  'crm.import.dateOrder.mdy': 'Month first (10 March)',
  'crm.import.dateOrderHint': 'Columns where it is not clear: {columns}',
  'crm.import.tags': 'Tags',
  'crm.import.addTag': 'Add a tag',
  'crm.import.removeTag': 'Remove the tag {name}',
  'crm.import.defaultTag': 'Imported {date}',
  'crm.import.addChoices': 'Add missing choices',
  'crm.import.addChoicesHint': 'Values a choice field does not have yet are added to it. Otherwise these rows are left out.',
  'crm.import.runAutomation': 'Run automation rules',
  'crm.import.runAutomationHint': 'Off: no automation rules run and owners get no notifications for these records.',
  'crm.import.result': 'What the import will do',
  'crm.import.count.rows': 'Rows',
  'crm.import.count.accounts': 'Accounts to add',
  'crm.import.count.contacts': 'Contacts to add',
  'crm.import.count.newCompanies': 'New accounts for companies',
  'crm.import.count.linked': 'Linked to existing accounts',
  'crm.import.count.leftOut': 'Left out',
  'crm.import.count.accountsAdded': 'Accounts added',
  'crm.import.count.contactsAdded': 'Contacts added',
  'crm.import.count.failed': 'Failed',
  'crm.import.problems': 'Why rows are left out',
  'crm.import.downloadProblems': 'Download the rows left out',
  'crm.import.problemsFile': 'rows-left-out',
  'crm.import.problemColumn': 'Problem',
  'crm.import.leftOutSuffix': 'left out',
  'crm.import.firstRows': 'First rows',
  'crm.import.row': 'Row',
  'crm.import.start': 'Start the import',
  'crm.import.queued': 'Waiting to start…',
  'crm.import.running': 'Importing…',
  'crm.import.progress': 'Rows done: {done} of {total}',
  'crm.import.mayLeave': 'You can leave this page. You get a notification when the import has finished.',
  'crm.import.done': 'The import has finished',
  'crm.import.showAccounts': 'Show the imported accounts',
  'crm.import.showContacts': 'Show the imported contacts',
  'crm.import.downloadLeftOut': 'Download the rows left out',
  'crm.import.downloadFailed': 'The file could not be downloaded.',
  'crm.import.failed': 'The import stopped: {reason}',
  'crm.import.stopped': 'Stopped',
  'crm.import.none': 'No imports yet',
  'crm.import.noneHint': 'Import accounts or contacts from a CSV or Excel file.',
  'crm.import.summary.accounts': 'Accounts: {count}',
  'crm.import.summary.contacts': 'Contacts: {count}',
  'crm.import.summary.leftOut': 'Left out: {count}',
  'crm.import.chip': 'Import',
  'crm.import.problem.accountNameMissing': 'The account has no name.',
  'crm.import.problem.contactNameMissing': 'The person has no name.',
  'crm.import.problem.tooManyEmails': 'More email addresses than a record can have.',
  'crm.import.problem.tooManyPhones': 'More phone numbers than a record can have.',
  'crm.import.problem.required_missing': '{field} is required and has no value.',
  'crm.import.problem.duplicate': 'The same as row {row}.',
  'crm.import.problem.failed': 'The row could not be saved.',
  'crm.import.problem.company_name_missing': 'The company is not in the CRM, and the row has no company name to add it.',
  'crm.import.problem.record_locked': 'This row is a record you can see but not change. It is left as it is.',
  'crm.import.problem.email_invalid': '{column}: "{value}" is not an email address.',
  'crm.import.problem.choice_unknown': '{column}: "{value}" is not one of the choices.',
  'crm.import.problem.too_long': '{column}: the value is too long.',
  'crm.import.problem.date_invalid': '{column}: "{value}" is not a date.',
  'crm.import.problem.number_invalid': '{column}: "{value}" is not a number.',
  'crm.import.problem.yes_no_invalid': '{column}: "{value}" is not yes or no.',
  'crm.import.problem.country_unknown': '{column}: "{value}" is not a known country.',
  'crm.import.problem.kind_unknown': '{column}: "{value}" is not an account type.',
  'crm.import.problem.salutation_unknown': '{column}: "{value}" is not a known salutation.',
  'crm.import.problem.language_unknown': '{column}: "{value}" is not a known language.',
  'crm.import.kind.name_missing': 'No name',
  'crm.import.kind.email_invalid': 'Email address not valid',
  'crm.import.kind.choice_unknown': 'Not one of the choices',
  'crm.import.kind.too_long': 'Value too long',
  'crm.import.kind.date_invalid': 'Date not valid',
  'crm.import.kind.number_invalid': 'Number not valid',
  'crm.import.kind.yes_no_invalid': 'Not yes or no',
  'crm.import.kind.country_unknown': 'Country not known',
  'crm.import.kind.kind_unknown': 'Account type not known',
  'crm.import.kind.salutation_unknown': 'Salutation not known',
  'crm.import.kind.language_unknown': 'Language not known',
  'crm.import.kind.too_many': 'Too many emails or phones',
  'crm.import.kind.required_missing': 'Required field empty',
  'crm.import.kind.duplicate': 'Same as an earlier row',
  'crm.import.kind.company_name_missing': 'Company without a name',
  'crm.import.kind.record_locked': 'Record you cannot change',
  'crm.import.target.exportId': 'Id in the export',
  'crm.import.target.exportAccountId': 'Account id in the export',
  'crm.import.target.points': 'All emails and phones',
  'crm.import.group.export': 'From the export',
  'crm.import.problem.points_invalid': '{column}: the emails and phones cannot be read.',
  'crm.import.kind.points_invalid': 'Emails and phones not readable',
  'crm.import.problem.account_missing': 'The account is not in this company. The person is imported without one.',
  'crm.import.kind.account_missing': 'Account not in this company',
  'crm.import.export.of': 'DoCuLat data export of {company}, made {date}.',
  'crm.import.export.file': 'A file from a DoCuLat data export.',
  'crm.import.export.pick': 'What to import',
  'crm.import.export.both': 'Accounts are imported first, then contacts, so each person keeps their account.',
  'crm.import.export.broken': 'Lines that are not JSON, left out: {lines}',
  'crm.import.export.trashed': 'Records in the trash when the export was made, left out: {count}',
  'crm.import.export.unknownFields': 'Not imported, as this company does not have these fields: {fields}',
  'crm.import.export.restore': 'This export is of this company. Records are matched by their id only. A record deleted since the export is added again, and nothing added since is changed.',
  'crm.import.ownerMatched': 'Owners found by email: {count}',
  'crm.import.unknownOwners': 'Not people of this company: {owners}',
  'crm.import.accountsMissing': 'People whose account is not in this company: {count}. They are imported without one.',
  'crm.import.export.next': 'Import the contacts from the same export',
  'crm.import.kind.failed': 'Could not be saved',
  'crm.import.matching': 'Records the CRM has already',
  'crm.import.matched': 'Rows that are records the CRM has: {count}.',
  'crm.import.matchedBy': 'Found by {rules}.',
  'crm.import.matchChoice': 'What to do with these rows',
  'crm.import.match.skip': 'Leave the records as they are',
  'crm.import.match.skipHint': 'The rows are skipped.',
  'crm.import.match.update': 'Update the records',
  'crm.import.match.updateHint': 'Empty fields are filled from the file. Email addresses, phone numbers and tags are added.',
  'crm.import.match.add': 'Add them as new records',
  'crm.import.match.addHint': 'The CRM will have the same company or person twice.',
  'crm.import.overwrite': 'Replace what the records have',
  'crm.import.overwriteHint': 'A value in the file replaces the value in the record. An empty cell changes nothing.',
  'crm.import.rule.registrationNo': 'registration number',
  'crm.import.rule.vatNo': 'VAT number',
  'crm.import.rule.name': 'name',
  'crm.import.rule.email': 'email address',
  'crm.import.rule.phone': 'phone number',
  'crm.import.rule.personName': 'name at the same account',
  'crm.import.rule.externalId': 'same address-book contact',

  // Import from a person's own Google Contacts (TF-237).
  'crm.google.menu': 'Import from Google Contacts',
  'crm.google.title': 'Import from Google Contacts',
  'crm.google.membersOnly': 'Only the company\'s own people can import contacts.',
  'crm.google.step.choose': 'Choose',
  'crm.google.step.check': 'Check',
  'crm.google.step.import': 'Import',
  'crm.google.connectTitle': 'Connect your Google Contacts',
  'crm.google.connectIntro': 'DoCuLat reads your Google Contacts once, when you import them. It asks Google for read-only access to your contacts and nothing else. The connection is yours: colleagues cannot use it.',
  'crm.google.unverified': 'Until Google has verified DoCuLat, only the test users listed in Google\'s console can connect.',
  'crm.google.connect': 'Connect Google Contacts',
  'crm.google.refused': 'Google no longer accepts the connection. Connect again.',
  'crm.google.notAvailable': 'Google Contacts cannot be connected on this installation yet.',
  'crm.google.which': 'Which contacts',
  'crm.google.everything': 'All contacts',
  'crm.google.someLabels': 'Contacts with these labels',
  'crm.google.noLabels': 'Your Google Contacts have no labels.',
  'crm.google.labels': 'Labels',
  'crm.google.counts': '{count} contacts, {email} with an e-mail address',
  'crm.google.onlyNew': 'Only contacts that are new or changed',
  'crm.google.onlyNewHint': 'Since your last import on {date}.',
  'crm.google.privacy': 'The import copies these people\'s details into the company\'s CRM, as typing them in would. Nothing is read from Google after the import.',
  'crm.google.disconnect': 'Disconnect Google Contacts',
  'crm.google.disconnectConfirm': 'DoCuLat will no longer be able to read your Google Contacts. Contacts imported so far stay in the CRM.',
  'crm.google.read': 'Read {count} contacts',
  'crm.google.readFailed': 'Your Google Contacts could not be read.',
  'crm.google.youOwn': 'You become the owner of the contacts it adds. No automation rule runs for them.',

  // Import from a person's own Outlook / Microsoft 365 contacts (TF-311).
  'crm.microsoft.menu': 'Import from Microsoft 365 contacts',
  'crm.microsoft.title': 'Import from Microsoft 365 contacts',
  'crm.microsoft.connectTitle': 'Connect your Microsoft 365 contacts',
  'crm.microsoft.connectIntro': 'DoCuLat reads your Outlook or Microsoft 365 contacts once, when you import them. It asks Microsoft for read-only access to your contacts and nothing else. The connection is yours: colleagues cannot use it.',
  'crm.microsoft.connect': 'Connect Microsoft 365 contacts',
  'crm.microsoft.refused': 'Microsoft no longer accepts the connection. Connect again.',
  'crm.microsoft.notAvailable': 'Microsoft 365 contacts cannot be connected on this installation yet.',
  'crm.microsoft.someFolders': 'Contacts in these folders',
  'crm.microsoft.noFolders': 'Your Microsoft contacts have no folders.',
  'crm.microsoft.folders': 'Folders',
  'crm.microsoft.privacy': 'The import copies these people\'s details into the company\'s CRM, as typing them in would. Nothing is read from Microsoft after the import.',
  'crm.microsoft.disconnect': 'Disconnect Microsoft 365 contacts',
  'crm.microsoft.disconnectConfirm': 'DoCuLat will no longer be able to read your Microsoft 365 contacts. Contacts imported so far stay in the CRM.',
  'crm.microsoft.readFailed': 'Your Microsoft 365 contacts could not be read.',
  'crm.microsoft.adminConsent': 'Your organisation lets only its Microsoft administrator approve apps. Send them the approval link below, then connect again.',
  'crm.microsoft.adminConsented': 'Your administrator approved DoCuLat for your organisation. Now connect your own contacts.',
  'crm.microsoft.adminConsentHint': 'Only your Microsoft administrator may approve apps? Send them the approval link.',
  'crm.microsoft.adminConsentCopy': 'Copy the link',
  'crm.import.samples': 'Examples',
  'crm.import.sample': 'Row {row}, found by {rule}',
  'crm.import.sample.file': 'In the file',
  'crm.import.sample.record': 'In the CRM',
  'crm.import.count.toUpdate': 'Records to update',
  'crm.import.count.toSkip': 'Rows to skip',
  'crm.import.count.updated': 'Records updated',
  'crm.import.count.skipped': 'Rows skipped',
  'crm.import.summary.updated': 'Updated: {count}',
  'crm.import.problem.matches_several': '{value} records in the CRM match this row. Merge them, or add the row as a new record.',
  'crm.import.kind.matches_several': 'Matches several records',
  'crm.import.undo': 'Undo import',
  'crm.import.undoTitle': 'Undo the import of {name}?',
  'crm.import.undoChecking': 'Checking what the undo would do',
  'crm.import.undoRemove': 'To the trash: {accounts} accounts and {contacts} contacts the import added.',
  'crm.import.undoRestore': 'Set back to how they were: {count} records the import updated.',
  'crm.import.undoKept': 'Kept: {count} records the import added that someone has worked on since.',
  'crm.import.undoHint': 'An import can be undone for {days} days after it finishes.',
  'crm.import.undoStarted': 'The import is being undone.',
  'crm.import.undoFailed': 'The import could not be undone.',
  'crm.import.undoing': 'Undoing',
  'crm.import.undone': 'Undone: {removed} removed, {restored} set back',
  'notificationType.crm.import_done': 'An import of accounts or contacts I started has finished',
  'settings.forms': 'Website forms',
  'notificationType.crm.enquiry': 'Somebody sends one of our website forms and the record is mine',
  'notificationType.legal.subprocessors': 'DoCuLat adds a sub-processor for my company\'s data',
  'notificationType.team.deals': 'News of my teams\' deals',
  'notificationType.team.tasks': 'News of my teams\' tasks',
  'notificationType.team.documents': 'News of my teams\' documents',
  'notificationType.team.members': 'Somebody joined or left a team I run',
  'notificationType.tag.sensitive': 'Somebody makes a tag sensitive or changes who reaches it',
  'notificationType.team.outside': 'Each Monday, the teams that share outside my company',
  'notificationType.company.released': 'A company I registered can be used, once its registration was checked',
  'notificationType.mail.not_filed': 'An e-mail sent to my DoCuLat address was not filed',
  'notificationType.meeting.answered': 'Somebody answered the invitation to a meeting I organise',
  'notificationType.deals.mine': 'News of the deals I own',
  'bots.unavailable.form': 'We could not confirm the check that you are a person just now. Nothing you entered is lost; press Send again in a minute.',
  'bots.ourFault.form': 'This form cannot be sent right now because of a fault on our side. We have been told; please try later.',
  'bots.unavailable.report': 'We could not confirm the check that you are a person just now. Nothing you entered is lost; press Send again in a minute.',
  'bots.ourFault.report': 'The report cannot be sent right now because of a fault on our side. We have been told; please try later.',
  'billing.includesForms': '{count} website forms',
  'forms.title': 'Website forms',
  'forms.new': 'New form',
  'forms.intro': 'A form on your own website, or on a page of its own. Each answer adds the contact, their company, a deal and a task, and tells the person who owns them.',
  'forms.limitReached': 'Your plan allows {limit} forms, and they are all made.',
  'forms.seePlans': 'See the plans',
  'forms.empty': 'No forms yet',
  'forms.paused': 'Paused',
  // What a form's answers made, and a form that makes no deal (TF-329).
  'forms.noDealNote': 'Answers make a contact and a task, but no deal.',
  'forms.noDealBadge': 'No deal',
  'forms.account': 'Account',
  'forms.dealColumn': 'Deal',
  'forms.taskColumn': 'Task',
  'forms.ownerColumn': 'Owner',
  'forms.noDealMade': 'No deal (form setting)',
  'forms.thisMonth': 'This month: {count}',
  'forms.lastAnswer': 'last answer {when}',
  'forms.noAnswers': 'no answers yet',
  'forms.edit': 'Edit {name}',
  'forms.usage': '{count} of {limit} forms made',
  'forms.back': 'Back to the forms',
  'forms.about': 'The form',
  'forms.name': 'Name',
  'forms.nameHint': "The visitor sees it as the form's title.",
  'forms.language': 'Language',
  'forms.languageHint': 'Of the labels, the messages and the bot check.',
  'forms.pausedSwitch': 'Paused',
  'forms.pausedHint': 'The form stays on the site, but takes no answers.',
  'forms.questions': 'Questions',
  'forms.questionsHint': 'The e-mail address is always asked. Custom fields of contacts and accounts can be asked too.',
  'forms.required': 'Required',
  'forms.moveUp': 'Move {name} up',
  'forms.moveDown': 'Move {name} down',
  'forms.removeQuestion': 'Remove {name}',
  'forms.addQuestion': 'Add a question',
  'forms.addQuestionPlaceholder': 'Choose a field',
  'forms.ofContact': 'contact',
  'forms.ofAccount': 'account',
  'forms.ofDeal': 'deal',
  'forms.ownQuestion': 'Write your own question',
  'forms.newQuestion': 'Your own question',
  'forms.editQuestion': 'Change the question',
  'forms.editQuestionNamed': 'Change {name}',
  'forms.addThisQuestion': 'Add question',
  'forms.questionLabel': 'Question',
  'forms.questionTypeLabel': 'Answer',
  'forms.questionType.text': 'Short text',
  'forms.questionType.textarea': 'Long text',
  'forms.questionType.number': 'Number',
  'forms.questionType.date': 'Date',
  'forms.questionType.boolean': 'Yes or no',
  'forms.questionType.select': 'One choice',
  'forms.questionType.multiselect': 'Several choices',
  'forms.questionHelp': 'Help text',
  'forms.questionHelpHint': 'Shown under the question. Optional.',
  'forms.questionChoices': 'Choices, one per line',
  'forms.questionChoicesHint': 'Up to 50. With 6 or fewer, one choice is shown as buttons.',
  'forms.questionLabelMissing': 'Write the question.',
  'forms.questionChoicesMissing': 'Add at least one choice.',
  'forms.questionChoicesMany': 'At most {max} choices.',
  'forms.questionChoiceLong': 'A choice can have at most 100 characters.',
  'forms.dealFieldsNoDeal': 'Deal fields are kept only when the form makes a deal. Choose a stage below.',
  'forms.field.firstName': 'First name',
  'forms.field.lastName': 'Last name',
  'forms.field.email': 'E-mail',
  'forms.field.phone': 'Phone',
  'forms.field.company': 'Company',
  'forms.field.registrationNo': 'Registration or VAT number',
  'forms.field.country': 'Country',
  'forms.field.message': 'Message',
  'forms.makes': 'What an answer makes',
  'forms.makesHint': 'The contact is found by e-mail and the company by its number or name. What is not found is added.',
  'forms.owner': 'Owner',
  'forms.ownerPerson': 'One person',
  'forms.ownerTurns': 'In turn',
  'forms.ownerTurnsHint': 'Each answer goes to the next person on the list.',
  'forms.ownerWho': 'Who owns the records',
  'forms.ownersWho': 'Who takes turns',
  'forms.deal': 'Deal',
  'forms.dealHint': 'A new deal at this stage, or no deal.',
  'forms.noDeal': 'Do not make a deal',
  'forms.task': 'Task',
  'forms.taskHint': 'Due the next working day at 9:00.',
  'forms.taskOwner': 'For the owner',
  'forms.taskPerson': 'For somebody else',
  'forms.taskNone': 'No task',
  'forms.taskWho': 'Task for',
  'forms.notify': 'Tell the owner',
  'forms.notifyHint': '"New enquiry" in the app and by e-mail, as each person has chosen.',
  'forms.tags': 'Tags',
  'forms.after': 'After sending',
  'forms.thankYou': 'Thank-you message',
  'forms.thankYouHint': 'Empty: "Thank you. We will be in touch soon."',
  'forms.redirect': 'Or open this page',
  'forms.redirectHint': 'An https:// address on your site, instead of the message.',
  'forms.privacy': 'Privacy',
  'forms.privacyText': 'Privacy notice',
  'forms.privacyTextHint': 'Shown above the consent box. The note on the contact keeps it with the date of consent.',
  'forms.privacyDefault': 'We use your details only to answer your enquiry and keep them for 2 years. You can ask us to delete them at any time.',
  'forms.checkDisposable': 'Refuse throwaway e-mail addresses',
  'forms.checkDisposableHint': 'Addresses from services that make a mailbox for a few minutes.',
  'forms.sites': 'Sites',
  'forms.origins': 'Sites the form may be sent from',
  'forms.originsHint': "One per line, such as https://www.example.com. The form's own page always may.",
  'forms.create': 'Create the form',
  'forms.delete': 'Delete the form',
  'forms.deleteTitle': 'Delete {name}?',
  'forms.deleteConfirm': 'Its log goes with it. The contacts, companies and deals it made stay.',
  'forms.deleted': '{name} deleted',
  'forms.onYourSite': 'On your site',
  'forms.snippet': 'Code for your site',
  'forms.snippetHint': "Paste it where the form should be. It takes your site's fonts and colours.",
  'forms.copySnippet': 'Copy the code',
  'forms.hosted': "The form's own page",
  'forms.hostedHint': 'For a link in a newsletter or a post, or a company without a site.',
  'forms.copyLink': 'Copy the link',
  'forms.server': 'From your own server',
  'forms.serverHint': 'Send the key in a header instead of the bot check. The key ends in {hint}.',
  'forms.key': 'key',
  'forms.newKey': 'New key',
  'forms.newKeyConfirm': 'The old key stops working at once.',
  'forms.keyTitle': "The form's key",
  'forms.keyOnce': 'Copy it now. It is shown only this once.',
  'forms.copyKey': 'Copy the key',
  'forms.copied': 'Copied',
  'forms.answers': 'Answers',
  'forms.recentAnswers': 'The last 100 answers',
  'forms.when': 'When',
  'forms.who': 'Who',
  'forms.refused': 'Refused',
  'forms.refusedHint': 'Kept for 30 days, without the answers.',
  'forms.refusal.required': 'A required field was empty',
  'forms.refusal.invalid': 'A field was not filled in correctly',
  'forms.refusal.consent': 'No consent',
  'forms.refusal.disposable': 'A throwaway e-mail address',
  'forms.refusal.botCheck': 'The bot check did not pass',
  'forms.refusal.origin': 'Sent from a site not on the list',
  'forms.refusal.key': 'A wrong key',
  'forms.refusal.paused': 'The form was paused',
  'forms.refusal.dailyLimit': 'Over 1,000 answers that day',
  'forms.refusal.honeypot': 'Dropped as a bot',
  'forms.refusal.other': 'Refused',
  'forms.viaServer': 'from a server',
  'formPage.gone': 'This form is not here any more.',
  'formPage.paused': 'This form is not taking answers just now.',
  'formPage.thankYou': 'Thank you. We will be in touch soon.',
  'formPage.privacy': 'Privacy',
  'formPage.consent': 'I agree to the privacy notice above',
  'formPage.send': 'Send',
  'formPage.choose': 'Choose',
  'formPage.poweredBy': 'Sent with DoCuLat',
  'meetingAnswer.gone': 'This link no longer works. A newer e-mail about the meeting replaced it, or you were taken off the meeting.',
  'meetingAnswer.cancelled': 'This meeting was cancelled.',
  'meetingAnswer.question': 'Will you come?',
  'meetingAnswer.accepted': 'Yes',
  'meetingAnswer.tentative': 'Maybe',
  'meetingAnswer.declined': 'No',
  'meetingAnswer.sentTo': 'Thank you. {name} sees your answer.',
  'meetingAnswer.sent': 'Thank you. Your answer was sent.',
  'meetingAnswer.yours': 'Your answer: {answer}',
  'meetingAnswer.for': 'Sent to {email}',
  'meetingAnswer.when': 'When',
  'meetingAnswer.where': 'Where',
  'meetingAnswer.organiser': 'Organiser',
  'meetingAnswer.you': 'You',
  'meetingAnswer.optional': 'Optional',
  'meetingAnswer.allDay': 'all day',
  'meetingAnswer.yourTime': 'your time',
  'crm.list.customDates': 'Custom dates…',
  'crm.list.periodButton': 'Period, {period}',
  'crm.legalForm': 'Legal form',
  'crm.register.fill': 'Fill from the Register of Enterprises',
  'crm.register.status.active': 'Active',
  'crm.register.status.liquidated': 'Liquidated',
  'crm.register.status.reorganised': 'Reorganised',
  'crm.register.status.closed': 'Closed',
  'crm.register.status.not-found': 'Not in the register',
  'crm.register.found': 'Active in the Register of Enterprises ({date}). Filled in: check before saving.',
  'crm.register.foundClosed': '{status} ({date}), says the Register of Enterprises. Filled in: check before saving.',
  'crm.register.notFound': 'Not in the Register of Enterprises ({date}).',
  'crm.register.unavailable': 'The Register of Enterprises is not available right now, try later.',
  'crm.register.confirmTitle': 'Save a company that is not active?',
  'crm.register.confirmText': 'The Register of Enterprises says: {status} ({date}). You can still save it, for example to keep its history.',
  'crm.register.confirmYes': 'Save anyway',
  'crm.register.refresh': 'Refresh from the register',
  'crm.register.diffTitle': 'Changes in the register',
  'crm.register.diffText': 'Tick what to take over from the Register of Enterprises.',
  'crm.register.diffApply': 'Apply',
  'crm.register.nothingDiffers': 'The account matches the register.',
  'crm.register.updated': 'Updated from the register.',
  'crm.register.checkedOn': 'Checked in the Register of Enterprises on {date}',
  // Deal lines settings (TF-321).
  'settings.dealLines': 'Deal lines',
  'dealLines.intro': 'What your salespeople pick on a deal\'s lines. A hidden entry leaves the pickers but stays on the lines that have it.',
  'dealLines.units': 'Units of measure',
  'dealLines.periods': 'Billing periods',
  'dealLines.vatRates': 'VAT rates',
  'dealLines.addUnit': 'Add unit',
  'dealLines.addPeriod': 'Add period',
  'dealLines.addVat': 'Add VAT rate',
  'dealLines.restore': 'Restore defaults',
  'dealLines.restoreTitle': 'Restore defaults: {list}',
  'dealLines.restoreConfirm': 'The standard entries come back, shown and with their standard names. Your own entries stay as they are.',
  'dealLines.restored': 'Defaults restored.',
  'dealLines.full': 'A list can have at most {count} entries.',
  'dealLines.default': 'Default',
  'dealLines.hidden': 'Hidden',
  'dealLines.edit': 'Edit {name}',
  'dealLines.makeDefault': 'Make {name} the default',
  'dealLines.defaultSet': 'New lines start with {name}.',
  'dealLines.hide': 'Hide {name}',
  'dealLines.show': 'Show {name}',
  'dealLines.defaultStays': 'The default rate stays shown. Make another rate the default first.',
  'dealLines.hiddenToast': 'Hidden: {name}',
  'dealLines.shownToast': 'Shown: {name}',
  'dealLines.noRepeat': 'Does not repeat',
  'dealLines.lengthWeeks': 'Weeks: {count}',
  'dealLines.lengthMonths': 'Months: {count}',
  'dealLines.name': 'Name',
  'dealLines.short': 'Short label',
  'dealLines.shortHint': 'Shown on a line, for example "pcs" or "kg".',
  'dealLines.standardHint': 'Leave it empty for the standard name in each person\'s language.',
  'dealLines.vatNamePlaceholder': 'For example: Reverse charge',
  'dealLines.repeats': 'Repeats',
  'dealLines.weeks': 'Every few weeks',
  'dealLines.months': 'Every few months',
  'dealLines.everyCount': 'How many',
  'dealLines.rate': 'VAT rate',
  'dealLines.isDefault': 'New lines start with this rate',
  'dealLines.nameMissing': 'Give it a name.',
  'dealLines.shortMissing': 'Give it a short label.',
  'dealLines.rateInvalid': 'Enter a rate from 0 to 100, with at most two decimals.',
  'dealLines.everyInvalid': 'Enter a whole number from 1 to 120.',
  'dealLines.unit.piece': 'Piece',
  'dealLines.unitShort.piece': 'pcs',
  'dealLines.unit.hour': 'Hour',
  'dealLines.unitShort.hour': 'h',
  'dealLines.unit.day': 'Day',
  'dealLines.unitShort.day': 'd',
  'dealLines.unit.month': 'Month',
  'dealLines.unitShort.month': 'mo',
  'dealLines.unit.user': 'User',
  'dealLines.unitShort.user': 'user',
  'dealLines.unit.licence': 'Licence',
  'dealLines.unitShort.licence': 'lic.',
  'dealLines.unit.project': 'Project',
  'dealLines.unitShort.project': 'proj.',
  'dealLines.unit.km': 'Kilometre',
  'dealLines.unitShort.km': 'km',
  'dealLines.unit.kg': 'Kilogram',
  'dealLines.unitShort.kg': 'kg',
  'dealLines.unit.litre': 'Litre',
  'dealLines.unitShort.litre': 'l',
  'dealLines.unit.m': 'Metre',
  'dealLines.unitShort.m': 'm',
  'dealLines.unit.m2': 'Square metre',
  'dealLines.unitShort.m2': 'm²',
  'dealLines.unit.set': 'Set',
  'dealLines.unitShort.set': 'set',
  'dealLines.period.once': 'One-off',
  'dealLines.period.week': 'Per week',
  'dealLines.period.month': 'Per month',
  'dealLines.period.quarter': 'Per quarter',
  'dealLines.period.year': 'Per year',
  // Products and services on a deal (TF-251).
  'dealLines.title': 'Products and services',
  'dealLines.addDiscount': 'Discount',
  'dealLines.exportCsv': 'Export lines (CSV)',
  'dealLines.qty': 'Qty',
  'dealLines.unit': 'Unit',
  'dealLines.unitPrice': 'Unit price',
  'dealLines.discount': 'Discount',
  'dealLines.vat': 'VAT',
  'dealLines.total': 'Total',
  'dealLines.withoutVat': 'Without VAT',
  'dealLines.vatAt': 'VAT {rate}',
  'dealLines.withVat': 'With VAT',
  'dealLines.product': 'Product',
  'dealLines.service': 'Service',
  'dealLines.kindToggle': '{kind}: {name}. Switch between product and service',
  'dealLines.nameOf': 'Name of {name}',
  'dealLines.qtyOf': 'Quantity of {name}',
  'dealLines.unitOf': 'Unit of {name}',
  'dealLines.priceOf': 'Unit price of {name}',
  'dealLines.discountOf': 'Discount on {name}',
  'dealLines.vatOf': 'VAT rate of {name}',
  'dealLines.moveLine': 'Move {name}',
  'dealLines.moveHint': 'Drag, or use the arrow keys',
  'dealLines.remove': 'Remove {name}',
  'dealLines.qtyInvalid': 'Enter a quantity, for example 1 or 2,5.',
  'dealLines.priceInvalid': 'Enter a price, for example 19,99.',
  'dealLines.newName': 'New line: name',
  'dealLines.newQty': 'New line: quantity',
  'dealLines.newPrice': 'New line: unit price',
  'dealLines.newPlaceholder': 'Add a product or service',
  'dealLines.addLine': 'Add the line',
  'dealLines.saveLine': 'Save line',
  'dealLines.suggestions': 'Earlier lines',
  'dealLines.amountFromLines': 'From the lines, without VAT',
  'dealLines.csv.deal': 'Deal',
  'dealLines.csv.name': 'Name',
  'dealLines.csv.type': 'Type',
  'dealLines.csv.quantity': 'Quantity',
  'dealLines.csv.unit': 'Unit',
  'dealLines.csv.unitPrice': 'Unit price',
  'dealLines.csv.discount': 'Discount %',
  'dealLines.csv.vatRate': 'VAT %',
  'dealLines.csv.withoutVat': 'Without VAT',
  'dealLines.csv.vat': 'VAT',
  'dealLines.csv.withVat': 'With VAT',
  'dealLines.csv.currency': 'Currency',
  // Recurring deal lines (TF-322).
  'dealLines.addBilling': 'Billing period',
  'dealLines.billing': 'Billing',
  'dealLines.periodOf': 'Billing period of {name}',
  'dealLines.periodsOf': 'Number of periods of {name}',
  'dealLines.periodsHint': 'Empty: until cancelled',
  'dealLines.everyWeeks': 'Every {count} weeks',
  'dealLines.everyMonths': 'Every {count} months',
  'dealLines.oneOffTotal': 'One-off',
  'dealLines.vatAndGross': 'without VAT · VAT {vat} · with VAT {gross}',
  'dealLines.contract': 'Contract value, without VAT',
  'dealLines.contractMonths': 'Contract value, without VAT (lines until cancelled as {count} months)',
  'dealLines.perMonthAmount': '{amount}/month',
  'dealLines.amountContract': 'Contract value of the lines, without VAT',
  'dealLines.amountContractMonths': 'Contract value of the lines, without VAT, {count} months',
  'dealLines.contractValue': 'Contract value',
  'dealLines.openEnded': 'Count a line until cancelled as',
  'dealLines.monthsSuffix': 'months',
  'dealLines.openEndedHint': 'The amount of a deal is its contract value: one-off lines once, a recurring line times its periods, and a line until cancelled for this many months. Open deals are counted again when you save.',
  'dealLines.openEndedSaved': 'Saved. Open deals counted again: {count}.',
  'dealLines.csv.period': 'Billing period',
  'dealLines.csv.periods': 'Periods',
  'crm.mrr': 'MRR',
  'crm.mrrLong': 'Monthly recurring revenue, without VAT',
  // The fields list and its dialog (TF-340).
  'settings.searchFields': 'Search fields',
  'settings.newField': 'New field',
  'settings.fieldsLimit': 'At most {count} fields.',
  'settings.noFieldMatches': 'No field matches.',
  'settings.clearSearch': 'Clear search',
  'settings.copyKey': 'Copy the key of {name}',
  'settings.keyCopied': 'Key copied.',
  'settings.choicesCount': 'Choices: {count}',
  'settings.badgeRequired': 'Required',
  'settings.badgeClassification': 'Classification',
  'settings.badgePersonal': 'Personal',
  'settings.badgePublicForm': 'On website forms',
  'settings.badgeOff': 'Off',
  'settings.editField': 'Edit {name}',
  'settings.orderSaved': 'Order saved.',
  'settings.deleteField': 'Delete field',
  'settings.deleteFieldTitle': 'Delete {name}?',
  'settings.deleteFieldConfirm': 'The values already entered are kept. They come back if you add a field with the same key.',
  'settings.fieldDeleted': '{name} deleted.',
  'settings.discardTitle': 'Discard changes?',
  'settings.discardMessage': 'What you changed in this field is not saved.',
  'settings.discard': 'Discard',
  // Teams (TF-296).
  'settings.teams': 'Teams',
  'members.teams': 'Teams',
  'members.teamsOf': 'Teams of {name}',
  'teams.title': 'Teams',
  'teams.intro': 'A team is a group of people in the company. Anybody here can create one and becomes its admin. Deals, contacts, tasks and documents get teams next.',
  'teams.new': 'New team',
  'teams.search': 'Search teams',
  'teams.none': 'No teams yet',
  'teams.noneHint': 'Create one for people who work together: sales, support, a project.',
  'teams.noneFound': 'No team matches.',
  'teams.people.one': '{count} person',
  'teams.people.other': '{count} people',
  'teams.limitReached.one': 'Your plan allows {count} team.',
  'teams.limitReached.other': 'Your plan allows {count} teams.',
  'teams.seePlans': 'See the plans',
  'teams.of': 'Teams of {name}',
  'teams.showAll': 'Show all teams',
  'teams.joining.open': 'Open',
  'teams.joining.invite': 'Invite only',
  'teams.joiningLabel': 'Who can join',
  'teams.joiningHint.open': 'Anybody in the company can join it.',
  'teams.joiningHint.invite': 'Only a team admin adds people.',
  'teams.name': 'Name',
  'teams.description': 'Description',
  'teams.create': 'Create team',
  'teams.created': 'Team “{name}” created',
  'teams.edit': 'Edit team',
  'teams.saved': 'Team saved',
  'teams.delete': 'Delete team',
  'teams.deleteConfirm': 'Delete the team “{name}”? Everybody in it loses their place in it.',
  'teams.deleted': 'Team “{name}” deleted',
  'teams.hasRecords': 'Records with only this team: {count}. Move them to another team first.',
  'teams.recordsUnknown': 'This team\'s records can\'t be counted right now. Try again in a minute.',
  'teams.moveTitle': 'Move records first',
  'teams.moveMessage': 'Records with only the team “{name}”: {count}. Choose a team to move all its records to. Then the team is deleted.',
  'teams.moveTo': 'Move to',
  'teams.moveToPick': 'Choose a team',
  'teams.moveAndDelete': 'Move and delete',
  'teams.movedAndDeleted': 'Records moved to “{name}”: {count}. Team “{team}” deleted.',
  'teams.join': 'Join',
  'teams.hiddenFromAdmins': 'Hidden from admins',
  'teams.hideFromAdmins': 'Hide from admins',
  'teams.hiddenHint': 'Only this team\'s people and the company\'s owners see its records. Admins see only its name and size.',
  'teams.hiddenNeedsAccess': 'It takes effect while access follows teams (Settings, Company).',
  'teamNotices.title': 'Team notices',
  'teamNotices.hint': 'What you hear about your teams\' deals, tasks and documents, by the channels chosen above. Until you choose, the team\'s default applies.',
  'teamNotices.company': 'Company',
  'mailLog.title': 'Mail logging',
  'mailLog.hint': 'Your own address for filing e-mails in this company. Put it in BCC when you write to a customer, or forward an e-mail to it: the e-mail is filed on the contacts, accounts and deals whose addresses it names.',
  'mailLog.company': 'Company',
  'mailLog.address': 'Your address',
  'mailLog.how': 'Only e-mails you send from your sign-in address are filed. Keep the address to yourself: anybody who has it can try.',
  'mailLog.renew': 'Renew the address',
  'mailLog.renewTitle': 'Renew your address?',
  'mailLog.renewConfirm': 'You get a new address. The old one stops filing e-mails at once.',
  'mailLog.renewed': 'Your address is renewed. Use the new one from now on.',
  'mailLog.ms.title': 'Microsoft 365 mailbox',
  'mailLog.ms.hint': 'Connect your Outlook or Microsoft 365 mailbox, read only. E-mails you send to or get from the company\'s contacts and accounts are then filed on them by themselves. Other e-mails are not stored.',
  'mailLog.ms.off': 'Mail logging from Microsoft 365 is switched off for this company. Its owners and admins can switch it on in Settings, Marketplace.',
  'mailLog.ms.start': 'Log e-mails from',
  'mailLog.ms.start0': 'Now on',
  'mailLog.ms.start30': 'The last 30 days',
  'mailLog.ms.start90': 'The last 90 days',
  'mailLog.ms.connect': 'Connect Microsoft 365 mailbox',
  'mailLog.ms.reconnect': 'Connect again',
  'mailLog.ms.broken': 'Microsoft no longer accepts this connection. Connect again to carry on.',
  'mailLog.ms.failed': 'The last reading did not work: {detail}. It is tried again by itself.',
  'mailLog.ms.lastRead': 'Read {when}. E-mails filed so far: {count}.',
  'mailLog.ms.notYet': 'Connected. The first reading starts in a moment.',
  'mailLog.ms.readNow': 'Read now',
  'mailLog.ms.readAsked': 'Your mailbox is read in a moment.',
  'mailLog.ms.disconnect': 'Disconnect',
  'mailLog.ms.disconnectTitle': 'Disconnect your mailbox?',
  'mailLog.ms.disconnectConfirm': 'No more e-mails are logged from it, and its access is deleted. What was logged stays on the records.',
  'mailLog.ms.disconnected': 'Your mailbox is disconnected.',
  'calSync.title': 'Calendar',
  'calSync.google': 'Google Calendar',
  'calSync.microsoft': 'Microsoft 365 calendar',
  'calSync.hint': 'Connect your own calendar. Your DoCuLat meetings are written to it, and its meetings with the company\'s contacts become meetings here. Anything else shows as busy in the DoCuLat calendar, without its title.',
  'calSync.connectGoogle': 'Connect Google Calendar',
  'calSync.connectMicrosoft': 'Connect Microsoft 365 calendar',
  'calSync.broken': 'The calendar refused the connection. Connect it again.',
  'calSync.failed': 'The last sync failed: {detail}',
  'calSync.lastSynced': 'Last synced {when}.',
  'calSync.notYet': 'Not synced yet. It starts within a minute.',
  'calSync.calendar': 'Write meetings to',
  'calSync.calendarHint': 'Another calendar starts again from there. Meetings already written stay where they are.',
  'calSync.main': '{name} (main)',
  'calSync.chosen': 'Meetings now go to that calendar.',
  'calSync.how': 'Changes on either side follow within a minute. If a meeting changed in both places, the later change is kept, and the Changes tab says so.',
  'calSync.syncNow': 'Sync now',
  'calSync.syncAsked': 'Syncing your calendar now.',
  'calSync.reconnect': 'Connect again',
  'calSync.disconnect': 'Disconnect',
  'calSync.disconnectTitle': 'Disconnect your calendar?',
  'calSync.disconnectConfirm': 'Nothing is synced any more, and its access is deleted. Meetings stay in both places as they are.',
  'calSync.disconnected': 'Your calendar is disconnected.',
  'mailLog.ms.mine': 'My addresses never to log',
  'mailLog.ms.company': 'Addresses never to log, for everybody in the company',
  'mailLog.ms.companyList': 'The company never logs e-mails with: {list}.',
  'mailLog.ms.listHint': 'One a line: an address, or a domain such as @example.com. An e-mail that names one is not logged.',
  'mailLog.ms.listSaved': 'The list is saved.',
  'mailLog.gm.title': 'Gmail',
  'mailLog.gm.hint': 'Connect your Gmail or Google Workspace mailbox, read only. E-mails you send to or get from the company\'s contacts and accounts are then filed on them by themselves. Other e-mails are not stored.',
  'mailLog.gm.off': 'Mail logging from Gmail is switched off for this company. Its owners and admins can switch it on in Settings, Marketplace.',
  'mailLog.gm.connect': 'Connect Gmail',
  'mailLog.gm.broken': 'Google no longer accepts this connection. Connect again to carry on.',
  'mailLog.gm.labels': 'Labels to log',
  'mailLog.gm.labelsHint': 'E-mails with one of these labels are logged, from now on. Drafts, spam and the bin never are.',
  'mailLog.gm.labelsSaved': 'The labels are saved.',
  'mailLog.gm.label.INBOX': 'Inbox',
  'mailLog.gm.label.SENT': 'Sent',
  'mailLog.gm.label.IMPORTANT': 'Important',
  'mailLog.gm.label.STARRED': 'Starred',
  'teamNotices.none': 'You are in no team in this company yet. Teams are on Settings, Teams.',
  'teamNotices.myDeals': 'My deals',
  'teamNotices.myDealsHint': 'The deals you own, also outside your teams.',
  'teamNotices.daily': 'One summary e-mail a day',
  'teamNotices.dailyHint': 'Instead of an e-mail for each. The bell still shows each at once.',
  'teamNotices.reset': 'Use the team\'s defaults',
  'teamNotices.area.deals': 'Deals',
  'teamNotices.area.tasks': 'Tasks',
  'teamNotices.area.documents': 'Documents',
  'teamNotices.area.team': 'Team',
  'teamNotices.kind.deal.created': 'A deal is created in the team or added to it',
  'teamNotices.kind.deal.stage': 'A deal changes stage, is won or is lost',
  'teamNotices.kind.deal.changed': 'A deal\'s amount or close date changes',
  'teamNotices.kind.deal.quiet': 'A deal has had no activity for {days} days',
  'teamNotices.kind.deal.quietPlain': 'A deal has had no activity for its team\'s number of days',
  'teamNotices.kind.deal.close_passed': 'An open deal\'s close date has passed',
  'teamNotices.kind.task.unassigned': 'A task is created without anybody assigned',
  'teamNotices.kind.task.overdue': 'A task becomes overdue',
  'teamNotices.kind.task.done': 'A task is done',
  'teamNotices.kind.document.added': 'A document is added',
  'teamNotices.kind.document.updated': 'A document is changed, at most once an hour',
  'teamNotices.kind.team.members': 'Somebody joins or leaves the team',
  'teamNotices.defaultsTitle': 'Notices',
  'teamNotices.defaultsHint': 'What the team\'s people hear about until they choose for themselves on their account page.',
  'teamNotices.quietDays': 'Days without activity before a deal is quiet',
  'teamNotices.quietDaysHint': 'No call, e-mail, meeting, note, task or stage change for this many days.',
  'teamNotices.quietDaysRange': 'Enter a whole number from 1 to 90.',
  'teams.hiddenConfirmTitle': 'Hide “{name}” from admins?',
  'teams.hiddenConfirm': 'Records in this team: {count}. Admins who are not in the team will no longer see them. People join the team only when invited.',
  'teams.hiddenOn': '“{name}” is hidden from admins.',
  'teams.hiddenOff': 'Admins see “{name}” again.',
  'teams.sharesOutside': 'Shared outside the company',
  'teams.outsideTitle': 'People from outside the company',
  'teams.outsideHint': 'Let a customer\'s or a partner\'s people work in this team. They see only this team\'s folders and, while access follows teams, its records.',
  'teams.outsideAllow': 'Allow people from outside the company',
  'teams.outsideWarning': 'This team will share its records and folders outside the company. It is marked “Shared outside the company” wherever its name appears.',
  'teams.outsideLimitsHint': 'Choose who may be let in: the contacts of customer accounts, e-mail domains, or both.',
  'teams.outsideAccounts': 'Contacts of these accounts',
  'teams.outsideAccountRemove': 'Remove {name}',
  'teams.outsideAccountGone': 'An account no longer in the CRM',
  'teams.outsideDomains': 'E-mail domains',
  'teams.outsideDomainsHint': 'Separated by commas, for example partner.lv',
  'teams.outsideMayChange': 'They may change the team\'s records',
  'teams.outsideMayChangeHint': 'Off: they only read. They never share, add people or run the team.',
  'teams.outsideAffectedTitle': 'People leave the team',
  'teams.outsideAffected': 'These people from outside the company no longer match and leave the team:',
  'teams.outsideAffectedConfirm': 'Save and remove them',
  'teams.outsidePeople': 'People from outside in this team',
  'teams.outsideCount': 'The company has {count} of {limit} people from outside, across its teams.',
  'teams.outsidePending': 'Invited',
  'teams.outsidePickContact': 'A contact of an allowed account',
  'teams.outsidePickContactPlaceholder': 'Choose a contact',
  'teams.outsideEmail': 'E-mail address',
  'teams.outsideLetIn': 'Let in',
  'teams.outsideInvited': '{email} is invited. They join the team when they accept.',
  'teams.outsideAdded': '{email} is in the team.',
  'teams.outsideFull': 'The plan allows {limit} people from outside the company, as many as its users.',
  'teams.outsidePlans': 'See the plans',
  'teams.hiddenInviteOnly': 'A team hidden from admins is joined by invitation only.',
  'teams.joined': 'You joined “{name}”',
  'teams.leave': 'Leave team',
  'teams.leaveConfirm': 'Leave the team “{name}”?',
  'teams.left': 'You left “{name}”',
  'teams.members': 'People',
  'teams.addPeople': 'Add people',
  'teams.addPeopleTo': 'Add people to “{name}”',
  'teams.findPerson': 'Find a person',
  'teams.addAs': 'Add as',
  'teams.add': 'Add',
  'teams.added': 'Added to “{name}”',
  'teams.noColleagues': 'Everybody in the company is in this team.',
  'teams.roleFor': 'Role in the team: {name}',
  'teams.roleChanged': 'Role of {name}: {role}',
  'teams.remove': 'Remove from the team',
  'teams.removeTitle': 'Remove from the team: {name}',
  'teams.removeConfirm': 'Remove {name} from “{team}”?',
  'teams.removed': 'Removed from the team: {name}',
  'teams.notFound': 'This team is gone, or you can’t see it.',
  'teams.rolesTitle': 'What each role can do',
  'teams.role.admin': 'Team admin',
  'teams.role.member': 'Member',
  'teams.role.reader': 'Read-only',
  'teams.role.guest': 'Guest',
  'teams.role.external': 'External',
  'teams.roleHint.admin': 'Everything a member can, plus the team’s name, settings and people.',
  'teams.roleHint.member': 'Works with everything of the team. Adds people when the team is open.',
  'teams.roleHint.reader': 'Sees everything of the team and changes nothing.',
  'teams.roleHint.guest': 'Like a member, but never shares the team’s documents and never adds people.',
  'teams.roleHint.external': 'Somebody from outside the company. Never shares or adds people, and only reads unless the team allows more.',
  'teams.nameTaken': 'The company already has a team of this name.',
  'teams.lastAdmin': 'A team needs at least one admin. Make somebody else its admin first.',
  'teams.roleNotAllowed': 'An external person can only be External in a team, and nobody else can.',
  // Teams: "All company" and default teams (TF-299).
  'teams.allCompany': 'All company',
  'teams.allCompanyHint': 'Everybody in the company is in it, except external people.',
  'teams.everybody': 'Everybody',
  'teams.allCompanyFixed': 'Everybody in the company is in “All company”. It can’t be changed, joined or left.',
  'teams.notInTeam': 'Choose a team this person is in.',
  'members.defaultTeam': 'Default team',
  'members.defaultTeamFor': 'Default team of {name}: {team}. Change',
  'members.defaultTeamTitle': 'Default team: {name}',
  'members.defaultTeamHint': 'New deals, contacts, tasks and documents this person creates get this team. Only teams the person is in can be chosen.',
  'members.defaultTeamSaved': 'Default team saved: {name}',
  // Signatures on the phone (TF-279).
  'mobile.signing.sendDetail': 'Choose who signs, in which order and how.',
  'mobile.signing.notConnected': 'E-signing is not connected for your company yet.',
  'mobile.signing.notConnectedAdmin': 'E-signing is not connected yet. Connect Dokobit in the web app, under Settings and Integrations.',
  'mobile.signing.fromContacts': 'Add from contacts',
  'mobile.signing.byEmail': 'Add by email',
  'mobile.signing.addMe': 'Add me',
  'mobile.signing.signerTitle': 'Signer',
  'mobile.signing.searchContacts': 'Search contacts by name',
  'mobile.signing.noEmail': 'No email address',
  'mobile.signing.moveUp': 'Move {name} up',
  'mobile.signing.moveDown': 'Move {name} down',
  'mobile.signing.ordered': 'One after another',
  'mobile.signing.orderedHint': 'In the order above. Each signer is asked once the one before has signed.',
  'mobile.signing.atOnce': 'Everybody is asked at once.',
  'mobile.signing.methods': 'How they may sign',
  'mobile.signing.methodsHint': 'None chosen: any way Dokobit offers.',
  'mobile.signing.method.smartid': 'Smart-ID',
  'mobile.signing.method.mobile_sk': 'Mobile-ID',
  'mobile.signing.method.eparaksts_mobile': 'eParaksts mobile',
  'mobile.signing.method.smartcard': 'ID card',
  'mobile.signing.noDeadline': 'No deadline',
  'mobile.signing.in14Days': 'In 14 days',
  'mobile.signing.problem.nameMissing': 'The first name is missing.',
  'mobile.signing.problem.surnameMissing': 'The last name is missing.',
  'mobile.signing.problem.emailMissing': 'The email address is missing.',
  'mobile.signing.problem.emailInvalid': 'This is not an email address.',
  'mobile.signing.problem.emailTwice': 'This person is on the list already.',
  'mobile.signing.problem.tooLong': 'The name is too long.',
  'mobile.signing.noSigners': 'Add at least one signer.',
  'mobile.signing.planLimit': 'Your plan’s signatures for this month are used.',
  'mobile.signing.notScanned': 'The file has not passed the virus check yet.',
  'mobile.signing.sendFailed': 'It was not sent. Check the connection and try again.',
  'mobile.signing.signMyself': 'Sign myself',
  'mobile.signing.signMyselfDetail': 'Opens Dokobit in the browser. Smart-ID and Mobile-ID open their own app, then come back.',
  'mobile.signing.myTurnLater': 'You sign once the signers before you have signed.',
  'mobile.signing.signer.waiting': 'waiting for the signer before',
  'mobile.signing.signer.closed': 'no longer asked',
  'mobile.signing.refused.emailNotVerified': 'Confirm your email address first. Until then, use the link in the email from Dokobit.',
  'mobile.signing.refused.notASigner': 'You are not one of the signers.',
  'mobile.signing.refused.notYourTurn': 'The signers before you have not signed yet.',
  'mobile.signing.refused.alreadySigned': 'You have signed it already.',
  'mobile.signing.refused.declined': 'You declined to sign it.',
  'mobile.signing.refused.notOpen': 'It is no longer out for signature.',
  'mobile.signing.refused.noSigningPage': 'Use the link in the email from Dokobit.',
  'mobile.signing.checking': 'Back from signing. It can take a minute until it shows here.',
  'mobile.signing.noDeal': 'No deal',
  // AI assistants (TF-315).
  'settings.assistants': 'AI assistants',
  'assistants.intro': 'Your people can ask Claude, ChatGPT, Copilot and other AI assistants about the CRM. An assistant signs in as the person, for one company, and sees only what they see here.',
  'assistants.notOnPlan': 'Your plan does not include AI assistants.',
  'assistants.seePlans': 'See plans',
  'assistants.switches': 'Switches',
  'assistants.enabled': 'Allow AI assistants',
  'assistants.enabledHint': 'Off: nobody can connect one, and every connection ends at once.',
  'assistants.write': 'Allow assistants to make changes',
  'assistants.writeHint': 'Off: assistants only read. With it on, each person still chooses Read or Write when they connect.',
  'assistants.connect': 'Connect an assistant',
  'assistants.address': 'Server address',
  'assistants.guideClaude': 'Claude',
  'assistants.guideClaudeText': 'In Claude, open Settings, Connectors and add a custom connector. Paste the address, then sign in to DoCuLat and choose the company.',
  'assistants.guideChatGpt': 'ChatGPT',
  'assistants.guideChatGptText': 'In ChatGPT, open Settings, Apps and connectors and create a connector. Paste the address, choose OAuth, then sign in to DoCuLat.',
  'assistants.guideVsCode': 'VS Code (Copilot)',
  'assistants.guideVsCodeText': 'In VS Code, run "MCP: Add Server", choose HTTP and paste the address. Copilot asks you to sign in to DoCuLat.',
  'assistants.usage': 'Usage',
  'assistants.usageToday': 'Today: {calls} of {limit} calls.',
  'assistants.usageMonth': 'This month: {calls} calls.',
  'assistants.connections': 'Connections',
  'assistants.none': 'No assistants connected.',
  'assistants.assistant': 'Assistant',
  'assistants.person': 'Person',
  'assistants.access': 'Access',
  'assistants.accessRead': 'Read',
  'assistants.accessWrite': 'Read and change',
  'assistants.connectedOn': 'Connected',
  'assistants.lastUsed': 'Last used',
  'assistants.lastUsedShort': 'last used {when}',
  'assistants.notUsed': 'Not yet',
  'assistants.revoke': 'Revoke',
  'assistants.revokeNamed': 'Revoke {assistant}',
  'assistants.revokeTitle': 'Revoke {assistant}?',
  'assistants.revokeConfirm': 'It stops reading {person}\'s data at once. They can connect it again later.',
  'assistants.revokeMine': 'It stops reading your data at once. You can connect it again later.',
  'assistants.revoked': '{assistant} revoked.',
  'assistants.offTitle': 'Switch off AI assistants?',
  'assistants.offConfirm': 'Every connection in the company ends at once. People can connect again when you switch assistants back on.',
  'assistants.switchOff': 'Switch off',
  'assistants.readOnlyTitle': 'Stop assistants making changes?',
  'assistants.readOnlyConfirm': 'Every assistant connected with Write reads only from now on.',
  'assistants.mine': 'Connected assistants',
  'assistants.companyOff': 'Your company has AI assistants switched off.',
  'marketplace.openAssistants': 'Open AI assistants',
  'audit.plain.assistantConnected': 'AI assistant connected',
  'audit.plain.assistantRevoked': 'AI assistant revoked',
  'audit.plain.assistantSettingsChanged': 'AI assistant switches changed',
  'notificationType.assistant.connected': 'Somebody connects an AI assistant to the company for the first time',
  // Changes through an AI assistant (TF-314).
  'crm.viaAssistant': 'via AI assistant ({name})',
  'crm.filedByRule': 'Filed {file} into {path} by the rule {rule}',
  'crm.openRule': 'Open the rule',
  'audit.viaAssistant': '{name} via AI assistant ({assistant})',
} as const;

export type MessageKey = keyof typeof en;
